
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ixWw7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cJj5V")).default; });

var $cJj5V = parcelRequire("cJj5V");

});
parcelRegister("cJj5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9cc98f36fb0b33$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $gPr7r = parcelRequire("gPr7r");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $2RWab = parcelRequire("2RWab");

var $a4JY7 = parcelRequire("a4JY7");

var $8PL6n = parcelRequire("8PL6n");

var $bwE7U = parcelRequire("bwE7U");

var $gxFZp = parcelRequire("gxFZp");

var $hDoR2 = parcelRequire("hDoR2");

var $kGZng = parcelRequire("kGZng");

var $lGc56 = parcelRequire("lGc56");

var $4Cacz = parcelRequire("4Cacz");

var $j6Axx = parcelRequire("j6Axx");

var $dJVgs = parcelRequire("dJVgs");

var $61A0C = parcelRequire("61A0C");

var $9g0oR = parcelRequire("9g0oR");

var $2ChcF = parcelRequire("2ChcF");

var $68wZ4 = parcelRequire("68wZ4");

var $g99nl = parcelRequire("g99nl");

var $gAJUc = parcelRequire("gAJUc");

var $2ceSC = parcelRequire("2ceSC");

var $gygyq = parcelRequire("gygyq");

var $52gYK = parcelRequire("52gYK");
const $1a9cc98f36fb0b33$export$6955bcca4cd3539f = (props)=>{
    var _component_slots;
    const { component: component, siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix } = props;
    const fullSiteSelectorProductKey = siteSelectorProductKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${siteSelectorProductKey}.ondemand`;
    const locale = (0, $2ceSC.useLocale)();
    const isBootIntercom = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp5381AddIntercomWidgetToUniform);
    const intercomAppId = locale === "ja" ? "p0ww63i2" : "";
    var _component_slots_content;
    const contentSlot = (_component_slots_content = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["content"]) !== null && _component_slots_content !== void 0 ? _component_slots_content : [];
    const pageHasGlobalNavComponent = !!contentSlot.find((content)=>content.type === "globalNav");
    const pageHasGlobalFooterComponent = !!contentSlot.find((content)=>content.type === "globalFooter");
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9O2F2.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gPr7r.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $52gYK.OptionalSiteSelectorContextProvider), {
                    siteSelectorProductKey: fullSiteSelectorProductKey,
                    siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                    children: [
                        !pageHasGlobalNavComponent && /*#__PURE__*/ (0, $loA2J.jsx)($1a9cc98f36fb0b33$var$PageNav, {
                            component: component
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                                id: "content",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                                    name: "content"
                                })
                            })
                        })
                    ]
                })
            }),
            !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};
// eslint-disable-next-line complexity
const $1a9cc98f36fb0b33$var$PageNav = ({ component: component })=>{
    const pageNavType = component.parameters && component.parameters["nav"] && component.parameters["nav"].value;
    let pageNav;
    switch(pageNavType){
        case "confluence":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $kGZng.default), {});
            break;
        case "bitbucket":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gxFZp.BitbucketNav), {});
            break;
        case "confluence-template-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.ConfluenceTemplateHeaderContainer), {});
            break;
        case "enterprise":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bwE7U.default), {});
            break;
        case "jira-software":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {});
            break;
        case "jira-service-management":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {});
            break;
        case "jira-product-discovery":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $j6Axx.default), {});
            break;
        case "gwp-7880-jira-software-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $61A0C.default), {});
            break;
        case "gwp-7880-jira-service-management-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $2ChcF.default), {});
            break;
        case "compass":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hDoR2.CompassNav), {});
            break;
        case "atlassian-access":
        case "guard":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Cacz.GuardNav), {});
            break;
        case "rovo":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $g99nl.RovoNav), {});
            break;
        case "rovo-dev":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gygyq.RovoDevNav), {});
            break;
        case "loom":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $68wZ4.LoomNav), {});
            break;
        case "teamwork-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $8PL6n.TeamworkCollectionNavbar), {});
            break;
        case "strategy-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $2RWab.StrategyCollectionNavbar), {});
            break;
        case "service-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $a4JY7.ServiceCollectionNavbar), {});
            break;
        case "none":
            break;
        case "global":
        default:
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                productKey: "uniform",
                isShowTryNowLink: true
            });
            break;
    }
    return pageNav;
};
var $1a9cc98f36fb0b33$export$2e2bcd8739ae039 = $1a9cc98f36fb0b33$export$6955bcca4cd3539f;

});
parcelRegister("gPr7r", function(module, exports) {

$parcel$export(module.exports, "useProductTemplateContext", function () { return $205f85a083271d56$export$9aa15cd8273c8730; });
$parcel$export(module.exports, "default", function () { return $205f85a083271d56$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $205f85a083271d56$var$ProductTemplateContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: ()=>{}
});
const $205f85a083271d56$export$d254455f6d2132ac = ({ children: children })=>{
    const [template, setTemplate] = (0, $iSvIT.useState)(null);
    const value = (0, $iSvIT.useMemo)(()=>({
            template: template,
            setTemplate: setTemplate
        }), [
        template
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($205f85a083271d56$var$ProductTemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $205f85a083271d56$export$9aa15cd8273c8730 = ()=>{
    const context = (0, $iSvIT.useContext)($205f85a083271d56$var$ProductTemplateContext);
    if (!context) throw new Error("useProductTemplateContext must be used within a ProductTemplateContextProvider");
    return context;
};
var $205f85a083271d56$export$2e2bcd8739ae039 = $205f85a083271d56$export$d254455f6d2132ac;

});

parcelRegister("aRHrH", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("9O2F2")).IntercomProvider; });
parcelRequire("9O2F2");
parcelRequire("42XIn");

});
parcelRegister("9O2F2", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $be094a112486886f$export$5091c5023e5c7eba; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4i0P = parcelRequire("l4i0P");

var $gkhN4 = parcelRequire("gkhN4");

var $7OS3I = parcelRequire("7OS3I");
const $be094a112486886f$var$isWindowExist = typeof window !== "undefined";
const $be094a112486886f$export$e578ca56db818a8e = /*#__PURE__*/ $iSvIT.createContext(undefined);
const $be094a112486886f$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $iSvIT.useRef(false);
    const isInit = $iSvIT.useRef(false);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const initIntercomInstance = $iSvIT.useCallback(()=>{
        if (!isInit.current) {
            (0, $7OS3I.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $iSvIT.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $iSvIT.useCallback(async ()=>{
        if ($be094a112486886f$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $7Knp0._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $iSvIT.useCallback(()=>{
        if (!isBooted.current) return;
        if ($be094a112486886f$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $iSvIT.useEffect(()=>{
        if ($be094a112486886f$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $l4i0P.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($be094a112486886f$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $iSvIT.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($be094a112486886f$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $be094a112486886f$export$28418e623d2470bc = ()=>{
    const context = $iSvIT.useContext($be094a112486886f$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("7OS3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f03bd135604494e$export$2e2bcd8739ae039; });
function $9f03bd135604494e$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $9f03bd135604494e$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($9f03bd135604494e$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $9f03bd135604494e$export$2e2bcd8739ae039 = $9f03bd135604494e$var$initializeIntercomInstance;

});


parcelRegister("42XIn", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("2RWab", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionNavbar", function () { return $d5a5b968eec327c1$export$8f1cb1d63697797a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");

var $b49hK = parcelRequire("b49hK");
const $d5a5b968eec327c1$export$8f1cb1d63697797a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $b49hK.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("4R0f2", function(module, exports) {

$parcel$export(module.exports, "CollectionsCompoundSubNavProps", function () { return $265ebf1ac0867280$export$7390cb3961621991; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $ispPN = parcelRequire("ispPN");

var $gAJUc = parcelRequire("gAJUc");

var $aOuDE = parcelRequire("aOuDE");
const $265ebf1ac0867280$export$7390cb3961621991 = ()=>{
    const intl = (0, $f6qj2.default)();
    const teamworkOverviewHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork");
    const teamworkFeaturesHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork/features");
    const teamworkPricingHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork/pricing");
    const strategyOverviewHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy");
    const strategyDemoCenterHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy/demo-center");
    const strategyPricingHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy/pricing");
    const serviceHref = (0, $3FBn4.useLocalizedHref)("/collections/service");
    const softwareHref = (0, $3FBn4.useLocalizedHref)("/collections/software");
    const isGwp7850 = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    const collectionsHref = (0, $3FBn4.useLocalizedHref)("/collections");
    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = (0, $aOuDE.useIsMobile)(1024);
    const hasSubnav = isGwp7850 && !isMobile;
    const props = {
        optionalClassName: isGwp7850 ? "collections-nav" : "",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "overview",
                linkText: intl.formatMessage({
                    id: "collectionsCompoundSubNav.Navlink.overview",
                    defaultMessage: "Overview"
                }),
                hasSubnav: false,
                href: collectionsHref
            },
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ispPN.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.features",
                                        defaultMessage: "Features"
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: teamworkPricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ispPN.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.demoCenter",
                                        defaultMessage: "Demo Center"
                                    }),
                                    href: strategyDemoCenterHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: strategyPricingHref
                                }
                            ]
                        }
                    ]
                })
            }
        ],
        isShowCta: isGwp7850 ? false : true,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    if (isGwp7850) {
        props.compoundSubNavLinksProps.push({
            globalLinksKey: "service",
            linkText: "Service",
            hasSubnav: false,
            href: serviceHref
        }, {
            globalLinksKey: "software",
            linkText: "Software",
            hasSubnav: false,
            href: softwareHref
        });
        props.compoundSubNavLinksProps.shift();
    }
    return props;
};

});
parcelRegister("ispPN", function(module, exports) {

$parcel$export(module.exports, "DropdownContent", function () { return $16fe9e86fc1396d8$export$59308621e1a05692; });

var $9g0oR = parcelRequire("9g0oR");
const $16fe9e86fc1396d8$export$59308621e1a05692 = (0, $9g0oR.DropdownContent);

});
parcelRegister("9g0oR", function(module, exports) {

$parcel$export(module.exports, "DropdownContent", function () { return $72f10e92f8563842$export$59308621e1a05692; });
$parcel$export(module.exports, "default", function () { return $72f10e92f8563842$export$2e2bcd8739ae039; });
/* software-jira-service-management-navbarv2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $8ltM2 = parcelRequire("8ltM2");

var $1TEMI = parcelRequire("1TEMI");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $jGfor = parcelRequire("jGfor");

var $gAJUc = parcelRequire("gAJUc");

var $dWbel = parcelRequire("dWbel");

var $hbBKK = parcelRequire("hbBKK");
const $72f10e92f8563842$var$JiraServiceManagementLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
};
const $72f10e92f8563842$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    var _links_find, _links_find1;
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $f6qj2.default)();
    const featuresHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/features");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/pricing");
    const itSupportHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/itsm-software");
    const itOperationsHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/it-operations");
    const enterpriseServiceManagementHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/features/enterprise-service-management");
    const customerServiceHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/customer-service-software");
    const hrHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/hr");
    const smallTeamsHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/help-desk-software-small-business-software");
    const premiumHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/premium");
    const enterpriseHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/enterprise");
    const technologyTelecomHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/technology-telecommunications");
    const financialServicesHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/financial-services");
    const retailHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/retail-ecommerce");
    const manufacturingHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/manufacturing");
    const itsmHref = (0, $3FBn4.useLocalizedHref)("/itsm");
    const productGuideHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/product-guide");
    const resourcesHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/resources");
    const solutionsDropdownStyles = (0, $iSvIT.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    const templatesUrl = (0, $3FBn4.useLocalizedHref)("/software/jira/templates/service-management");
    const { fireUIEvent: fireUIEvent } = (0, $1TEMI.useFireEvent)();
    const viewedUIEvent = (0, $iSvIT.useRef)(false);
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    (0, $iSvIT.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: "viewed",
                actionSubject: "jiraServiceManagementSoftwareNavV2"
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $iSvIT.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: featuresHref
            },
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: pricingHref
            },
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                dropdownType: "solutions",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $loA2J.jsx)($72f10e92f8563842$export$59308621e1a05692, {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.useCases.header",
                                defaultMessage: "By use case"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itSupport",
                                        defaultMessage: "IT Support"
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itOperations",
                                        defaultMessage: "IT Operations"
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.businessTeams",
                                        defaultMessage: "Business Teams"
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.customerService",
                                        defaultMessage: "Customer Service"
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.humanResources",
                                        defaultMessage: "Human Resources"
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.capability.header",
                                defaultMessage: "By capability"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.smallTeams",
                                        defaultMessage: "Small Teams"
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.premium",
                                        defaultMessage: "Premium"
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.industry.customerService",
                                defaultMessage: "By industry"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.technologyTelecom",
                                        defaultMessage: "Technology & Telecom"
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.financialServices",
                                        defaultMessage: "Financial Services"
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.retail",
                                        defaultMessage: "Retail"
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.manufacturing",
                                        defaultMessage: "Manufacturing"
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "resources",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.resources",
                    defaultMessage: "Resources"
                }),
                hasSubnav: true,
                dropdownType: "resources",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                content: /*#__PURE__*/ (0, $loA2J.jsx)($72f10e92f8563842$export$59308621e1a05692, {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.resources.type.header",
                                defaultMessage: "By type"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.itsm",
                                        defaultMessage: "ITSM"
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: gwp7518NavIconUpdates ? intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide-gwp-7518",
                                        defaultMessage: "Guide"
                                    }) : intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide",
                                        defaultMessage: "Product Guide"
                                    }),
                                    href: productGuideHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.additionalResources",
                                        defaultMessage: "Additional Resources"
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        productGuideHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $8ltM2.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $iFd5d.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $iFd5d.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $iSvIT.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $iSvIT.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($72f10e92f8563842$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($72f10e92f8563842$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management"),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira-service-management",
                    mobileLinksProps: links
                }
            ],
            mobileCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: (_links_find = links.find((link)=>link.globalLinksKey === "solutions")) === null || _links_find === void 0 ? void 0 : _links_find.content
                },
                {
                    menuPageKey: "resources",
                    menuPageObjects: (_links_find1 = links.find((link)=>link.globalLinksKey === "resources")) === null || _links_find1 === void 0 ? void 0 : _links_find1.content
                }
            ]
        })
    });
};
const $72f10e92f8563842$export$59308621e1a05692 = (props)=>{
    const { contentSections: contentSections } = props;
    const { orientation: orientation = "row" } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                orientation === "row" && "_ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _1e0c1txw _2lx21bp4 _1bsb1osq _zulpzwfg _oqic1ylp _1rmj1ylp _cjbt1ylp _pnmb1ylp _1inivrvc",
                orientation === "column" && "_ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp _1q51gktf _1e0c1txw _2lx21bp4 _1bsb1osq _zulp7vkz"
            ]),
            children: contentSections.map((section, idx)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($72f10e92f8563842$var$DropdownContentSection, (0, $7Knp0._)({}, section)),
                        orientation === "column" && idx < contentSections.length - 1 && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1bsb1osq _mqm2rq6f"
                            ]),
                            style: {
                                "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000"))
                            }
                        })
                    ]
                }, `${section.header}-${idx}`))
        })
    });
};
const $72f10e92f8563842$var$DropdownContentSection = ({ header: header, links: links })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
        children: [
            header && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v",
                    "nav-column-header"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _umai1ylp _1bsbntd2 _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfh7vkz"
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", (0, $6iHNw._)((0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({
                            href: link.href
                        }, link.dataEventProps), {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "global-Product-Nav-link-in-dropdown",
                            onClick: link.onClick
                        }), link.anchorProps), {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazqlpt _1wyboxwj _1wpzh9n0 _30l3jk2v"
                            ]),
                            style: {
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: link.text
                        }))
                    }, link.text))
            })
        ]
    });
};
const $72f10e92f8563842$var$dropdownGridStyle = null;
const $72f10e92f8563842$var$dropdownColumnStyles = null;
const $72f10e92f8563842$var$dropdownColumnDividerStyles = null;
const $72f10e92f8563842$var$headerStyle = null;
const $72f10e92f8563842$var$linkColumnStyle = null;
const $72f10e92f8563842$var$linkStyle = null;
var $72f10e92f8563842$export$2e2bcd8739ae039 = $72f10e92f8563842$var$JiraServiceManagementSoftwareNavV2;

});
parcelRegister("i8kxh", function(module, exports) {
$parcel$export(module.exports, "Editions", function () { return (parcelRequire("iFd5d")).Editions; });
$parcel$export(module.exports, "ProductKeys", function () { return (parcelRequire("iFd5d")).ProductKeys; });
parcelRequire("eYeUQ");
parcelRequire("iFd5d");
parcelRequire("8IHSJ");

});
parcelRegister("eYeUQ", function(module, exports) {
parcelRequire("6sxne");
var $3ig2D = parcelRequire("3ig2D");

var $dRxyd = parcelRequire("dRxyd");

var $5HAN6 = parcelRequire("5HAN6");

var $2bsWQ = parcelRequire("2bsWQ");

var $olBf4 = parcelRequire("olBf4");

var $iFd5d = parcelRequire("iFd5d");

var $4CzEV = parcelRequire("4CzEV");
parcelRequire("f2t2w");
var $7ucnk = parcelRequire("7ucnk");
var $cWrL0 = parcelRequire("cWrL0");
var $gtHju = parcelRequire("gtHju");
var $ae623d45811ecda0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $ae623d45811ecda0$export$d7d36d558022b438 = "https://wac.stg.internal.atlassian.com/gateway/api";
const $ae623d45811ecda0$export$c039d0ad0b34bf5 = "https://id.staging.atl-paas.net";
const $ae623d45811ecda0$var$openRequestCache = new Map();
class $ae623d45811ecda0$export$c66ca190f89caaac {
    /**
     * Deduplicate fetch requests made while there is an open request with the same cacheKey
     * @param cacheKey
     * @param input
     * @param init
     * @private
     */ dedupeFetch(cacheKey, input, init) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableRequestDeduplication) return (0, $2bsWQ.fetch)(input, init);
            // Check for an open request
            const cachedResult = $ae623d45811ecda0$var$openRequestCache.get(cacheKey);
            if (cachedResult) return cachedResult.then((res)=>res.clone());
            // Create a new request based on the input
            const request = (0, $2bsWQ.fetch)(input, init);
            $ae623d45811ecda0$var$openRequestCache.set(cacheKey, request);
            // Return the request and clear it from cache when it completes
            return request.finally(()=>{
                $ae623d45811ecda0$var$openRequestCache.delete(cacheKey);
            });
        });
    }
    /**
     * Get the xsrf token required to make calls to the signup server
     *
     * @see https://bxp-signup-server.staging.atl-paas.net/swagger/#/Authentication/get_auth_xsrf
     */ getSignupServerXsrfToken(webPlatform) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToText)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/auth/xsrf`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "accept": "text/plain",
                    "web-platform": webPlatform || "no-platform"
                }
            })));
        });
    }
    /**
     * Get the authentication methods available to a given user.
     *
     * @see https://bxp-signup-server.us-west-2.prod.atl-paas.net/swagger/#/Identity/post_authentication_methods_available
     */ checkAuthenticationMethodsAvailable({ email: email, application: application = "wac", successRedirect: successRedirect, webPlatform: webPlatform }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/authentication/methods-available`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "X-Atl-Cohort-Id": atlCohortId,
                    "web-platform": webPlatform || "no-platform"
                },
                credentials: "include",
                body: JSON.stringify({
                    email: email,
                    application: application,
                    continue: successRedirect
                })
            })));
        });
    }
    /**
     * Get whether a user has a permission for a particular resource.
     *
     * @see https://id-public-api-facade.prod.atl-paas.net/swagger.json
     */ getUserPermissionsIsPermitted({ permissionId: permissionId, resourceId: resourceId, dontRequirePrincipalInSite: dontRequirePrincipalInSite, webPlatform: webPlatform }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/permissions/permitted`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "web-platform": webPlatform || "no-platform"
                },
                body: JSON.stringify({
                    permissionId: permissionId,
                    resourceId: resourceId,
                    dontRequirePrincipalInSite: dontRequirePrincipalInSite
                })
            })));
        });
    }
    /**
     * Returns details about the current authenticated user.
     * This is expected to be consistent with Atlassian account.
     *
     * @see https://id-public-api-facade.prod.atl-paas.net/swagger.json
     */ getCurrentAuthenticatedUser() {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/me`, {
                credentials: "include"
            })));
        });
    }
    /**
     * Gets trial information for Atlassian products. Currently only supports
     *   JSW.
     *
     * @returns
     */ getProductHubInfo() {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/producthub/info`, {
                credentials: "include"
            })));
        });
    }
    postCloudSignUp({ payload: payload, webPlatform: webPlatform }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/cloud/signup`, {
                method: "POST",
                headers: {
                    "web-platform": webPlatform || "no-platform",
                    "Content-Type": "application/json",
                    "atl-cookies": JSON.stringify({
                        _ga: (0, (/*@__PURE__*/$parcel$interopDefault($olBf4))).get("_ga") || "",
                        seg_xid: localStorage.getItem("seg_xid") || "",
                        __atl_path: (0, (/*@__PURE__*/$parcel$interopDefault($olBf4))).get("__atl_path") || "",
                        ajs_anonymous_id: (0, (/*@__PURE__*/$parcel$interopDefault($olBf4))).get("ajs_anonymous_id") || ""
                    })
                },
                body: JSON.stringify(payload),
                credentials: "include"
            })));
        });
    }
    /**
     * Rename a Cloud
     * @see https://cofs.dev.public.atl-paas.net/api.html#external__cloudId__rename_put
     */ renameCloud({ cloudId: cloudId, cloudName: cloudName, webPlatform: webPlatform }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/cofs/${cloudId}/rename`, {
                method: "put",
                body: JSON.stringify({
                    cloudName: cloudName
                }),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "web-platform": webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    /**
     * @see https://cloud-name-availability.prod.atl-paas.net/swagger-ui/index.html#/name-availability-stargate-controller/checkAvailabilityUsingPOST
     */ checkCloudNameAvailability({ cloudName: cloudName, webPlatform: webPlatform }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/hostname/cloud/availability/check`, {
                method: "post",
                body: JSON.stringify({
                    cloudName: cloudName
                }),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "web-platform": webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    getUserCloudSites({ product: product, editions: editions, adminAccess: adminAccess, licenseLevels: licenseLevels, billingFrequency: billingFrequency }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/cloud/users/cloudsites`, {
                method: "post",
                body: JSON.stringify({
                    product: product,
                    editions: editions,
                    adminAccess: adminAccess,
                    licenseLevels: licenseLevels,
                    billingFrequency: billingFrequency
                }),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                credentials: "include"
            })));
        });
    }
    /**
     * Get the new ais/available-products
     */ availableProducts({ includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite, removeNonAdminSites: removeNonAdminSites }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const reqUrl = `${this.baseUrl}/ais/available-products`;
            const response = yield this.dedupeFetch(reqUrl, reqUrl, {
                method: "GET",
                credentials: "include"
            });
            if (response.ok) {
                const result = yield response.json();
                let sites = result && result.sites || [];
                if (removeNonAdminSites) sites = sites.filter((site)=>site.adminAccess);
                if (!includeInvalidSites) sites = sites.filter((site)=>(0, $cWrL0.isValidSite)({
                        site: site,
                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                    }));
                return Promise.resolve({
                    sites: sites,
                    isNewUser: !!(result && result.isNewUser)
                });
            } else throw new (0, $5HAN6.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    userSignup(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/identity/user-signup`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "X-Atl-Cohort-Id": atlCohortId,
                    "web-platform": request.webPlatform || "no-platform",
                    "recaptcha-site-key": (0, $gtHju.getReCaptchaKey)()
                },
                credentials: "include",
                body: JSON.stringify(Object.assign({}, request))
            })));
        });
    }
    activateProduct(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            const upstreamResponse = yield (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/activate-product`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "X-Atl-Cohort-Id": atlCohortId,
                    "web-platform": request.webPlatform || "no-platform",
                    "x-b3-sampled": "1",
                    "recaptcha-site-key": (0, $gtHju.getReCaptchaKey)()
                },
                credentials: "include",
                body: JSON.stringify(request)
            })));
            return upstreamResponse;
        });
    }
    getProductActivationStatus(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/activate/status/${request.provisioningRequestId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    getLicenceInformationStatus(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/cloud/${request.cloudId}/license-information`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    // for attaching a product to an existing site, xflow worked on the endpoint
    postProductActivate(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/product/activate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "web-platform": request.webPlatform || "no-platform",
                    "recaptcha-site-key": (0, $gtHju.getReCaptchaKey)()
                },
                credentials: "include",
                body: JSON.stringify(request)
            })));
        });
    }
    // for attaching a product to an existing site using COFS, xflow worked on the endpoint
    postCOFSProductActivate(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const { cloudId: cloudId } = request;
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/xflow/${cloudId}/activate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include",
                body: JSON.stringify(request)
            })));
        });
    }
    /**
     * Indentity calls
     */ me({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const url = `${this.baseUrl}/me`;
            const response = yield this.dedupeFetch(`${url}-${cloudSessionTokenCookie}`, url, {
                headers: (0, $5HAN6.mapCookieToHeaders)(cloudSessionTokenCookie),
                credentials: "include"
            });
            if (response.ok) return (0, $iFd5d.mapMeResponseToUserProfile)((yield response.json()));
            else throw new (0, $5HAN6.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    /**
     * Get a list of Bitbucket workspaces
     * @param nextUrl - override the request URL for pagination
     * bitbucket/user/permissions/workspaces?sort=workspace.slug
     */ bitbucketWorkspaces({ nextUrl: nextUrl, cloudSessionTokenCookie: cloudSessionTokenCookie, urlQuery: urlQuery }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            let reqUrl = `${this.baseUrl}/bitbucket/user/permissions/workspaces`;
            if (nextUrl) reqUrl = nextUrl;
            if (urlQuery) reqUrl = `${reqUrl}?${urlQuery}`;
            const response = yield (0, $2bsWQ.fetch)(reqUrl, {
                headers: (0, $5HAN6.mapCookieToHeaders)(cloudSessionTokenCookie),
                credentials: "include"
            });
            if (response.ok) return Promise.resolve((yield response.json()));
            else throw new (0, $5HAN6.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    /**
     * The legacy get availableProducts call from IdentityClient
     */ availableProductsLegacy({ cloudSessionTokenCookie: cloudSessionTokenCookie, includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const reqUrl = `${this.baseUrl}/available-products/api/available-products`;
            const response = yield (0, $2bsWQ.fetch)(reqUrl, {
                headers: (0, $5HAN6.mapCookieToHeaders)(cloudSessionTokenCookie),
                credentials: "include"
            });
            if (response.ok) {
                const result = yield response.json();
                let sites = result && result.sites || [];
                sites = (0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).remove((0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).map(sites, (site)=>{
                    const products = (0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).map(site.availableProducts, (product)=>{
                        return (0, $4CzEV.PRODUCT_KEY_MAP)[product.productType];
                    }).filter((product)=>product !== undefined);
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).isEmpty(products)) return {
                        adminAccess: site.adminAccess,
                        cloudId: site.cloudId,
                        displayName: site.displayName,
                        url: site.url,
                        products: products
                    };
                    else return null;
                }), (site)=>site !== undefined && site !== null);
                if (!includeInvalidSites) sites = sites.filter((site)=>(0, $cWrL0.isValidSite)({
                        site: site,
                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                    }));
                return Promise.resolve(sites);
            } else throw new (0, $5HAN6.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    patchUserProfile(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const { body: body, userId: userId, cloudSessionTokenCookie: cloudSessionTokenCookie } = request;
            const options = {
                headers: {
                    "content-type": "application/json",
                    "Cookie": (0, $5HAN6.serializeCookie)(cloudSessionTokenCookie)
                }
            };
            return new Promise((resolve, reject)=>{
                (0, $3ig2D.default).patch(`${this.baseUrl}/users/${userId}/manage/profile`, body, options).then((response)=>{
                    resolve(response.data);
                }).catch((err)=>{
                    reject(err.toString());
                });
            });
        });
    }
    getCcpHamsStatus(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const { cloudId: cloudId, offeringKeys: offeringKeys } = request;
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bag/rollout/service?cloudId=${cloudId}&offeringKeys=${offeringKeys}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include"
            })));
        });
    }
    getAvailableSites(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const { orderId: orderId, transactionAccount: transactionAccount } = request;
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/v1/order/${orderId}/available-sites`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Transaction-Account": transactionAccount,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    activateDirectBuyProduct(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/v1/order/${request.orderId}/activation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "X-Transaction-Account": request.transactionAccountId,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include",
                body: JSON.stringify({
                    timezone: request.timezone,
                    region: request.region,
                    site: request.site
                })
            })));
        });
    }
    getCloudProductInfo(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/v1/cloud/${request.cloudId}/product-information`, {
                headers: {
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    getProductEdition(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const { cloudId: cloudId, productKey: productKey } = request;
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/cloud/edition/${cloudId}/${productKey}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include"
            })));
        });
    }
    getConsentConfig() {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/preferencesV2/consent-config`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include"
            })));
        });
    }
    postConsentConfig() {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/preferencesV2/consent-config`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include"
            })));
        });
    }
    postExpandFreeValidation(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const { cloudId: cloudId, productKeys: productKeys } = request;
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/cloud/expand-free-validation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    cloudId: cloudId,
                    productKeys: productKeys
                })
            })));
        });
    }
    getActivationAuthorization(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const { productKeys: productKeys, productEdition: productEdition, cloudId: cloudId, siteName: siteName } = request;
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/activation-authorization?${new URLSearchParams({
                productKeys: productKeys.join(","),
                productEdition: productEdition,
                cloudId: cloudId !== null && cloudId !== void 0 ? cloudId : "",
                siteName: siteName
            })}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Atl-Cohort-Id": atlCohortId,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    getFeatureFlag(request, webPlatform) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const flag = request;
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/feature-flag/${flag}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "web-platform": webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    getFeatureFlagSync(request, webPlatform) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const flag = request;
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/feature-flag/sync/${flag}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Atl-Cohort-Id": atlCohortId,
                    "web-platform": webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    getRecommendedSiteName(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            const headers = (0, $5HAN6.mapCookieToHeaders)(request.cloudSessionTokenCookie);
            Object.assign(headers, {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "X-Atl-Cohort-Id": atlCohortId,
                "web-platform": request.webPlatform || "no-platform"
            });
            const response = yield (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/site/recommended-name`, {
                method: "POST",
                headers: headers,
                credentials: "include",
                body: JSON.stringify(request)
            })));
            return response;
        });
    }
    getAccountOrgs({ includeVortexMode: includeVortexMode, webPlatform: webPlatform }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const params = includeVortexMode === true ? `?includeVortexMode=true` : "";
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/account/orgs${params}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "web-platform": webPlatform || "no-platform"
                },
                credentials: "include"
            })));
        });
    }
    cofsCreateOrg(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/cofs-create-organization`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "X-Atl-Cohort-Id": atlCohortId,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include",
                body: JSON.stringify(request)
            })));
        });
    }
    cofsActivateProductExisting(request) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $7ucnk.getAtlCohortIdFromCookie)();
            const upstreamResponse = yield (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bxp/signup/cofs-activate-product-existing`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "xsrf-token": xsrfToken,
                    "X-Atl-Cohort-Id": atlCohortId,
                    "web-platform": request.webPlatform || "no-platform"
                },
                credentials: "include",
                body: JSON.stringify(request)
            })));
            return upstreamResponse;
        });
    }
    bitbucketValidateWorkspaceSlug({ workspaceSlug: workspaceSlug }) {
        return $ae623d45811ecda0$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $5HAN6.mapResponseToJson)((yield (0, $2bsWQ.fetch)(`${this.baseUrl}/bitbucket/api/internal/workspace/slug/validate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    workspace_slug: workspaceSlug
                })
            })));
        });
    }
    constructor({ baseUrl: baseUrl, disableRequestDeduplication: disableRequestDeduplication }){
        this.baseUrl = baseUrl;
        this.disableRequestDeduplication = disableRequestDeduplication;
    }
}

});
parcelRegister("6sxne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3ig2D")).default; });

var $3ig2D = parcelRequire("3ig2D");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $4b3f3ef2132edfa4$export$1c00760e9e5a4e95, AxiosError: $4b3f3ef2132edfa4$export$c1fbed17c2f6a328, CanceledError: $4b3f3ef2132edfa4$export$1ab0c6b20d94fa14, isCancel: $4b3f3ef2132edfa4$export$3b22524397b493c6, CancelToken: $4b3f3ef2132edfa4$export$fd08e3cb425f0d61, VERSION: $4b3f3ef2132edfa4$export$a4ad2735b021c132, all: $4b3f3ef2132edfa4$export$84bf76cd7afc7469, Cancel: $4b3f3ef2132edfa4$export$848c9b7ead0df967, isAxiosError: $4b3f3ef2132edfa4$export$fbafdbe06a5b5a9a, spread: $4b3f3ef2132edfa4$export$3ae0fd4797ed47c8, toFormData: $4b3f3ef2132edfa4$export$10ae0d317ea97f8b, AxiosHeaders: $4b3f3ef2132edfa4$export$4e7d6ff0f3e6520, HttpStatusCode: $4b3f3ef2132edfa4$export$a972f69c851492b3, formToJSON: $4b3f3ef2132edfa4$export$86d7c59254d6a2c9, getAdapter: $4b3f3ef2132edfa4$export$17ddc20a97d669e2, mergeConfig: $4b3f3ef2132edfa4$export$7ec1ebcfa9d8bd6a } = (0, $3ig2D.default);

});
parcelRegister("3ig2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $265f7f09b95ef7d3$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $6VoCJ = parcelRequire("6VoCJ");

var $jVk3l = parcelRequire("jVk3l");

var $hxjSH = parcelRequire("hxjSH");

var $gXjM7 = parcelRequire("gXjM7");

var $681Xw = parcelRequire("681Xw");

var $5tZpE = parcelRequire("5tZpE");

var $8ninC = parcelRequire("8ninC");

var $bNedC = parcelRequire("bNedC");

var $f14aV = parcelRequire("f14aV");

var $a2FSR = parcelRequire("a2FSR");

var $hEMVe = parcelRequire("hEMVe");

var $fHGZX = parcelRequire("fHGZX");

var $cJHbZ = parcelRequire("cJHbZ");

var $84HLP = parcelRequire("84HLP");

var $kClje = parcelRequire("kClje");

var $hgJB5 = parcelRequire("hgJB5");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $265f7f09b95ef7d3$var$createInstance(defaultConfig) {
    const context = new (0, $jVk3l.default)(defaultConfig);
    const instance = (0, $6VoCJ.default)((0, $jVk3l.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $eN72d.default).extend(instance, (0, $jVk3l.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $eN72d.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $265f7f09b95ef7d3$var$createInstance((0, $hxjSH.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $265f7f09b95ef7d3$var$axios = $265f7f09b95ef7d3$var$createInstance((0, $gXjM7.default));
// Expose Axios class to allow class inheritance
$265f7f09b95ef7d3$var$axios.Axios = (0, $jVk3l.default);
// Expose Cancel & CancelToken
$265f7f09b95ef7d3$var$axios.CanceledError = (0, $5tZpE.default);
$265f7f09b95ef7d3$var$axios.CancelToken = (0, $8ninC.default);
$265f7f09b95ef7d3$var$axios.isCancel = (0, $bNedC.default);
$265f7f09b95ef7d3$var$axios.VERSION = (0, $f14aV.VERSION);
$265f7f09b95ef7d3$var$axios.toFormData = (0, $a2FSR.default);
// Expose AxiosError class
$265f7f09b95ef7d3$var$axios.AxiosError = (0, $hEMVe.default);
// alias for CanceledError for backward compatibility
$265f7f09b95ef7d3$var$axios.Cancel = $265f7f09b95ef7d3$var$axios.CanceledError;
// Expose all/spread
$265f7f09b95ef7d3$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$265f7f09b95ef7d3$var$axios.spread = (0, $fHGZX.default);
// Expose isAxiosError
$265f7f09b95ef7d3$var$axios.isAxiosError = (0, $cJHbZ.default);
// Expose mergeConfig
$265f7f09b95ef7d3$var$axios.mergeConfig = (0, $hxjSH.default);
$265f7f09b95ef7d3$var$axios.AxiosHeaders = (0, $84HLP.default);
$265f7f09b95ef7d3$var$axios.formToJSON = (thing)=>(0, $681Xw.default)((0, $eN72d.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$265f7f09b95ef7d3$var$axios.getAdapter = (0, $kClje.default).getAdapter;
$265f7f09b95ef7d3$var$axios.HttpStatusCode = (0, $hgJB5.default);
$265f7f09b95ef7d3$var$axios.default = $265f7f09b95ef7d3$var$axios;
var // this module should only have a default export
$265f7f09b95ef7d3$export$2e2bcd8739ae039 = $265f7f09b95ef7d3$var$axios;

});
parcelRegister("eN72d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac4b19386d864794$export$2e2bcd8739ae039; });

var $6VoCJ = parcelRequire("6VoCJ");

var $XAEGR = parcelRequire("XAEGR");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $ac4b19386d864794$var$toString } = Object.prototype;
const { getPrototypeOf: $ac4b19386d864794$var$getPrototypeOf } = Object;
const { iterator: $ac4b19386d864794$var$iterator, toStringTag: $ac4b19386d864794$var$toStringTag } = Symbol;
const $ac4b19386d864794$var$kindOf = ((cache)=>(thing)=>{
        const str = $ac4b19386d864794$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $ac4b19386d864794$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$ac4b19386d864794$var$kindOf(thing) === type;
};
const $ac4b19386d864794$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $ac4b19386d864794$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $ac4b19386d864794$var$isUndefined = $ac4b19386d864794$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $ac4b19386d864794$var$isBuffer(val) {
    return val !== null && !$ac4b19386d864794$var$isUndefined(val) && val.constructor !== null && !$ac4b19386d864794$var$isUndefined(val.constructor) && $ac4b19386d864794$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $ac4b19386d864794$var$isArrayBuffer = $ac4b19386d864794$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $ac4b19386d864794$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $ac4b19386d864794$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $ac4b19386d864794$var$isString = $ac4b19386d864794$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $ac4b19386d864794$var$isFunction = $ac4b19386d864794$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $ac4b19386d864794$var$isNumber = $ac4b19386d864794$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $ac4b19386d864794$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $ac4b19386d864794$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $ac4b19386d864794$var$isPlainObject = (val)=>{
    if ($ac4b19386d864794$var$kindOf(val) !== "object") return false;
    const prototype = $ac4b19386d864794$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($ac4b19386d864794$var$toStringTag in val) && !($ac4b19386d864794$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $ac4b19386d864794$var$isDate = $ac4b19386d864794$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $ac4b19386d864794$var$isFile = $ac4b19386d864794$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $ac4b19386d864794$var$isBlob = $ac4b19386d864794$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $ac4b19386d864794$var$isFileList = $ac4b19386d864794$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $ac4b19386d864794$var$isStream = (val)=>$ac4b19386d864794$var$isObject(val) && $ac4b19386d864794$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $ac4b19386d864794$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $ac4b19386d864794$var$isFunction(thing.append) && ((kind = $ac4b19386d864794$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $ac4b19386d864794$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $ac4b19386d864794$var$isURLSearchParams = $ac4b19386d864794$var$kindOfTest("URLSearchParams");
const [$ac4b19386d864794$var$isReadableStream, $ac4b19386d864794$var$isRequest, $ac4b19386d864794$var$isResponse, $ac4b19386d864794$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($ac4b19386d864794$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $ac4b19386d864794$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $ac4b19386d864794$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($ac4b19386d864794$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $ac4b19386d864794$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $ac4b19386d864794$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $ac4b19386d864794$var$isContextDefined = (context)=>!$ac4b19386d864794$var$isUndefined(context) && context !== $ac4b19386d864794$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $ac4b19386d864794$var$merge() {
    const { caseless: caseless } = $ac4b19386d864794$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $ac4b19386d864794$var$findKey(result, key) || key;
        if ($ac4b19386d864794$var$isPlainObject(result[targetKey]) && $ac4b19386d864794$var$isPlainObject(val)) result[targetKey] = $ac4b19386d864794$var$merge(result[targetKey], val);
        else if ($ac4b19386d864794$var$isPlainObject(val)) result[targetKey] = $ac4b19386d864794$var$merge({}, val);
        else if ($ac4b19386d864794$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $ac4b19386d864794$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $ac4b19386d864794$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $ac4b19386d864794$var$forEach(b, (val, key)=>{
        if (thisArg && $ac4b19386d864794$var$isFunction(val)) a[key] = (0, $6VoCJ.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $ac4b19386d864794$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $ac4b19386d864794$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $ac4b19386d864794$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $ac4b19386d864794$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $ac4b19386d864794$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $ac4b19386d864794$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($ac4b19386d864794$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$ac4b19386d864794$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $ac4b19386d864794$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $ac4b19386d864794$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $ac4b19386d864794$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$ac4b19386d864794$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $ac4b19386d864794$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $ac4b19386d864794$var$isHTMLForm = $ac4b19386d864794$var$kindOfTest("HTMLFormElement");
const $ac4b19386d864794$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $ac4b19386d864794$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $ac4b19386d864794$var$isRegExp = $ac4b19386d864794$var$kindOfTest("RegExp");
const $ac4b19386d864794$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $ac4b19386d864794$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $ac4b19386d864794$var$freezeMethods = (obj)=>{
    $ac4b19386d864794$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($ac4b19386d864794$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$ac4b19386d864794$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $ac4b19386d864794$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $ac4b19386d864794$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $ac4b19386d864794$var$noop = ()=>{};
const $ac4b19386d864794$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $ac4b19386d864794$var$isSpecCompliantForm(thing) {
    return !!(thing && $ac4b19386d864794$var$isFunction(thing.append) && thing[$ac4b19386d864794$var$toStringTag] === "FormData" && thing[$ac4b19386d864794$var$iterator]);
}
const $ac4b19386d864794$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($ac4b19386d864794$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $ac4b19386d864794$var$isArray(source) ? [] : {};
                $ac4b19386d864794$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$ac4b19386d864794$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $ac4b19386d864794$var$isAsyncFn = $ac4b19386d864794$var$kindOfTest("AsyncFunction");
const $ac4b19386d864794$var$isThenable = (thing)=>thing && ($ac4b19386d864794$var$isObject(thing) || $ac4b19386d864794$var$isFunction(thing)) && $ac4b19386d864794$var$isFunction(thing.then) && $ac4b19386d864794$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $ac4b19386d864794$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $ac4b19386d864794$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $ac4b19386d864794$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $ac4b19386d864794$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $ac4b19386d864794$var$isFunction($ac4b19386d864794$var$_global.postMessage));
const $ac4b19386d864794$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($ac4b19386d864794$var$_global) : typeof $XAEGR !== "undefined" && $XAEGR.nextTick || $ac4b19386d864794$var$_setImmediate;
// *********************
const $ac4b19386d864794$var$isIterable = (thing)=>thing != null && $ac4b19386d864794$var$isFunction(thing[$ac4b19386d864794$var$iterator]);
var $ac4b19386d864794$export$2e2bcd8739ae039 = {
    isArray: $ac4b19386d864794$var$isArray,
    isArrayBuffer: $ac4b19386d864794$var$isArrayBuffer,
    isBuffer: $ac4b19386d864794$var$isBuffer,
    isFormData: $ac4b19386d864794$var$isFormData,
    isArrayBufferView: $ac4b19386d864794$var$isArrayBufferView,
    isString: $ac4b19386d864794$var$isString,
    isNumber: $ac4b19386d864794$var$isNumber,
    isBoolean: $ac4b19386d864794$var$isBoolean,
    isObject: $ac4b19386d864794$var$isObject,
    isPlainObject: $ac4b19386d864794$var$isPlainObject,
    isReadableStream: $ac4b19386d864794$var$isReadableStream,
    isRequest: $ac4b19386d864794$var$isRequest,
    isResponse: $ac4b19386d864794$var$isResponse,
    isHeaders: $ac4b19386d864794$var$isHeaders,
    isUndefined: $ac4b19386d864794$var$isUndefined,
    isDate: $ac4b19386d864794$var$isDate,
    isFile: $ac4b19386d864794$var$isFile,
    isBlob: $ac4b19386d864794$var$isBlob,
    isRegExp: $ac4b19386d864794$var$isRegExp,
    isFunction: $ac4b19386d864794$var$isFunction,
    isStream: $ac4b19386d864794$var$isStream,
    isURLSearchParams: $ac4b19386d864794$var$isURLSearchParams,
    isTypedArray: $ac4b19386d864794$var$isTypedArray,
    isFileList: $ac4b19386d864794$var$isFileList,
    forEach: $ac4b19386d864794$var$forEach,
    merge: $ac4b19386d864794$var$merge,
    extend: $ac4b19386d864794$var$extend,
    trim: $ac4b19386d864794$var$trim,
    stripBOM: $ac4b19386d864794$var$stripBOM,
    inherits: $ac4b19386d864794$var$inherits,
    toFlatObject: $ac4b19386d864794$var$toFlatObject,
    kindOf: $ac4b19386d864794$var$kindOf,
    kindOfTest: $ac4b19386d864794$var$kindOfTest,
    endsWith: $ac4b19386d864794$var$endsWith,
    toArray: $ac4b19386d864794$var$toArray,
    forEachEntry: $ac4b19386d864794$var$forEachEntry,
    matchAll: $ac4b19386d864794$var$matchAll,
    isHTMLForm: $ac4b19386d864794$var$isHTMLForm,
    hasOwnProperty: $ac4b19386d864794$var$hasOwnProperty,
    hasOwnProp: $ac4b19386d864794$var$hasOwnProperty,
    reduceDescriptors: $ac4b19386d864794$var$reduceDescriptors,
    freezeMethods: $ac4b19386d864794$var$freezeMethods,
    toObjectSet: $ac4b19386d864794$var$toObjectSet,
    toCamelCase: $ac4b19386d864794$var$toCamelCase,
    noop: $ac4b19386d864794$var$noop,
    toFiniteNumber: $ac4b19386d864794$var$toFiniteNumber,
    findKey: $ac4b19386d864794$var$findKey,
    global: $ac4b19386d864794$var$_global,
    isContextDefined: $ac4b19386d864794$var$isContextDefined,
    isSpecCompliantForm: $ac4b19386d864794$var$isSpecCompliantForm,
    toJSONObject: $ac4b19386d864794$var$toJSONObject,
    isAsyncFn: $ac4b19386d864794$var$isAsyncFn,
    isThenable: $ac4b19386d864794$var$isThenable,
    setImmediate: $ac4b19386d864794$var$_setImmediate,
    asap: $ac4b19386d864794$var$asap,
    isIterable: $ac4b19386d864794$var$isIterable
};

});
parcelRegister("6VoCJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50ab2ab1fff92f00$export$2e2bcd8739ae039; });
"use strict";
function $50ab2ab1fff92f00$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("jVk3l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e812e547b1169788$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $bLbXt = parcelRequire("bLbXt");

var $48vAc = parcelRequire("48vAc");

var $fS0Ne = parcelRequire("fS0Ne");

var $hxjSH = parcelRequire("hxjSH");

var $fIyiW = parcelRequire("fIyiW");

var $324iN = parcelRequire("324iN");

var $84HLP = parcelRequire("84HLP");
"use strict";
const $e812e547b1169788$var$validators = (0, $324iN.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $e812e547b1169788$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $hxjSH.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $324iN.default).assertOptions(transitional, {
            silentJSONParsing: $e812e547b1169788$var$validators.transitional($e812e547b1169788$var$validators.boolean),
            forcedJSONParsing: $e812e547b1169788$var$validators.transitional($e812e547b1169788$var$validators.boolean),
            clarifyTimeoutError: $e812e547b1169788$var$validators.transitional($e812e547b1169788$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $eN72d.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $324iN.default).assertOptions(paramsSerializer, {
                encode: $e812e547b1169788$var$validators.function,
                serialize: $e812e547b1169788$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $324iN.default).assertOptions(config, {
            baseUrl: $e812e547b1169788$var$validators.spelling("baseURL"),
            withXsrfToken: $e812e547b1169788$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $eN72d.default).merge(headers.common, headers[config.method]);
        headers && (0, $eN72d.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $84HLP.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $fS0Ne.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $fS0Ne.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $hxjSH.default)(this.defaults, config);
        const fullPath = (0, $fIyiW.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $bLbXt.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $48vAc.default)(),
            response: new (0, $48vAc.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $eN72d.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $e812e547b1169788$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $hxjSH.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $eN72d.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $hxjSH.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $e812e547b1169788$var$Axios.prototype[method] = generateHTTPMethod();
    $e812e547b1169788$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $e812e547b1169788$export$2e2bcd8739ae039 = $e812e547b1169788$var$Axios;

});
parcelRegister("bLbXt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88fd5c216e007953$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $kAPYa = parcelRequire("kAPYa");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $88fd5c216e007953$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $88fd5c216e007953$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $88fd5c216e007953$var$encode;
    if ((0, $eN72d.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $eN72d.default).isURLSearchParams(params) ? params.toString() : new (0, $kAPYa.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("kAPYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efdf7b7da01526d1$export$2e2bcd8739ae039; });

var $a2FSR = parcelRequire("a2FSR");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $efdf7b7da01526d1$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $efdf7b7da01526d1$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $a2FSR.default)(params, this, options);
}
const $efdf7b7da01526d1$var$prototype = $efdf7b7da01526d1$var$AxiosURLSearchParams.prototype;
$efdf7b7da01526d1$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$efdf7b7da01526d1$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $efdf7b7da01526d1$var$encode);
    } : $efdf7b7da01526d1$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $efdf7b7da01526d1$export$2e2bcd8739ae039 = $efdf7b7da01526d1$var$AxiosURLSearchParams;

});
parcelRegister("a2FSR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74fa9492bb11a0ab$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $hEMVe = parcelRequire("hEMVe");

var $fOmje = parcelRequire("fOmje");

var $jjovn = parcelRequire("jjovn");
var $74fa9492bb11a0ab$require$Buffer = $jjovn.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $74fa9492bb11a0ab$var$isVisitable(thing) {
    return (0, $eN72d.default).isPlainObject(thing) || (0, $eN72d.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $74fa9492bb11a0ab$var$removeBrackets(key) {
    return (0, $eN72d.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $74fa9492bb11a0ab$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $74fa9492bb11a0ab$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $74fa9492bb11a0ab$var$isFlatArray(arr) {
    return (0, $eN72d.default).isArray(arr) && !arr.some($74fa9492bb11a0ab$var$isVisitable);
}
const $74fa9492bb11a0ab$var$predicates = (0, $eN72d.default).toFlatObject((0, $eN72d.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $74fa9492bb11a0ab$var$toFormData(obj, formData, options) {
    if (!(0, $eN72d.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $fOmje.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $eN72d.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $eN72d.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $eN72d.default).isSpecCompliantForm(formData);
    if (!(0, $eN72d.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $eN72d.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $eN72d.default).isBlob(value)) throw new (0, $hEMVe.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $eN72d.default).isArrayBuffer(value) || (0, $eN72d.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $74fa9492bb11a0ab$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $eN72d.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $eN72d.default).isArray(value) && $74fa9492bb11a0ab$var$isFlatArray(value) || ((0, $eN72d.default).isFileList(value) || (0, $eN72d.default).endsWith(key, "[]")) && (arr = (0, $eN72d.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $74fa9492bb11a0ab$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $eN72d.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $74fa9492bb11a0ab$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($74fa9492bb11a0ab$var$isVisitable(value)) return true;
        formData.append($74fa9492bb11a0ab$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($74fa9492bb11a0ab$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $74fa9492bb11a0ab$var$isVisitable
    });
    function build(value, path) {
        if ((0, $eN72d.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $eN72d.default).forEach(value, function each(el, key) {
            const result = !((0, $eN72d.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $eN72d.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $eN72d.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $74fa9492bb11a0ab$export$2e2bcd8739ae039 = $74fa9492bb11a0ab$var$toFormData;

});
parcelRegister("hEMVe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdac1f01abe63539$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $cdac1f01abe63539$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $eN72d.default).inherits($cdac1f01abe63539$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $eN72d.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $cdac1f01abe63539$var$prototype = $cdac1f01abe63539$var$AxiosError.prototype;
const $cdac1f01abe63539$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $cdac1f01abe63539$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($cdac1f01abe63539$var$AxiosError, $cdac1f01abe63539$var$descriptors);
Object.defineProperty($cdac1f01abe63539$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$cdac1f01abe63539$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($cdac1f01abe63539$var$prototype);
    (0, $eN72d.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $cdac1f01abe63539$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $cdac1f01abe63539$export$2e2bcd8739ae039 = $cdac1f01abe63539$var$AxiosError;

});

parcelRegister("fOmje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b82cd4a847f94a09$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $b82cd4a847f94a09$export$2e2bcd8739ae039 = null;

});




parcelRegister("48vAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3030687ff4ea2a07$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");
"use strict";
class $3030687ff4ea2a07$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $eN72d.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $3030687ff4ea2a07$export$2e2bcd8739ae039 = $3030687ff4ea2a07$var$InterceptorManager;

});

parcelRegister("fS0Ne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8dc83a3e7bb5235$export$2e2bcd8739ae039; });

var $i7czI = parcelRequire("i7czI");

var $bNedC = parcelRequire("bNedC");

var $gXjM7 = parcelRequire("gXjM7");

var $5tZpE = parcelRequire("5tZpE");

var $84HLP = parcelRequire("84HLP");

var $kClje = parcelRequire("kClje");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $b8dc83a3e7bb5235$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $5tZpE.default)(null, config);
}
function $b8dc83a3e7bb5235$export$2e2bcd8739ae039(config) {
    $b8dc83a3e7bb5235$var$throwIfCancellationRequested(config);
    config.headers = (0, $84HLP.default).from(config.headers);
    // Transform request data
    config.data = (0, $i7czI.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $kClje.default).getAdapter(config.adapter || (0, $gXjM7.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $b8dc83a3e7bb5235$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $i7czI.default).call(config, config.transformResponse, response);
        response.headers = (0, $84HLP.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $bNedC.default)(reason)) {
            $b8dc83a3e7bb5235$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $i7czI.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $84HLP.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("i7czI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d302a297e3123b72$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $gXjM7 = parcelRequire("gXjM7");

var $84HLP = parcelRequire("84HLP");
"use strict";
function $d302a297e3123b72$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $gXjM7.default);
    const context = response || config;
    const headers = (0, $84HLP.default).from(context.headers);
    let data = context.data;
    (0, $eN72d.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("gXjM7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5817ef3f572de30$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $hEMVe = parcelRequire("hEMVe");

var $As6vu = parcelRequire("As6vu");

var $a2FSR = parcelRequire("a2FSR");

var $1vCNX = parcelRequire("1vCNX");

var $dWImh = parcelRequire("dWImh");

var $681Xw = parcelRequire("681Xw");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $c5817ef3f572de30$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $eN72d.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $eN72d.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $c5817ef3f572de30$var$defaults = {
    transitional: (0, $As6vu.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $eN72d.default).isObject(data);
            if (isObjectPayload && (0, $eN72d.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $eN72d.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $681Xw.default)(data)) : data;
            if ((0, $eN72d.default).isArrayBuffer(data) || (0, $eN72d.default).isBuffer(data) || (0, $eN72d.default).isStream(data) || (0, $eN72d.default).isFile(data) || (0, $eN72d.default).isBlob(data) || (0, $eN72d.default).isReadableStream(data)) return data;
            if ((0, $eN72d.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $eN72d.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $1vCNX.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $eN72d.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $a2FSR.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $c5817ef3f572de30$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $c5817ef3f572de30$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $eN72d.default).isResponse(data) || (0, $eN72d.default).isReadableStream(data)) return data;
            if (data && (0, $eN72d.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $hEMVe.default).from(e, (0, $hEMVe.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $dWImh.default).classes.FormData,
        Blob: (0, $dWImh.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $eN72d.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $c5817ef3f572de30$var$defaults.headers[method] = {};
});
var $c5817ef3f572de30$export$2e2bcd8739ae039 = $c5817ef3f572de30$var$defaults;

});
parcelRegister("As6vu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06d929c45badb8fa$export$2e2bcd8739ae039; });
"use strict";
var $06d929c45badb8fa$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("1vCNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1196c97e9ca3d325$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $a2FSR = parcelRequire("a2FSR");

var $dWImh = parcelRequire("dWImh");
"use strict";
function $1196c97e9ca3d325$export$2e2bcd8739ae039(data, options) {
    return (0, $a2FSR.default)(data, new (0, $dWImh.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $dWImh.default).isNode && (0, $eN72d.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("dWImh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a27319c8fbe6a34d$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $5Swa0 = parcelRequire("5Swa0");

var $5KGgI = parcelRequire("5KGgI");
var $a27319c8fbe6a34d$export$2e2bcd8739ae039 = (0, $7Knp0._)({}, $5KGgI, (0, $5Swa0.default));

});
parcelRegister("5Swa0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $447af1428afeb5d9$export$2e2bcd8739ae039; });

var $dG4oU = parcelRequire("dG4oU");

var $5vToq = parcelRequire("5vToq");

var $cv6Un = parcelRequire("cv6Un");
var $447af1428afeb5d9$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $dG4oU.default,
        FormData: $5vToq.default,
        Blob: $cv6Un.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("dG4oU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f529c7c61aea88e$export$2e2bcd8739ae039; });

var $kAPYa = parcelRequire("kAPYa");
"use strict";
var $9f529c7c61aea88e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $kAPYa.default);

});

parcelRegister("5vToq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $403ad0e08b12dea3$export$2e2bcd8739ae039; });
"use strict";
var $403ad0e08b12dea3$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("cv6Un", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $919dbd1cf9bb7281$export$2e2bcd8739ae039; });
"use strict";
var $919dbd1cf9bb7281$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("5KGgI", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $4302094533ac0279$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $4302094533ac0279$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $4302094533ac0279$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $4302094533ac0279$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $4302094533ac0279$export$f710a83a91838a36; });
const $4302094533ac0279$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $4302094533ac0279$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $4302094533ac0279$export$c0bcc9250309d66 = $4302094533ac0279$export$c4996c4b7b93b0bf && (!$4302094533ac0279$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($4302094533ac0279$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $4302094533ac0279$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $4302094533ac0279$export$f710a83a91838a36 = $4302094533ac0279$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("681Xw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4765026f41b30d94$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $4765026f41b30d94$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $eN72d.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $4765026f41b30d94$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $4765026f41b30d94$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $eN72d.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $eN72d.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $eN72d.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $eN72d.default).isArray(target[name])) target[name] = $4765026f41b30d94$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $eN72d.default).isFormData(formData) && (0, $eN72d.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $eN72d.default).forEachEntry(formData, (name, value)=>{
            buildPath($4765026f41b30d94$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $4765026f41b30d94$export$2e2bcd8739ae039 = $4765026f41b30d94$var$formDataToJSON;

});


parcelRegister("84HLP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e10a65e4fcb7f41$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $8CwNq = parcelRequire("8CwNq");
"use strict";
const $5e10a65e4fcb7f41$var$$internals = Symbol("internals");
function $5e10a65e4fcb7f41$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $5e10a65e4fcb7f41$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $eN72d.default).isArray(value) ? value.map($5e10a65e4fcb7f41$var$normalizeValue) : String(value);
}
function $5e10a65e4fcb7f41$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $5e10a65e4fcb7f41$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $5e10a65e4fcb7f41$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $eN72d.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $eN72d.default).isString(value)) return;
    if ((0, $eN72d.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $eN72d.default).isRegExp(filter)) return filter.test(value);
}
function $5e10a65e4fcb7f41$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $5e10a65e4fcb7f41$var$buildAccessors(obj, header) {
    const accessorName = (0, $eN72d.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $5e10a65e4fcb7f41$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $5e10a65e4fcb7f41$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $eN72d.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $5e10a65e4fcb7f41$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $eN72d.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $eN72d.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $eN72d.default).isString(header) && (header = header.trim()) && !$5e10a65e4fcb7f41$var$isValidHeaderName(header)) setHeaders((0, $8CwNq.default)(header), valueOrRewrite);
        else if ((0, $eN72d.default).isObject(header) && (0, $eN72d.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $eN72d.default).isArray(entry)) throw TypeError("Object iterator must return a key-value pair");
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $eN72d.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $5e10a65e4fcb7f41$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eN72d.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $5e10a65e4fcb7f41$var$parseTokens(value);
                if ((0, $eN72d.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $eN72d.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $5e10a65e4fcb7f41$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eN72d.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $5e10a65e4fcb7f41$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $5e10a65e4fcb7f41$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $eN72d.default).findKey(self, _header);
                if (key && (!matcher || $5e10a65e4fcb7f41$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $eN72d.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $5e10a65e4fcb7f41$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $eN72d.default).forEach(this, (value, header)=>{
            const key = (0, $eN72d.default).findKey(headers, header);
            if (key) {
                self[key] = $5e10a65e4fcb7f41$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $5e10a65e4fcb7f41$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $5e10a65e4fcb7f41$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $eN72d.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $eN72d.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$5e10a65e4fcb7f41$var$$internals] = this[$5e10a65e4fcb7f41$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $5e10a65e4fcb7f41$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $5e10a65e4fcb7f41$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $eN72d.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$5e10a65e4fcb7f41$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $eN72d.default).reduceDescriptors($5e10a65e4fcb7f41$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $eN72d.default).freezeMethods($5e10a65e4fcb7f41$var$AxiosHeaders);
var $5e10a65e4fcb7f41$export$2e2bcd8739ae039 = $5e10a65e4fcb7f41$var$AxiosHeaders;

});
parcelRegister("8CwNq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $646b4ffba29b7be8$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $646b4ffba29b7be8$var$ignoreDuplicateOf = (0, $eN72d.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $646b4ffba29b7be8$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $646b4ffba29b7be8$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("bNedC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $895f4cd83d7435f1$export$2e2bcd8739ae039; });
"use strict";
function $895f4cd83d7435f1$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("5tZpE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fdf4c7a496bb977$export$2e2bcd8739ae039; });

var $hEMVe = parcelRequire("hEMVe");

var $eN72d = parcelRequire("eN72d");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $3fdf4c7a496bb977$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $hEMVe.default).call(this, message == null ? "canceled" : message, (0, $hEMVe.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $eN72d.default).inherits($3fdf4c7a496bb977$var$CanceledError, (0, $hEMVe.default), {
    __CANCEL__: true
});
var $3fdf4c7a496bb977$export$2e2bcd8739ae039 = $3fdf4c7a496bb977$var$CanceledError;

});

parcelRegister("kClje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f027e2cbb32a9594$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $fOmje = parcelRequire("fOmje");

var $7frmW = parcelRequire("7frmW");

var $lM56w = parcelRequire("lM56w");

var $hEMVe = parcelRequire("hEMVe");
const $f027e2cbb32a9594$var$knownAdapters = {
    http: (0, $fOmje.default),
    xhr: (0, $7frmW.default),
    fetch: (0, $lM56w.default)
};
(0, $eN72d.default).forEach($f027e2cbb32a9594$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f027e2cbb32a9594$var$renderReason = (reason)=>`- ${reason}`;
const $f027e2cbb32a9594$var$isResolvedHandle = (adapter)=>(0, $eN72d.default).isFunction(adapter) || adapter === null || adapter === false;
var $f027e2cbb32a9594$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $eN72d.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f027e2cbb32a9594$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f027e2cbb32a9594$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $hEMVe.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f027e2cbb32a9594$var$renderReason).join("\n") : " " + $f027e2cbb32a9594$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $hEMVe.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f027e2cbb32a9594$var$knownAdapters
};

});
parcelRegister("7frmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $546f2a0b9fe2fb51$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $9PAeu = parcelRequire("9PAeu");

var $As6vu = parcelRequire("As6vu");

var $hEMVe = parcelRequire("hEMVe");

var $5tZpE = parcelRequire("5tZpE");

var $8N7CQ = parcelRequire("8N7CQ");

var $dWImh = parcelRequire("dWImh");

var $84HLP = parcelRequire("84HLP");

var $h1YI2 = parcelRequire("h1YI2");

var $d0pGT = parcelRequire("d0pGT");
const $546f2a0b9fe2fb51$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $546f2a0b9fe2fb51$export$2e2bcd8739ae039 = $546f2a0b9fe2fb51$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $d0pGT.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $84HLP.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $84HLP.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $9PAeu.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $hEMVe.default)("Request aborted", (0, $hEMVe.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $hEMVe.default)("Network Error", (0, $hEMVe.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $As6vu.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $hEMVe.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $hEMVe.default).ETIMEDOUT : (0, $hEMVe.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $eN72d.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $eN72d.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $h1YI2.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $h1YI2.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $5tZpE.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $8N7CQ.default)(_config.url);
        if (protocol && (0, $dWImh.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $hEMVe.default)("Unsupported protocol " + protocol + ":", (0, $hEMVe.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("9PAeu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7284fb8d844b2202$export$2e2bcd8739ae039; });

var $hEMVe = parcelRequire("hEMVe");
"use strict";
function $7284fb8d844b2202$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $hEMVe.default)("Request failed with status code " + response.status, [
        (0, $hEMVe.default).ERR_BAD_REQUEST,
        (0, $hEMVe.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("8N7CQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6668d094d075d968$export$2e2bcd8739ae039; });
"use strict";
function $6668d094d075d968$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("h1YI2", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $c6619f478b973de2$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $c6619f478b973de2$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $c6619f478b973de2$export$5d35863c355a22a9; });

var $flvIG = parcelRequire("flvIG");

var $hQ9cI = parcelRequire("hQ9cI");

var $eN72d = parcelRequire("eN72d");
const $c6619f478b973de2$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $flvIG.default)(50, 250);
    return (0, $hQ9cI.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $c6619f478b973de2$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $c6619f478b973de2$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $eN72d.default).asap(()=>fn(...args));

});
parcelRegister("flvIG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2c16c0ab740a4db$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $b2c16c0ab740a4db$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $b2c16c0ab740a4db$export$2e2bcd8739ae039 = $b2c16c0ab740a4db$var$speedometer;

});

parcelRegister("hQ9cI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfce6ec17ece780d$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $cfce6ec17ece780d$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $cfce6ec17ece780d$export$2e2bcd8739ae039 = $cfce6ec17ece780d$var$throttle;

});


parcelRegister("d0pGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $977f341a807ae608$export$2e2bcd8739ae039; });

var $dWImh = parcelRequire("dWImh");

var $eN72d = parcelRequire("eN72d");

var $iUCSh = parcelRequire("iUCSh");

var $6KIYm = parcelRequire("6KIYm");

var $fIyiW = parcelRequire("fIyiW");

var $hxjSH = parcelRequire("hxjSH");

var $84HLP = parcelRequire("84HLP");

var $bLbXt = parcelRequire("bLbXt");
var $977f341a807ae608$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $hxjSH.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $84HLP.default).from(headers);
    newConfig.url = (0, $bLbXt.default)((0, $fIyiW.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $eN72d.default).isFormData(data)) {
        if ((0, $dWImh.default).hasStandardBrowserEnv || (0, $dWImh.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $dWImh.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $eN72d.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $iUCSh.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $6KIYm.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("iUCSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc4b9c9b8d7c2e95$export$2e2bcd8739ae039; });

var $dWImh = parcelRequire("dWImh");
var $dc4b9c9b8d7c2e95$export$2e2bcd8739ae039 = (0, $dWImh.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $dWImh.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $dWImh.default).origin), (0, $dWImh.default).navigator && /(msie|trident)/i.test((0, $dWImh.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("6KIYm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ea9ec969f020df8$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");

var $dWImh = parcelRequire("dWImh");
var $4ea9ec969f020df8$export$2e2bcd8739ae039 = (0, $dWImh.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $eN72d.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $eN72d.default).isString(path) && cookie.push("path=" + path);
        (0, $eN72d.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("fIyiW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b715933c4ad3ec64$export$2e2bcd8739ae039; });

var $4Rggc = parcelRequire("4Rggc");

var $ejEnm = parcelRequire("ejEnm");
"use strict";
function $b715933c4ad3ec64$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $4Rggc.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $ejEnm.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("4Rggc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3898b99ec77f65fd$export$2e2bcd8739ae039; });
"use strict";
function $3898b99ec77f65fd$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("ejEnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6c228d073419d43$export$2e2bcd8739ae039; });
"use strict";
function $a6c228d073419d43$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("hxjSH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc44f0bc460d2752$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $eN72d = parcelRequire("eN72d");

var $84HLP = parcelRequire("84HLP");
"use strict";
const $cc44f0bc460d2752$var$headersToObject = (thing)=>thing instanceof (0, $84HLP.default) ? (0, $7Knp0._)({}, thing) : thing;
function $cc44f0bc460d2752$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $eN72d.default).isPlainObject(target) && (0, $eN72d.default).isPlainObject(source)) return (0, $eN72d.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $eN72d.default).isPlainObject(source)) return (0, $eN72d.default).merge({}, source);
        else if ((0, $eN72d.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $eN72d.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $eN72d.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $eN72d.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $eN72d.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $eN72d.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($cc44f0bc460d2752$var$headersToObject(a), $cc44f0bc460d2752$var$headersToObject(b), prop, true)
    };
    (0, $eN72d.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $eN72d.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("lM56w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fda20a4445d0ea81$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $dWImh = parcelRequire("dWImh");

var $eN72d = parcelRequire("eN72d");

var $hEMVe = parcelRequire("hEMVe");

var $jDIuy = parcelRequire("jDIuy");

var $2u0Zg = parcelRequire("2u0Zg");

var $84HLP = parcelRequire("84HLP");

var $h1YI2 = parcelRequire("h1YI2");

var $d0pGT = parcelRequire("d0pGT");

var $9PAeu = parcelRequire("9PAeu");
const $fda20a4445d0ea81$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $fda20a4445d0ea81$var$isReadableStreamSupported = $fda20a4445d0ea81$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $fda20a4445d0ea81$var$encodeText = $fda20a4445d0ea81$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $fda20a4445d0ea81$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $fda20a4445d0ea81$var$supportsRequestStream = $fda20a4445d0ea81$var$isReadableStreamSupported && $fda20a4445d0ea81$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $dWImh.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $fda20a4445d0ea81$var$DEFAULT_CHUNK_SIZE = 65536;
const $fda20a4445d0ea81$var$supportsResponseStream = $fda20a4445d0ea81$var$isReadableStreamSupported && $fda20a4445d0ea81$var$test(()=>(0, $eN72d.default).isReadableStream(new Response("").body));
const $fda20a4445d0ea81$var$resolvers = {
    stream: $fda20a4445d0ea81$var$supportsResponseStream && ((res)=>res.body)
};
$fda20a4445d0ea81$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$fda20a4445d0ea81$var$resolvers[type] && ($fda20a4445d0ea81$var$resolvers[type] = (0, $eN72d.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $hEMVe.default)(`Response type '${type}' is not supported`, (0, $hEMVe.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $fda20a4445d0ea81$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $eN72d.default).isBlob(body)) return body.size;
    if ((0, $eN72d.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $dWImh.default).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $eN72d.default).isArrayBufferView(body) || (0, $eN72d.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $eN72d.default).isURLSearchParams(body)) body = body + "";
    if ((0, $eN72d.default).isString(body)) return (await $fda20a4445d0ea81$var$encodeText(body)).byteLength;
};
const $fda20a4445d0ea81$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $eN72d.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $fda20a4445d0ea81$var$getBodyLength(body) : length;
};
var $fda20a4445d0ea81$export$2e2bcd8739ae039 = $fda20a4445d0ea81$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $d0pGT.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $jDIuy.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $fda20a4445d0ea81$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $fda20a4445d0ea81$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $eN72d.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $h1YI2.progressEventDecorator)(requestContentLength, (0, $h1YI2.progressEventReducer)((0, $h1YI2.asyncDecorator)(onUploadProgress)));
                data = (0, $2u0Zg.trackStream)(_request.body, $fda20a4445d0ea81$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $eN72d.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, (0, $6iHNw._)((0, $7Knp0._)({}, fetchOptions), {
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        }));
        let response = await fetch(request);
        const isStreamResponse = $fda20a4445d0ea81$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($fda20a4445d0ea81$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $eN72d.default).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $h1YI2.progressEventDecorator)(responseContentLength, (0, $h1YI2.progressEventReducer)((0, $h1YI2.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $2u0Zg.trackStream)(response.body, $fda20a4445d0ea81$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $fda20a4445d0ea81$var$resolvers[(0, $eN72d.default).findKey($fda20a4445d0ea81$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $9PAeu.default)(resolve, reject, {
                data: responseData,
                headers: (0, $84HLP.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $hEMVe.default)("Network Error", (0, $hEMVe.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $hEMVe.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("jDIuy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c42bf8303d6cca$export$2e2bcd8739ae039; });

var $5tZpE = parcelRequire("5tZpE");

var $hEMVe = parcelRequire("hEMVe");

var $eN72d = parcelRequire("eN72d");
const $e4c42bf8303d6cca$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $hEMVe.default) ? err : new (0, $5tZpE.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $hEMVe.default)(`timeout ${timeout} of ms exceeded`, (0, $hEMVe.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $eN72d.default).asap(unsubscribe);
        return signal;
    }
};
var $e4c42bf8303d6cca$export$2e2bcd8739ae039 = $e4c42bf8303d6cca$var$composeSignals;

});

parcelRegister("2u0Zg", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $1cef2620acd0fa71$export$b0119225647bd83; });
const $1cef2620acd0fa71$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $1cef2620acd0fa71$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $1cef2620acd0fa71$var$readStream(iterable))yield* $1cef2620acd0fa71$export$71b051935044bd5d(chunk, chunkSize);
};
const $1cef2620acd0fa71$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $1cef2620acd0fa71$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $1cef2620acd0fa71$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("324iN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2354e557b06f991c$export$2e2bcd8739ae039; });

var $f14aV = parcelRequire("f14aV");

var $hEMVe = parcelRequire("hEMVe");
"use strict";
const $2354e557b06f991c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $2354e557b06f991c$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $2354e557b06f991c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $2354e557b06f991c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $f14aV.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $hEMVe.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $hEMVe.default).ERR_DEPRECATED);
        if (version && !$2354e557b06f991c$var$deprecatedWarnings[opt]) {
            $2354e557b06f991c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$2354e557b06f991c$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $2354e557b06f991c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $hEMVe.default)("options must be an object", (0, $hEMVe.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $hEMVe.default)("option " + opt + " must be " + result, (0, $hEMVe.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $hEMVe.default)("Unknown option " + opt, (0, $hEMVe.default).ERR_BAD_OPTION);
    }
}
var $2354e557b06f991c$export$2e2bcd8739ae039 = {
    assertOptions: $2354e557b06f991c$var$assertOptions,
    validators: $2354e557b06f991c$var$validators
};

});
parcelRegister("f14aV", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $aeea301d76ca9f88$export$a4ad2735b021c132; });
const $aeea301d76ca9f88$export$a4ad2735b021c132 = "1.9.0";

});



parcelRegister("8ninC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $618eba9551315004$export$2e2bcd8739ae039; });

var $5tZpE = parcelRequire("5tZpE");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $618eba9551315004$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $618eba9551315004$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $5tZpE.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $618eba9551315004$export$2e2bcd8739ae039 = $618eba9551315004$var$CancelToken;

});

parcelRegister("fHGZX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6ec39bcf6b67b8b$export$2e2bcd8739ae039; });
"use strict";
function $b6ec39bcf6b67b8b$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("cJHbZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $945b311ae6b340c2$export$2e2bcd8739ae039; });

var $eN72d = parcelRequire("eN72d");
"use strict";
function $945b311ae6b340c2$export$2e2bcd8739ae039(payload) {
    return (0, $eN72d.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("hgJB5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9274ceae5e5e33b$export$2e2bcd8739ae039; });
const $c9274ceae5e5e33b$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($c9274ceae5e5e33b$var$HttpStatusCode).forEach(([key, value])=>{
    $c9274ceae5e5e33b$var$HttpStatusCode[value] = key;
});
var $c9274ceae5e5e33b$export$2e2bcd8739ae039 = $c9274ceae5e5e33b$var$HttpStatusCode;

});



parcelRegister("olBf4", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("iFd5d", function(module, exports) {

$parcel$export(module.exports, "mapMeResponseToUserProfile", function () { return $d966345f2dd1774d$export$76c6404ebb3f2fbe; });
$parcel$export(module.exports, "Editions", function () { return $d966345f2dd1774d$export$696c71818ae3f184; });
$parcel$export(module.exports, "ProductKeys", function () { return $d966345f2dd1774d$export$ef2c0ffddaaaf76c; });
var $d966345f2dd1774d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d966345f2dd1774d$export$5699ee30bc277ff0;
(function(AuthenticationMethodsType) {
    AuthenticationMethodsType["PASSWORD"] = "password";
    AuthenticationMethodsType["GOOGLE"] = "google";
    AuthenticationMethodsType["SAML"] = "saml";
    AuthenticationMethodsType["MICROSOFT"] = "microsoft";
    AuthenticationMethodsType["APPLE"] = "apple";
    AuthenticationMethodsType["SLACK"] = "slack";
})($d966345f2dd1774d$export$5699ee30bc277ff0 || ($d966345f2dd1774d$export$5699ee30bc277ff0 = {}));
var $d966345f2dd1774d$export$13699c771a86789f;
(function(GetUserPermissionsIsPermittedRequestPermissionId) {
    GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCTS"] = "add-products";
    GetUserPermissionsIsPermittedRequestPermissionId["INVITE_USERS"] = "invite-users";
    GetUserPermissionsIsPermittedRequestPermissionId["MANAGE"] = "manage";
    GetUserPermissionsIsPermittedRequestPermissionId["WRITE"] = "write";
    /**
     * @deprecated ADD_PRODUCT is a legacy permissionId, use ADD_PRODUCTS instead.
     */ GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCT"] = "addProduct";
})($d966345f2dd1774d$export$13699c771a86789f || ($d966345f2dd1774d$export$13699c771a86789f = {}));
function $d966345f2dd1774d$export$bdffa12efde3d762(auth) {
    return !!auth.asap;
}
function $d966345f2dd1774d$export$76c6404ebb3f2fbe(_a) {
    var { account_id: account_id } = _a, others = $d966345f2dd1774d$var$__rest(_a, [
        "account_id"
    ]);
    return Object.assign({
        accountId: account_id
    }, others);
}
var $d966345f2dd1774d$export$696c71818ae3f184;
(function(Editions) {
    Editions["FREE"] = "free";
    Editions["STANDARD"] = "standard";
    Editions["PREMIUM"] = "premium";
})($d966345f2dd1774d$export$696c71818ae3f184 || ($d966345f2dd1774d$export$696c71818ae3f184 = {}));
var $d966345f2dd1774d$export$ef2c0ffddaaaf76c;
(function(ProductKeys) {
    ProductKeys["CONFLUENCE"] = "confluence.ondemand";
    ProductKeys["JIRA_CORE"] = "jira-core.ondemand";
    ProductKeys["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKeys["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKeys["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    ProductKeys["TRELLO"] = "trello";
    ProductKeys["OPSGENIE"] = "opsgenie";
    ProductKeys["BITBUCKET"] = "bitbucket.ondemand";
    ProductKeys["BITBUCKET_COFS"] = "com.atlassian.bitbucket";
    ProductKeys["STATUSPAGE"] = "statuspage";
    ProductKeys["TEAM_CENTRAL"] = "townsquare";
    ProductKeys["AVOCADO"] = "avocado";
    ProductKeys["COMPASS"] = "compass";
    ProductKeys["ANALYTICS"] = "atlassian-analytics-free";
    ProductKeys["WHITEBOARD"] = "atlassian-whiteboard";
    ProductKeys["GUARD"] = "guard";
    ProductKeys["ROVO"] = "rovo";
})($d966345f2dd1774d$export$ef2c0ffddaaaf76c || ($d966345f2dd1774d$export$ef2c0ffddaaaf76c = {}));

});

parcelRegister("4CzEV", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_KEY_MAP", function () { return $35d65f2cdb00cbf6$export$49ebef81048c4e68; });
$parcel$export(module.exports, "IDENTITY_RECAPTCHA_KEY", function () { return $35d65f2cdb00cbf6$export$ba007ad7a8d56c3d; });
$parcel$export(module.exports, "IDENTITY_RECAPTCHA_KEY_TEST", function () { return $35d65f2cdb00cbf6$export$901430629348d0a1; });
const $35d65f2cdb00cbf6$export$92fa52c125cc0e5 = "identity-platform";
const $35d65f2cdb00cbf6$export$49ebef81048c4e68 = {
    CONFLUENCE: "confluence.ondemand",
    JIRA_CORE: "jira-core.ondemand",
    JIRA_BUSINESS: "jira-core.ondemand",
    JIRA_SOFTWARE: "jira-software.ondemand",
    JIRA_SERVICE_DESK: "jira-servicedesk.ondemand",
    BITBUCKET: "com.atlassian.bitbucket",
    OPSGENIE: "opsgenie",
    STATUSPAGE: "statuspage",
    TRELLO: "trello"
};
const $35d65f2cdb00cbf6$export$ba007ad7a8d56c3d = "6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD";
const $35d65f2cdb00cbf6$export$901430629348d0a1 = "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN";

});

parcelRegister("f2t2w", function(module, exports) {
$parcel$export(module.exports, "getAtlCohortIdFromCookie", function () { return (parcelRequire("7ucnk")).getAtlCohortIdFromCookie; });
$parcel$export(module.exports, "isValidSite", function () { return (parcelRequire("cWrL0")).isValidSite; });
$parcel$export(module.exports, "getReCaptchaKey", function () { return (parcelRequire("gtHju")).getReCaptchaKey; });
parcelRequire("7ucnk");
parcelRequire("cWrL0");
parcelRequire("e46Pq");
parcelRequire("gtHju");

});
parcelRegister("7ucnk", function(module, exports) {

$parcel$export(module.exports, "getAtlCohortIdFromCookie", function () { return $5734ef34c98eb318$export$a284fd3cd35fac52; });

var $olBf4 = parcelRequire("olBf4");
function $5734ef34c98eb318$export$a284fd3cd35fac52() {
    let atlCohortId;
    try {
        const cookie = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($olBf4))).get("atlCohort") || "");
        atlCohortId = cookie["bucketAll"].index;
    } catch (e) {
        atlCohortId = "";
        console.warn("Cannot parse atlCohort cookie", e);
    }
    return atlCohortId;
}

});

parcelRegister("cWrL0", function(module, exports) {

$parcel$export(module.exports, "isValidSite", function () { return $96c06ec8df6e4a3d$export$c7346ed3533fb878; });
const $96c06ec8df6e4a3d$export$c7346ed3533fb878 = ({ site: site, includeInvalidBitbucketSite: includeInvalidBitbucketSite })=>{
    const ignoreSiteNames = [
        "servicedog",
        "ecosystem",
        "atlassiantraining",
        "Atlassian Stride",
        "volunteerhub",
        "atlassiantraining",
        "hello-staging",
        "ecosystem",
        "riskmanagement",
        "hello-staging3",
        "hello-staging6",
        "hello-staging9",
        "jdog",
        "sre-ehlo",
        "trello",
        "Trello"
    ];
    if (!includeInvalidBitbucketSite) ignoreSiteNames.push("bitbucket", "Bitbucket");
    if (ignoreSiteNames.includes(site.displayName)) return false;
    if (site.cloudId.startsWith("DUMMY")) return false;
    return true;
};

});

parcelRegister("e46Pq", function(module, exports) {

});

parcelRegister("gtHju", function(module, exports) {

$parcel$export(module.exports, "getReCaptchaKey", function () { return $bff0f3edc241aff4$export$4682c216c5c4d5d7; });

var $4CzEV = parcelRequire("4CzEV");
const $bff0f3edc241aff4$export$4682c216c5c4d5d7 = ()=>{
    return $bff0f3edc241aff4$var$isProduction() ? (0, $4CzEV.IDENTITY_RECAPTCHA_KEY) : (0, $4CzEV.IDENTITY_RECAPTCHA_KEY_TEST);
};
const $bff0f3edc241aff4$var$isProduction = ()=>{
    const urlParts = window.location.hostname.split(".");
    if (urlParts[1] === "dev") return false;
    switch(urlParts[0]){
        case "wac":
        case "qa-wac":
        case "author":
        case "proof":
        case "localhost":
        case "local":
            return false;
        case "truth":
        case "www":
        case "atlassian":
        case "bitbucket":
        case "sourcetreeapp":
        case "agile":
        case "git":
        case "software":
            return true;
        default:
            /* for omlet instances */ return false;
    }
};

});



parcelRegister("8IHSJ", function(module, exports) {
parcelRequire("kotDp");
parcelRequire("7PTYq");

});
parcelRegister("kotDp", function(module, exports) {

});

parcelRegister("7PTYq", function(module, exports) {

});



parcelRegister("3LLDq", function(module, exports) {

$parcel$export(module.exports, "CrossFlowTouchpointProvider", function () { return (parcelRequire("bi0vu")).CrossFlowTouchpointProvider; });
$parcel$export(module.exports, "useCrossFlowFrontendTouchpoint", function () { return (parcelRequire("8ltM2")).useCrossFlowFrontendTouchpoint; });

var $bi0vu = parcelRequire("bi0vu");

var $8ltM2 = parcelRequire("8ltM2");

});
parcelRegister("bi0vu", function(module, exports) {

$parcel$export(module.exports, "CrossFlowTouchpointProvider", function () { return $4586818afb9643f5$export$e2f4f4c41dccbd79; });
$parcel$export(module.exports, "useCrossFlowTouchpointContext", function () { return $4586818afb9643f5$export$411afe878b9f0326; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aYNGK = parcelRequire("aYNGK");

var $5wOn9 = parcelRequire("5wOn9");

var $1TEMI = parcelRequire("1TEMI");
const $4586818afb9643f5$export$1b5d8f0c33515521 = {
    isCrossFlowEnabled: false,
    productKeys: []
};
const $4586818afb9643f5$export$a4b3fa3db11b6b5d = /*#__PURE__*/ (0, $iSvIT.createContext)($4586818afb9643f5$export$1b5d8f0c33515521);
const $4586818afb9643f5$export$78e295e9b9464346 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($4586818afb9643f5$export$a4b3fa3db11b6b5d.Provider, {
        value: $4586818afb9643f5$export$1b5d8f0c33515521,
        children: children
    });
};
const $4586818afb9643f5$export$c2fcf9e694782042 = ({ children: children, productKeys: productKeys, screenName: screenName, viewedOnMount: viewedOnMount = true })=>{
    const { fireCrossFlowScreenEvent: fireCrossFlowScreenEvent, fireUIEvent: fireUIEvent } = (0, $1TEMI.useFireEvent)({
        productCohorts: (0, $1TEMI.getProductCohorts)(productKeys),
        screenName: screenName
    });
    const onViewTouchpoint = (0, $iSvIT.useCallback)(()=>{
        if (screenName) {
            fireCrossFlowScreenEvent(screenName, {
                recommendedProductIds: productKeys
            });
            return;
        }
        fireUIEvent({
            action: "viewed",
            actionSubject: (0, $1TEMI.WAC_GENERIC_TOUCHPOINT_NAME)
        });
    }, [
        screenName,
        fireUIEvent,
        fireCrossFlowScreenEvent,
        productKeys
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (viewedOnMount) onViewTouchpoint();
    }, [
        onViewTouchpoint,
        viewedOnMount
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($4586818afb9643f5$export$a4b3fa3db11b6b5d.Provider, {
        value: {
            isCrossFlowEnabled: true,
            productKeys: productKeys,
            screenName: screenName,
            onViewTouchpoint: onViewTouchpoint
        },
        children: children
    });
};
const $4586818afb9643f5$export$e2f4f4c41dccbd79 = ({ children: children, productKeys: productKeys, screenName: screenName, viewedOnMount: viewedOnMount = true })=>{
    const { isUserLoggedIn: isUserLoggedIn } = (0, $5wOn9.useLoggedInUser)();
    const crossFlow = (0, $aYNGK.useCrossFlow)();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $1TEMI.useFireEvent)({
        isUserLoggedIn: isUserLoggedIn,
        isCrossFlowEnabled: crossFlow === null || crossFlow === void 0 ? void 0 : crossFlow.isEnabled
    });
    if (!isUserLoggedIn || !(crossFlow === null || crossFlow === void 0 ? void 0 : crossFlow.isEnabled)) {
        fireOperationalEvent({
            action: "disabled",
            actionSubject: "crossFlowFrontend",
            eventType: "operational"
        });
        return /*#__PURE__*/ (0, $loA2J.jsx)($4586818afb9643f5$export$78e295e9b9464346, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)($4586818afb9643f5$export$c2fcf9e694782042, {
        productKeys: productKeys,
        screenName: screenName,
        viewedOnMount: viewedOnMount,
        children: children
    });
};
const $4586818afb9643f5$export$411afe878b9f0326 = ()=>(0, $iSvIT.useContext)($4586818afb9643f5$export$a4b3fa3db11b6b5d);

});
parcelRegister("1TEMI", function(module, exports) {

$parcel$export(module.exports, "getRolloutFlagValue", function () { return $22b7a29b7a899ee2$export$697caa2c041f95d9; });
$parcel$export(module.exports, "getProductCohorts", function () { return $22b7a29b7a899ee2$export$79c54cec4f0a656b; });
$parcel$export(module.exports, "useFireEvent", function () { return $22b7a29b7a899ee2$export$5e1559072ecb0787; });
$parcel$export(module.exports, "WAC_GENERIC_TOUCHPOINT_NAME", function () { return $22b7a29b7a899ee2$export$d64a4fd19c447036; });
$parcel$export(module.exports, "WAC_GENERIC_TOUCHPOINT_COMPONENT_NAME", function () { return $22b7a29b7a899ee2$export$b772174460988b88; });
$parcel$export(module.exports, "redirectToDefaultUrl", function () { return $22b7a29b7a899ee2$export$15376d3104f6357b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $4LHd8 = parcelRequire("4LHd8");

var $cMvwK = parcelRequire("cMvwK");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");

var $dWbel = parcelRequire("dWbel");
const $22b7a29b7a899ee2$export$9d0aa203dcbcf3a9 = {};
const $22b7a29b7a899ee2$var$productRolloutKeys = [
    // ProductKeys.JIRA_SOFTWARE,
    (0, $iFd5d.ProductKeys).JIRA_SERVICE_DESK
];
const $22b7a29b7a899ee2$export$697caa2c041f95d9 = (productKey, fireExperimentExposure)=>{
    if (!productKey) return "not-enrolled";
    if ($22b7a29b7a899ee2$var$productRolloutKeys.includes(productKey)) return "variation";
    const experimentKey = $22b7a29b7a899ee2$export$9d0aa203dcbcf3a9[productKey];
    if (!experimentKey) return "not-enrolled";
    return (0, $4LHd8.default).getExperimentValue(experimentKey, "cohort", "not-enrolled", {
        fireExperimentExposure: fireExperimentExposure
    });
};
const $22b7a29b7a899ee2$export$79c54cec4f0a656b = (productKeys)=>{
    const productCohorts = {};
    productKeys.forEach((productKey)=>{
        productCohorts[productKey] = $22b7a29b7a899ee2$export$697caa2c041f95d9(productKey);
    });
    return productCohorts;
};
const $22b7a29b7a899ee2$export$5e1559072ecb0787 = (initialAttributes = {})=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const crossFlowEvents = (0, $cMvwK.useFireCrossFlowAnalyticsEvents)();
    const fireEvent = (0, $iSvIT.useCallback)((eventPayload, attributes = {})=>{
        analyticsClient && createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            attributes: (0, $7Knp0._)({}, eventPayload["attributes"] || {}, attributes, initialAttributes)
        })).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent,
        initialAttributes
    ]);
    const fireUIEvent = (0, $iSvIT.useCallback)((eventPayload, attributes = {})=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            attributes: (0, $7Knp0._)({}, attributes, eventPayload["attributes"]),
            eventType: "ui"
        }));
    }, [
        fireEvent
    ]);
    const fireTrackEvent = (0, $iSvIT.useCallback)((eventPayload, attributes = {})=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            attributes: (0, $7Knp0._)({}, attributes, eventPayload["attributes"]),
            eventType: "track"
        }));
    }, [
        fireEvent
    ]);
    const fireScreenEvent = (0, $iSvIT.useCallback)((eventPayload, attributes = {})=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            attributes: (0, $7Knp0._)({}, attributes, eventPayload["attributes"]),
            eventType: "screen"
        }));
    }, [
        fireEvent
    ]);
    const fireOperationalEvent = (0, $iSvIT.useCallback)((eventPayload, attributes = {})=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            attributes: (0, $7Knp0._)({}, attributes, eventPayload["attributes"]),
            eventType: "operational"
        }));
    }, [
        fireEvent
    ]);
    const fireCrossFlowScreenEvent = (0, $iSvIT.useCallback)((screenName, commonAttributes, attributes = {})=>{
        if (!analyticsClient) return;
        crossFlowEvents.fireViewedScreenEvent(screenName, commonAttributes, (0, $7Knp0._)({}, initialAttributes, attributes));
    }, [
        analyticsClient,
        crossFlowEvents,
        initialAttributes
    ]);
    const fireCrossFlowViewedUIEvent = (0, $iSvIT.useCallback)((eventPayload, commonAttributes, attributes = {})=>{
        if (!analyticsClient) return;
        crossFlowEvents.fireViewedUIEvent(eventPayload, commonAttributes, (0, $7Knp0._)({}, initialAttributes, attributes));
    }, [
        analyticsClient,
        crossFlowEvents,
        initialAttributes
    ]);
    const fireCrossFlowInteractedUIEvent = (0, $iSvIT.useCallback)((eventPayload, commonAttributes, attributes = {})=>{
        if (!analyticsClient) return;
        crossFlowEvents.fireInteractedUIEvent(eventPayload, commonAttributes, (0, $7Knp0._)({}, initialAttributes, attributes));
    }, [
        analyticsClient,
        crossFlowEvents,
        initialAttributes
    ]);
    return {
        fireUIEvent: fireUIEvent,
        fireTrackEvent: fireTrackEvent,
        fireScreenEvent: fireScreenEvent,
        fireOperationalEvent: fireOperationalEvent,
        fireCrossFlowScreenEvent: fireCrossFlowScreenEvent,
        fireCrossFlowViewedUIEvent: fireCrossFlowViewedUIEvent,
        fireCrossFlowInteractedUIEvent: fireCrossFlowInteractedUIEvent
    };
};
const $22b7a29b7a899ee2$export$d64a4fd19c447036 = "wacGenericCrossFlowTouchpoint";
const $22b7a29b7a899ee2$export$b772174460988b88 = "wacGenericCrossFlowComponent";
const $22b7a29b7a899ee2$export$15376d3104f6357b = (redirectUrl, onSuccess, onError)=>{
    if (typeof redirectUrl !== "string" || redirectUrl === "") {
        onError(`Fallback href ${redirectUrl} is not a string or empty`);
        return;
    }
    try {
        const url = new URL(redirectUrl, window.location.origin);
        onSuccess();
        window.location.assign(url);
    } catch (error) {
        onError(error instanceof Error ? error.message : `Invalid URL: ${redirectUrl}`);
    }
};

});
parcelRegister("cMvwK", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", function () { return $94e26c5a30796d00$export$c2095165ae2bdcda; });

var $29g5S = parcelRequire("29g5S");

var $l9j1y = parcelRequire("l9j1y");

var $iSvIT = parcelRequire("iSvIT");

var $7hwvo = parcelRequire("7hwvo");

var $gK526 = parcelRequire("gK526");

var $admnH = parcelRequire("admnH");
var $94e26c5a30796d00$var$_excluded = [
    "recommendedProductIds"
], $94e26c5a30796d00$var$_excluded2 = [
    "source",
    "recommendedProductIds"
], $94e26c5a30796d00$var$_excluded3 = [
    "source",
    "recommendedProductIds",
    "targetProductId"
];
function $94e26c5a30796d00$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94e26c5a30796d00$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94e26c5a30796d00$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $29g5S.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94e26c5a30796d00$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $94e26c5a30796d00$export$c2095165ae2bdcda() {
    var _useAnalyticsEvents = (0, $7hwvo.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var firedViewedScreenEventName = (0, $iSvIT.useRef)();
    var firedViewedUIEventId = (0, $iSvIT.useRef)();
    var mapToCcpProductKeys = (0, $iSvIT.useCallback)(function(recommendedProductIds, targetProductId) {
        var ccpProductIds = recommendedProductIds.reduce(function(acc, curr) {
            var _SURFACE_ANALYTICS_PR;
            acc.push((_SURFACE_ANALYTICS_PR = (0, $gK526.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr]) !== null && _SURFACE_ANALYTICS_PR !== void 0 ? _SURFACE_ANALYTICS_PR : curr);
            return acc;
        }, []);
        var ccpTargetProductId = targetProductId && (0, $gK526.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId !== null && ccpTargetProductId !== void 0 ? ccpTargetProductId : targetProductId
        };
    }, []);
    var fireViewedScreenEvent = (0, $iSvIT.useCallback)(function(name, commonAttributes, attributes) {
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        var recommendedProductIds = commonAttributes.recommendedProductIds, rest = (0, $l9j1y.default)(commonAttributes, $94e26c5a30796d00$var$_excluded);
        var _mapToCcpProductKeys = mapToCcpProductKeys(recommendedProductIds), ccpProductIds = _mapToCcpProductKeys.recommendedProductIds;
        createAnalyticsEvent({
            eventType: (0, $admnH.eventTypes).SCREEN,
            name: name,
            attributes: $94e26c5a30796d00$var$_objectSpread($94e26c5a30796d00$var$_objectSpread({
                recommendedProductIds: ccpProductIds
            }, rest), attributes)
        }).fire((0, $admnH.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    var fireViewedUIEvent = (0, $iSvIT.useCallback)(function(event, commonAttributes, attributes) {
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        var source = commonAttributes.source, recommendedProductIds = commonAttributes.recommendedProductIds, rest = (0, $l9j1y.default)(commonAttributes, $94e26c5a30796d00$var$_excluded2);
        var _mapToCcpProductKeys2 = mapToCcpProductKeys(recommendedProductIds), ccpProductIds = _mapToCcpProductKeys2.recommendedProductIds;
        createAnalyticsEvent($94e26c5a30796d00$var$_objectSpread($94e26c5a30796d00$var$_objectSpread({
            eventType: (0, $admnH.eventTypes).UI
        }, event), {}, {
            source: source,
            attributes: $94e26c5a30796d00$var$_objectSpread($94e26c5a30796d00$var$_objectSpread({
                recommendedProductIds: ccpProductIds
            }, rest), attributes)
        })).fire((0, $admnH.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    var fireInteractedUIEvent = (0, $iSvIT.useCallback)(function(event, commonAttributes, attributes) {
        var source = commonAttributes.source, recommendedProductIds = commonAttributes.recommendedProductIds, targetProductId = commonAttributes.targetProductId, rest = (0, $l9j1y.default)(commonAttributes, $94e26c5a30796d00$var$_excluded3);
        var _mapToCcpProductKeys3 = mapToCcpProductKeys(recommendedProductIds !== null && recommendedProductIds !== void 0 ? recommendedProductIds : [], targetProductId), ccpProductIds = _mapToCcpProductKeys3.recommendedProductIds, ccpTargetProductId = _mapToCcpProductKeys3.targetProductId;
        createAnalyticsEvent($94e26c5a30796d00$var$_objectSpread($94e26c5a30796d00$var$_objectSpread({
            eventType: (0, $admnH.eventTypes).UI
        }, event), {}, {
            source: source,
            attributes: $94e26c5a30796d00$var$_objectSpread($94e26c5a30796d00$var$_objectSpread({
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId
            }, rest), attributes)
        })).fire((0, $admnH.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("29g5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1908e7eb6053a68f$export$2e2bcd8739ae039; });

var $gIUZr = parcelRequire("gIUZr");
function $1908e7eb6053a68f$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gIUZr.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("gIUZr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ccf668e1f18a1d$export$2e2bcd8739ae039; });

var $4NkmQ = parcelRequire("4NkmQ");

var $k3FLo = parcelRequire("k3FLo");
function $c2ccf668e1f18a1d$export$2e2bcd8739ae039(t) {
    var i = (0, $k3FLo.default)(t, "string");
    return "symbol" == (0, $4NkmQ.default)(i) ? i : i + "";
}

});
parcelRegister("4NkmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37db89981c6e263f$export$2e2bcd8739ae039; });
function $37db89981c6e263f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $37db89981c6e263f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $37db89981c6e263f$export$2e2bcd8739ae039(o);
}

});

parcelRegister("k3FLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9a47bd121b1151c$export$2e2bcd8739ae039; });

var $4NkmQ = parcelRequire("4NkmQ");
function $e9a47bd121b1151c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4NkmQ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4NkmQ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("l9j1y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6593206f309cdcf$export$2e2bcd8739ae039; });

var $95x2V = parcelRequire("95x2V");
function $f6593206f309cdcf$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $95x2V.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("95x2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69de36f5fed79a7e$export$2e2bcd8739ae039; });
function $69de36f5fed79a7e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("7hwvo", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $54d355cfe680c2b8$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $atbzl = parcelRequire("atbzl");

var $DEAoQ = parcelRequire("DEAoQ");
function $54d355cfe680c2b8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $DEAoQ.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $atbzl.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("atbzl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79f5962eedc1bd8b$export$2e2bcd8739ae039; });

var $8SXYW = parcelRequire("8SXYW");

var $fmxXz = parcelRequire("fmxXz");

var $5pRQo = parcelRequire("5pRQo");

var $5wokd = parcelRequire("5wokd");

var $M9VR9 = parcelRequire("M9VR9");

var $24gWJ = parcelRequire("24gWJ");

var $5BhTD = parcelRequire("5BhTD");

var $29g5S = parcelRequire("29g5S");

var $5qH4R = parcelRequire("5qH4R");
function $79f5962eedc1bd8b$var$_callSuper(t, o, e) {
    return o = (0, $M9VR9.default)(o), (0, $5wokd.default)(t, $79f5962eedc1bd8b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $M9VR9.default)(t).constructor) : o.apply(t, e));
}
function $79f5962eedc1bd8b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($79f5962eedc1bd8b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $79f5962eedc1bd8b$var$_superPropGet(t, o, e, r) {
    var p = (0, $24gWJ.default)((0, $M9VR9.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $79f5962eedc1bd8b$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $79f5962eedc1bd8b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $79f5962eedc1bd8b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $fmxXz.default)(this, UIAnalyticsEvent);
        _this = $79f5962eedc1bd8b$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $29g5S.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $29g5S.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $8SXYW.default)(_this.context);
            var handlers = (0, $8SXYW.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $29g5S.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $5BhTD.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $5pRQo.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $79f5962eedc1bd8b$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5qH4R.default));

});
parcelRegister("8SXYW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6781e50f874cbc27$export$2e2bcd8739ae039; });

var $jTLIM = parcelRequire("jTLIM");

var $b1Vzd = parcelRequire("b1Vzd");

var $6CzIN = parcelRequire("6CzIN");

var $jZhUS = parcelRequire("jZhUS");
function $6781e50f874cbc27$export$2e2bcd8739ae039(r) {
    return (0, $jTLIM.default)(r) || (0, $b1Vzd.default)(r) || (0, $6CzIN.default)(r) || (0, $jZhUS.default)();
}

});
parcelRegister("jTLIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7c82bcff7f5600c$export$2e2bcd8739ae039; });

var $1YbnY = parcelRequire("1YbnY");
function $e7c82bcff7f5600c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $1YbnY.default)(r);
}

});
parcelRegister("1YbnY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16f439fb650d706b$export$2e2bcd8739ae039; });
function $16f439fb650d706b$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("b1Vzd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $807c714e0995ff78$export$2e2bcd8739ae039; });
function $807c714e0995ff78$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6CzIN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d220041cd4ca750$export$2e2bcd8739ae039; });

var $1YbnY = parcelRequire("1YbnY");
function $4d220041cd4ca750$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1YbnY.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1YbnY.default)(r, a) : void 0;
    }
}

});

parcelRegister("jZhUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8d19ca7f265473f$export$2e2bcd8739ae039; });
function $e8d19ca7f265473f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fmxXz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f340c8829d2166$export$2e2bcd8739ae039; });
function $b2f340c8829d2166$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("5pRQo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f190ddd287b60e6$export$2e2bcd8739ae039; });

var $gIUZr = parcelRequire("gIUZr");
function $3f190ddd287b60e6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $gIUZr.default)(o.key), o);
    }
}
function $3f190ddd287b60e6$export$2e2bcd8739ae039(e, r, t) {
    return r && $3f190ddd287b60e6$var$_defineProperties(e.prototype, r), t && $3f190ddd287b60e6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("5wokd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4052cf5a43754474$export$2e2bcd8739ae039; });

var $4NkmQ = parcelRequire("4NkmQ");

var $h6RCc = parcelRequire("h6RCc");
function $4052cf5a43754474$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $4NkmQ.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $h6RCc.default)(t);
}

});
parcelRegister("h6RCc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c74c960bd65c7a04$export$2e2bcd8739ae039; });
function $c74c960bd65c7a04$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("M9VR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $090c30217f079948$export$2e2bcd8739ae039; });
function $090c30217f079948$export$2e2bcd8739ae039(t) {
    return $090c30217f079948$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $090c30217f079948$export$2e2bcd8739ae039(t);
}

});

parcelRegister("24gWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $181919abee328ad1$export$2e2bcd8739ae039; });

var $l5TGv = parcelRequire("l5TGv");
function $181919abee328ad1$export$2e2bcd8739ae039() {
    return $181919abee328ad1$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $l5TGv.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $181919abee328ad1$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("l5TGv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5b542654c5ee50a$export$2e2bcd8739ae039; });

var $M9VR9 = parcelRequire("M9VR9");
function $f5b542654c5ee50a$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $M9VR9.default)(t)););
    return t;
}

});


parcelRegister("5BhTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $413e4a4ed6ae2bc1$export$2e2bcd8739ae039; });

var $eW7EU = parcelRequire("eW7EU");
function $413e4a4ed6ae2bc1$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $eW7EU.default)(t, e);
}

});
parcelRegister("eW7EU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adfc6c558c1f8931$export$2e2bcd8739ae039; });
function $adfc6c558c1f8931$export$2e2bcd8739ae039(t, e) {
    return $adfc6c558c1f8931$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $adfc6c558c1f8931$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("5qH4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f40cbc1ed7c23e0$export$2e2bcd8739ae039; });

var $4NkmQ = parcelRequire("4NkmQ");

var $fmxXz = parcelRequire("fmxXz");

var $5pRQo = parcelRequire("5pRQo");

var $29g5S = parcelRequire("29g5S");
function $3f40cbc1ed7c23e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f40cbc1ed7c23e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f40cbc1ed7c23e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $29g5S.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f40cbc1ed7c23e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f40cbc1ed7c23e0$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3f40cbc1ed7c23e0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $3f40cbc1ed7c23e0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $fmxXz.default)(this, AnalyticsEvent);
        (0, $29g5S.default)(this, "_isAnalyticsEvent", true);
        (0, $29g5S.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $3f40cbc1ed7c23e0$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $5pRQo.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $4NkmQ.default)(updater) === "object") this.payload = $3f40cbc1ed7c23e0$var$_objectSpread($3f40cbc1ed7c23e0$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("DEAoQ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $0773202f97481e04$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $0773202f97481e04$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("admnH", function(module, exports) {

$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", function () { return $76fc7ab62bbea281$export$c536a7e29a0739b8; });
$parcel$export(module.exports, "eventTypes", function () { return $76fc7ab62bbea281$export$285f3d0989f9023f; });
var $76fc7ab62bbea281$export$c536a7e29a0739b8 = "crossFlow";
var $76fc7ab62bbea281$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});




parcelRegister("8ltM2", function(module, exports) {

$parcel$export(module.exports, "useCrossFlowFrontendTouchpoint", function () { return $c41901e3c44f0437$export$acccfb068b962644; });

var $bi0vu = parcelRequire("bi0vu");

var $1uAZF = parcelRequire("1uAZF");

var $hetvO = parcelRequire("hetvO");
const $c41901e3c44f0437$export$acccfb068b962644 = ({ productKey: productKey, screenName: screenName, redirectUrl: redirectUrl, edition: edition }, touchpointViewedOnMount = true)=>{
    const { isCrossFlowEnabled: isCrossFlowEnabled } = (0, $bi0vu.useCrossFlowTouchpointContext)();
    const onCrossFlowComponentViewed = (0, $hetvO.useCrossFlowFrontendTouchpointComponentViewed)({
        fireOnMount: isCrossFlowEnabled && touchpointViewedOnMount,
        productKey: productKey,
        screenName: screenName,
        edition: edition
    });
    const openCrossFlow = (0, $1uAZF.useOpenCrossFlow)({
        productKey: productKey,
        screenName: screenName,
        redirectUrl: redirectUrl,
        edition: edition
    });
    if (!isCrossFlowEnabled) return {
        isEnabled: false,
        onCrossFlowComponentViewed: onCrossFlowComponentViewed
    };
    return {
        isEnabled: true,
        openCrossFlow: openCrossFlow,
        onCrossFlowComponentViewed: onCrossFlowComponentViewed
    };
};

});
parcelRegister("1uAZF", function(module, exports) {

$parcel$export(module.exports, "useOpenCrossFlow", function () { return $33660b5be491dd5e$export$f6033fcc5716710c; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $aYNGK = parcelRequire("aYNGK");

var $1TEMI = parcelRequire("1TEMI");
const $33660b5be491dd5e$export$f6033fcc5716710c = ({ productKey: productKey, redirectUrl: redirectUrl, edition: edition, componentType: componentType = "button", interactionName: interactionName = "tryItFreeButton", screenName: screenName })=>{
    const { fireCrossFlowInteractedUIEvent: fireCrossFlowInteractedUIEvent, fireOperationalEvent: fireOperationalEvent, fireTrackEvent: fireTrackEvent } = (0, $1TEMI.useFireEvent)({
        productKey: productKey,
        redirectUrl: redirectUrl,
        edition: edition,
        componentType: componentType,
        interactionName: interactionName,
        screenName: screenName
    });
    const crossFlow = (0, $aYNGK.useCrossFlow)();
    const fireInteractionEvent = (0, $iSvIT.useCallback)(()=>{
        if (screenName && productKey) fireCrossFlowInteractedUIEvent({
            action: "clicked",
            actionSubject: componentType,
            actionSubjectId: interactionName
        }, {
            source: screenName,
            targetProductId: productKey
        });
        else fireTrackEvent({
            action: "clicked",
            actionSubject: componentType,
            actionSubjectId: interactionName
        });
    }, [
        componentType,
        fireCrossFlowInteractedUIEvent,
        fireTrackEvent,
        interactionName,
        productKey,
        screenName
    ]);
    const fireRedirectSuccessEvent = (0, $iSvIT.useCallback)(()=>{
        fireOperationalEvent({
            action: "successful",
            actionSubject: "crossFlowFallbackRedirectAttempt",
            eventType: "operational"
        });
    }, [
        fireOperationalEvent
    ]);
    const fireRedirectFailedEvent = (0, $iSvIT.useCallback)((errorMessage)=>fireOperationalEvent({
            action: "failed",
            actionSubject: "crossFlowFallbackRedirectAttempt",
            attributes: {
                errorMessage: errorMessage
            }
        }), [
        fireOperationalEvent
    ]);
    const openCrossFlow = (0, $iSvIT.useCallback)(async (event, payload = {}, extensions)=>{
        if (event) event.preventDefault();
        const targetProduct = payload.productKey || productKey;
        const url = payload.redirectUrl || redirectUrl || "";
        const targetEdition = payload.edition || edition;
        try {
            fireInteractionEvent();
            if (!targetProduct || !crossFlow.isEnabled || (0, $1TEMI.getRolloutFlagValue)(targetProduct, true) !== "variation") {
                (0, $1TEMI.redirectToDefaultUrl)(url, fireRedirectSuccessEvent, fireRedirectFailedEvent);
                return;
            }
            fireOperationalEvent({
                action: "successful",
                actionSubject: "crossFlowRequest"
            });
            if (targetEdition) extensions = (0, $6iHNw._)((0, $7Knp0._)({}, extensions), {
                edition: targetEdition
            });
            await crossFlow.api.open({
                journey: (0, $aYNGK.Journeys).GET_STARTED,
                targetProduct: targetProduct,
                sourceComponent: screenName || (0, $1TEMI.WAC_GENERIC_TOUCHPOINT_NAME),
                sourceContext: interactionName,
                extensions: extensions
            });
        } catch (error) {
            const errorData = error;
            fireOperationalEvent({
                action: "failed",
                actionSubject: "crossFlowRequest",
                attributes: {
                    errorMessage: errorData === null || errorData === void 0 ? void 0 : errorData.message,
                    errorStack: errorData === null || errorData === void 0 ? void 0 : errorData.stack,
                    url: url
                }
            });
            (0, $1TEMI.redirectToDefaultUrl)(url, fireRedirectSuccessEvent, fireRedirectFailedEvent);
        }
    }, [
        productKey,
        redirectUrl,
        edition,
        fireInteractionEvent,
        crossFlow,
        fireOperationalEvent,
        screenName,
        interactionName,
        fireRedirectSuccessEvent,
        fireRedirectFailedEvent
    ]);
    return openCrossFlow;
};

});

parcelRegister("hetvO", function(module, exports) {

$parcel$export(module.exports, "useCrossFlowFrontendTouchpointComponentViewed", function () { return $3cde185f9bb3d915$export$cffac58b53c8fc88; });

var $iSvIT = parcelRequire("iSvIT");

var $1TEMI = parcelRequire("1TEMI");
const $3cde185f9bb3d915$export$cffac58b53c8fc88 = ({ screenName: screenName, productKey: productKey, fireOnMount: fireOnMount, edition: edition })=>{
    const { fireCrossFlowViewedUIEvent: fireCrossFlowViewedUIEvent, fireUIEvent: fireUIEvent } = (0, $1TEMI.useFireEvent)({
        productKey: productKey,
        fireOnMount: fireOnMount,
        edition: edition
    });
    const onCrossFlowComponentViewed = (0, $iSvIT.useCallback)(({ componentType: componentType = "button", componentName: componentName })=>{
        if (componentName && screenName && productKey) fireCrossFlowViewedUIEvent({
            action: "viewed",
            actionSubject: componentType,
            actionSubjectId: componentName
        }, {
            source: screenName,
            recommendedProductIds: [
                productKey
            ]
        });
        else fireUIEvent({
            action: "viewed",
            actionSubject: (0, $1TEMI.WAC_GENERIC_TOUCHPOINT_COMPONENT_NAME)
        });
    }, [
        fireCrossFlowViewedUIEvent,
        fireUIEvent,
        productKey,
        screenName
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (fireOnMount) onCrossFlowComponentViewed({});
    }, [
        onCrossFlowComponentViewed,
        fireOnMount
    ]);
    return onCrossFlowComponentViewed;
};

});






parcelRegister("b49hK", function(module, exports) {

$parcel$export(module.exports, "CTA_URL_PATH", function () { return $51d399db3476ba7f$export$d5587a12d9eea1dc; });
const $51d399db3476ba7f$export$d5587a12d9eea1dc = "/collections/strategy#contact";

});


parcelRegister("a4JY7", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionNavbar", function () { return $d8f13c7e7c4f9ba4$export$21a8ade06194f818; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");

var $lCocY = parcelRequire("lCocY");
const $d8f13c7e7c4f9ba4$export$21a8ade06194f818 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $lCocY.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("lCocY", function(module, exports) {

$parcel$export(module.exports, "CTA_URL_PATH", function () { return $753242cc13657a15$export$d5587a12d9eea1dc; });
const $753242cc13657a15$export$d5587a12d9eea1dc = "/collections/service#contact";

});


parcelRegister("8PL6n", function(module, exports) {

$parcel$export(module.exports, "TeamworkCollectionNavbar", function () { return $f02da071f5e993e4$export$693b523fb4eb0711; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");
const $f02da071f5e993e4$export$693b523fb4eb0711 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: "/collections/teamwork#contact"
        })
    });
};

});

parcelRegister("bwE7U", function(module, exports) {

$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3f60c9aa58855bbf$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3f60c9aa58855bbf$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");
const $3f60c9aa58855bbf$var$logoWrapperStyles = null;
const $3f60c9aa58855bbf$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3f60c9aa58855bbf$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $f6qj2.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive == "success",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: (0, $3FBn4.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3f60c9aa58855bbf$export$2e2bcd8739ae039 = $3f60c9aa58855bbf$export$e36ad2737327f9c;

});

parcelRegister("gxFZp", function(module, exports) {

$parcel$export(module.exports, "BitbucketNav", function () { return $3fabb197901cb5ca$export$374e7235418bdbdb; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5netJ = parcelRequire("5netJ");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $8ltM2 = parcelRequire("8ltM2");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("3aCqg");
var $44Pau = parcelRequire("44Pau");
const $3fabb197901cb5ca$var$BitbucketLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5netJ.BitbucketLogo), {
        appearance: "brand"
    });
};
const $3fabb197901cb5ca$export$374e7235418bdbdb = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=bitbucket&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $8ltM2.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $iFd5d.ProductKeys).BITBUCKET,
        edition: (0, $iFd5d.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $3FBn4.useLocalizedHref)("/software/bitbucket/enterprise/data-center");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/bitbucket/pricing");
    const links = [
        {
            globalLinksKey: "whyBitbucket",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.whyBitbucket",
                defaultMessage: "Why Bitbucket"
            }),
            productKey: "bitbucket",
            hasSubnav: true,
            dropdownType: "why-bitbucket"
        },
        {
            globalLinksKey: "self-hosted",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.selfhosted",
                defaultMessage: "Self-Hosted"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: dataCenterHref
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productKey: "bitbucket",
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3fabb197901cb5ca$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.bitbucket-logo",
                defaultMessage: "Bitbucket logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3fabb197901cb5ca$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "whyBitbucket",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.whyBitbucket",
                        defaultMessage: "Why Bitbucket"
                    }),
                    containerStyles: {
                        width: "fit-content",
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $44Pau.WhyBitbucketSubnav), {
                        productKey: "bitbucket"
                    })
                },
                {
                    globalLinksKey: "self-hosted",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.selfhosted",
                        defaultMessage: "Self-Hosted"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: dataCenterHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-bitbucket",
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("5netJ", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogo", function () { return $3e9a54e2937c19ed$export$bd40525f5333524b; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $3e9a54e2937c19ed$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n        <path fill='.concat(colors.iconColor, ' d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>\n        <path fill=').concat(colors.textColor, ' d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>\n      </svg>');
};
var $3e9a54e2937c19ed$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3e9a54e2937c19ed$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3aCqg", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return (parcelRequire("gxFZp")).BitbucketNav; });
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return (parcelRequire("44Pau")).WhyBitbucketSubnav; });
parcelRequire("gxFZp");
parcelRequire("44Pau");

});
parcelRegister("44Pau", function(module, exports) {

$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $9633d059a3ed42d2$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $3XIdt = parcelRequire("3XIdt");

var $baj2f = parcelRequire("baj2f");

var $jGfor = parcelRequire("jGfor");

var $hbBKK = parcelRequire("hbBKK");
function $9633d059a3ed42d2$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: "solution",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.solution",
                defaultMessage: "Solution"
            }),
            items: [
                {
                    id: "ci-cd",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.work-management",
                        defaultMessage: "CI/CD"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/pipelines")
                },
                {
                    id: "cloud-security",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.cloud-security",
                        defaultMessage: "Cloud Security"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                },
                {
                    id: "dev-sec-ops",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.dev-sec-ops",
                        defaultMessage: "DevSecOps"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/devsecops")
                },
                {
                    id: "code-review",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.it-service-management",
                        defaultMessage: "Code Review"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/code-review")
                },
                {
                    id: "jira-integrations",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.agile-devops",
                        defaultMessage: "Jira Integrations"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/bitbucket-integration")
                }
            ]
        },
        plans: {
            id: "plans",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.plans",
                defaultMessage: "Plans"
            }),
            items: [
                {
                    id: "bitbucket-cloud-premium",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium",
                        defaultMessage: "Bitbucket Cloud Premium"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/premium")
                }
            ]
        }
    };
}
const $9633d059a3ed42d2$export$7b115720fff1fb0d = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $f6qj2.default)();
    const bitbucketLinks = $9633d059a3ed42d2$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bfhk1rga"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});



parcelRegister("hDoR2", function(module, exports) {

$parcel$export(module.exports, "CompassNav", function () { return $b48207cde0746e41$export$78e93448314ae49; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $7JG5H = parcelRequire("7JG5H");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $8ltM2 = parcelRequire("8ltM2");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $b48207cde0746e41$var$CompassLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $7JG5H.CompassLogo), {
        appearance: "brand"
    });
};
const $b48207cde0746e41$export$78e93448314ae49 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=compass&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $8ltM2.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $iFd5d.ProductKeys).COMPASS,
        edition: (0, $iFd5d.Editions).FREE,
        redirectUrl: signupLink
    });
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/compass/pricing");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b48207cde0746e41$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "CompassPageTemplate.navbar.compass-logo",
                defaultMessage: "Compass logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b48207cde0746e41$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: (0, $3FBn4.useLocalizedHref)("/software/compass/features")
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-compass",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: (0, $3FBn4.useLocalizedHref)("/software/compass/features")
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: pricingHref
                        }
                    ]
                }
            ]
        })
    });
};

});
parcelRegister("7JG5H", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", function () { return $5a1d62c42d86e741$export$eb7d748e4f9c9676; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $5a1d62c42d86e741$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n    <path fill='.concat(colors.iconColor, ' d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>\n    <path fill="').concat(colors.textColor, '" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n  </svg>');
};
var $5a1d62c42d86e741$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5a1d62c42d86e741$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("kGZng", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f35bf8f5229d6dee$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $2lKjb = parcelRequire("2lKjb");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $8ltM2 = parcelRequire("8ltM2");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $9g0oR = parcelRequire("9g0oR");

var $gAJUc = parcelRequire("gAJUc");
const $f35bf8f5229d6dee$var$ConfluenceLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "confluence",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lKjb.ConfluenceLogo), {
        appearance: "brand"
    });
};
const $f35bf8f5229d6dee$var$ConfluenceSoftwareNav = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=confluence&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $8ltM2.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $iFd5d.ProductKeys).CONFLUENCE,
        edition: (0, $iFd5d.Editions).FREE,
        redirectUrl: signupLink
    });
    const templateCategoriesShown = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).confluenceTemplatesDxpMigration);
    const templatesHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/templates");
    const templatesDropdown = (0, $iSvIT.useMemo)(()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
            contentSections: [
                {
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.allTemplates",
                                defaultMessage: "All templates"
                            }),
                            href: "/software/confluence/templates"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.design",
                                defaultMessage: "Design"
                            }),
                            href: "/software/confluence/templates/categories/design"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.financeAndOperations",
                                defaultMessage: "Finance & Ops"
                            }),
                            href: "/software/confluence/templates/categories/finance-and-operations"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.humanResources",
                                defaultMessage: "Human Resources"
                            }),
                            href: "/software/confluence/templates/categories/human-resources"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.marketingAndSales",
                                defaultMessage: "Marketing & Sales"
                            }),
                            href: "/software/confluence/templates/categories/marketing-and-sales"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.productManagement",
                                defaultMessage: "Product Management"
                            }),
                            href: "/software/confluence/templates/categories/product-management"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.projectManagement",
                                defaultMessage: "Project Management"
                            }),
                            href: "/software/confluence/templates/categories/project-management"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.recommended",
                                defaultMessage: "Recommended"
                            }),
                            href: "/software/confluence/templates/categories/recommended"
                        },
                        {
                            text: intl.formatMessage({
                                id: "confluence.TemplateCategoriesDropdown.softwareDevelopmentAndIt",
                                defaultMessage: "Software & IT"
                            }),
                            href: "/software/confluence/templates/categories/software-development-and-it"
                        }
                    ]
                }
            ]
        }), [
        intl
    ]);
    const templatesLinkContent = (0, $iSvIT.useMemo)(()=>{
        const common = {
            globalLinksKey: "templates",
            linkText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.navbar.templates",
                defaultMessage: "Templates"
            }),
            productKey: "confluence"
        };
        return templateCategoriesShown ? (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: true,
            // TODO: replace with TemplateCategoriesDropdown to have dynamic categories
            content: templatesDropdown,
            dropdownType: "templates",
            containerPosition: "relative"
        }) : (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: false,
            href: templatesHref
        });
    }, [
        templateCategoriesShown,
        templatesHref,
        intl,
        templatesDropdown
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-confluenceSoftwareNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: (0, $3FBn4.useLocalizedHref)("/software/confluence"),
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($f35bf8f5229d6dee$var$ConfluenceLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.navbar.confluence-logo",
                defaultMessage: "Confluence logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.navbar.getitfree",
                defaultMessage: "Get it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.navbar.getitfree",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($f35bf8f5229d6dee$var$ConfluenceLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "ConfluenceSoftwarePageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "confluence",
                    href: (0, $3FBn4.useLocalizedHref)("/software/confluence/features")
                },
                {
                    globalLinksKey: "resources",
                    linkText: intl.formatMessage({
                        id: "ConfluenceSoftwarePageTemplate.navbar.resources",
                        defaultMessage: "Resources"
                    }),
                    hasSubnav: false,
                    productKey: "confluence",
                    href: (0, $3FBn4.useLocalizedHref)("/software/confluence/resources")
                },
                templatesLinkContent,
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "ConfluenceSoftwarePageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "confluence",
                    href: (0, $3FBn4.useLocalizedHref)("/software/confluence/pricing")
                },
                {
                    globalLinksKey: "enterprise",
                    linkText: intl.formatMessage({
                        id: "ConfluenceSoftwarePageTemplate.navbar.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    hasSubnav: false,
                    productKey: "confluence",
                    href: (0, $3FBn4.useLocalizedHref)("/software/confluence/enterprise")
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-confluence",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "ConfluenceSoftwarePageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "confluence",
                            href: (0, $3FBn4.useLocalizedHref)("/software/confluence/features")
                        },
                        {
                            globalLinksKey: "resources",
                            linkText: intl.formatMessage({
                                id: "ConfluenceSoftwarePageTemplate.navbar.resources",
                                defaultMessage: "Resources"
                            }),
                            hasSubnav: false,
                            productKey: "confluence",
                            href: (0, $3FBn4.useLocalizedHref)("/software/confluence/resources")
                        },
                        templatesLinkContent,
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "ConfluenceSoftwarePageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "confluence",
                            href: (0, $3FBn4.useLocalizedHref)("/software/confluence/pricing")
                        },
                        {
                            globalLinksKey: "enterprise",
                            linkText: intl.formatMessage({
                                id: "ConfluenceSoftwarePageTemplate.navbar.enterprise",
                                defaultMessage: "Enterprise"
                            }),
                            hasSubnav: false,
                            productKey: "confluence",
                            href: (0, $3FBn4.useLocalizedHref)("/software/confluence/enterprise")
                        }
                    ]
                }
            ],
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "templates",
                    menuPageObjects: templatesLinkContent === null || templatesLinkContent === void 0 ? void 0 : templatesLinkContent.content
                }
            ]
        })
    });
};
$f35bf8f5229d6dee$var$ConfluenceSoftwareNav.displayName = "ConfluenceSoftwareNav";
var $f35bf8f5229d6dee$export$2e2bcd8739ae039 = $f35bf8f5229d6dee$var$ConfluenceSoftwareNav;

});

parcelRegister("lGc56", function(module, exports) {

$parcel$export(module.exports, "SharedHeaderFooterContainer", function () { return $eec4caa6e59cf8ea$export$93790172861f3d8b; });
$parcel$export(module.exports, "ConfluenceTemplateHeaderContainer", function () { return $eec4caa6e59cf8ea$export$715c042529a2f5fe; });
/* shared-header-footer-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $bi0vu = parcelRequire("bi0vu");
parcelRequire("gkV6l");
var $5ZKRm = parcelRequire("5ZKRm");

var $4himv = parcelRequire("4himv");

var $kex29 = parcelRequire("kex29");

var $kGZng = parcelRequire("kGZng");
const $eec4caa6e59cf8ea$var$minHeight = null;
const $eec4caa6e59cf8ea$export$93790172861f3d8b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1tke8stt"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $bi0vu.CrossFlowTouchpointProvider), {
            productKeys: [
                (0, $iFd5d.ProductKeys).CONFLUENCE
            ],
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $kGZng.default), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4himv.SitesContextProvider), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZKRm.SiteSelectorContextProvider), {
                        productKey: (0, $iFd5d.ProductKeys).CONFLUENCE,
                        analyticsPrefix: "wac.showroom",
                        internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
            ]
        })
    });
};
const $eec4caa6e59cf8ea$export$715c042529a2f5fe = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bi0vu.CrossFlowTouchpointProvider), {
        productKeys: [
            (0, $iFd5d.ProductKeys).CONFLUENCE
        ],
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4himv.SitesContextProvider), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZKRm.SiteSelectorContextProvider), {
                productKey: (0, $iFd5d.ProductKeys).CONFLUENCE,
                analyticsPrefix: "wac.showroom",
                internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kGZng.default), {})
            })
        })
    });
};

});
parcelRegister("gkV6l", function(module, exports) {
$parcel$export(module.exports, "SiteSelectorContextProvider", function () { return (parcelRequire("5ZKRm")).SiteSelectorContextProvider; });
$parcel$export(module.exports, "useSiteSelectorContext", function () { return (parcelRequire("5ZKRm")).useSiteSelectorContext; });
parcelRequire("3upvw");
parcelRequire("gTyVo");
parcelRequire("5ZKRm");

});
parcelRegister("3upvw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0219cdf54f4e8ec1$export$2e2bcd8739ae039; });
/* site-selector-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $8KELJ = parcelRequire("8KELJ");
var $bh8PA = parcelRequire("bh8PA");

var $gTyVo = parcelRequire("gTyVo");
const $0219cdf54f4e8ec1$var$SiteSelectorModal = ({ isOpen: isOpen, userName: userName, userEmail: userEmail, avatarSrc: avatarSrc, sites: sites, header: header, onNewSiteSelected: onNewSiteSelected, onSiteSelected: onSiteSelected, onSwitchAccountClick: onSwitchAccountClick, onSiteChanged: onSiteChanged, onModalClose: onModalClose })=>{
    const onClose = ()=>{
        if (onModalClose) onModalClose();
    };
    const onChange = ()=>{
        if (onSiteChanged) onSiteChanged();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bh8PA.default), {
        children: isOpen && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8KELJ.default), {
            onClose: onClose,
            label: "Site Selector Modal",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pkqslr _2hwxqslr _otyrqslr _18u0qslr"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gTyVo.default), {
                    userName: userName,
                    userEmail: userEmail,
                    avatarSrc: avatarSrc,
                    sites: sites,
                    header: header,
                    onNewSiteSelected: onNewSiteSelected,
                    onSiteSelected: onSiteSelected,
                    onSwitchAccountClick: onSwitchAccountClick,
                    onCancelClick: onClose,
                    onSiteChanged: onChange
                })
            })
        })
    });
};
var $0219cdf54f4e8ec1$export$2e2bcd8739ae039 = $0219cdf54f4e8ec1$var$SiteSelectorModal;
const $0219cdf54f4e8ec1$var$containerStyle = null;

});
parcelRegister("gTyVo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $193186f53c0afb6d$export$2e2bcd8739ae039; });
/* site-selector-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $gFAaC = parcelRequire("gFAaC");

var $geeeO = parcelRequire("geeeO");

var $js0jV = parcelRequire("js0jV");
const $193186f53c0afb6d$var$SiteSelectorView = ({ userName: userName, userEmail: userEmail, sites: sites, avatarSrc: avatarSrc, header: header, onNewSiteSelected: onNewSiteSelected, onSiteSelected: onSiteSelected, onSwitchAccountClick: onSwitchAccountClick, onCancelClick: onCancelClick, onSiteChanged: onSiteChanged, fullScreenView: fullScreenView })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ect41wi2"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ect4q6fz"
                ]),
                children: header !== undefined ? header : /*#__PURE__*/ (0, $loA2J.jsx)((0, $geeeO.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pkgktf _2hwxidpf _otyrgktf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gFAaC.default), {
                    userName: userName,
                    userEmail: userEmail,
                    avatarSrc: avatarSrc
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $js0jV.default), {
                    sites: sites,
                    onNewSiteSelected: onNewSiteSelected,
                    onSiteSelected: onSiteSelected,
                    onSwitchAccountClick: onSwitchAccountClick,
                    onCancelClick: onCancelClick,
                    onSiteChanged: onSiteChanged,
                    fullScreenView: fullScreenView
                })
            })
        ]
    });
};
const $193186f53c0afb6d$var$rootContainerStyle = null;
const $193186f53c0afb6d$var$headerStyle = null;
const $193186f53c0afb6d$var$avatarContainerStyle = null;
var $193186f53c0afb6d$export$2e2bcd8739ae039 = $193186f53c0afb6d$var$SiteSelectorView;

});
parcelRegister("gFAaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93645df0d294af6$export$2e2bcd8739ae039; });
/* account-details.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $fN3OO = parcelRequire("fN3OO");
var $objBZ = parcelRequire("objBZ");

var $3fSeD = parcelRequire("3fSeD");
const $a93645df0d294af6$var$AccountDetails = ({ userName: userName, userEmail: userEmail, avatarSrc: avatarSrc })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $fN3OO.default), {
        avatar: avatarSrc !== undefined ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $objBZ.default), {
            src: avatarSrc
        }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bsbzwfg _4t3izwfg _2rko1ssb _bfhkj1oc"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _ect41wi2 _1wyb19bv _vwz419bv _syazvwuj _1bsb1osq _4t3i1osq _bfhkj1oc _2rko1ssb"
                ]),
                children: (0, $3fSeD.getInitials)(userName)
            })
        }),
        primaryText: userName,
        secondaryText: userEmail
    }, userEmail);
const $a93645df0d294af6$var$initialsStyle = null;
const $a93645df0d294af6$var$initialsContainerStyle = null;
var $a93645df0d294af6$export$2e2bcd8739ae039 = $a93645df0d294af6$var$AccountDetails;

});
parcelRegister("fN3OO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7ee64ec1f6abf4f$export$2e2bcd8739ae039; });

var $3Zjy3 = parcelRequire("3Zjy3");

var $1WC6C = parcelRequire("1WC6C");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $hjKal = parcelRequire("hjKal");

var $6WQop = parcelRequire("6WQop");

var $bfeSi = parcelRequire("bfeSi");

var $5gK32 = parcelRequire("5gK32");

var $6ajuI = parcelRequire("6ajuI");
var $b7ee64ec1f6abf4f$var$_templateObject;
function $b7ee64ec1f6abf4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7ee64ec1f6abf4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7ee64ec1f6abf4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3Zjy3.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7ee64ec1f6abf4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b7ee64ec1f6abf4f$var$avatarItemStyles = (0, $2ZUkg.css)({
    minWidth: 0,
    maxWidth: "100%",
    flex: "1 1 100%",
    lineHeight: "1.4",
    paddingInlineStart: "var(--ds-space-100, 8px)"
});
var $b7ee64ec1f6abf4f$var$getStyles = function getStyles(css, _ref) {
    var backgroundColor = _ref.backgroundColor, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($b7ee64ec1f6abf4f$var$_templateObject || ($b7ee64ec1f6abf4f$var$_templateObject = (0, $1WC6C.default)([
        "\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    border: ",
        "px solid transparent;\n    box-sizing: border-box;\n    color: inherit;\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    outline: none;\n    margin: ",
        ";\n    padding: ",
        ";\n    text-align: left;\n    text-decoration: none;\n    width: 100%;\n\n    ",
        "\n\n    ",
        "\n  "
    ])), backgroundColor, (0, $6WQop.borderRadius)(), (0, $bfeSi.BORDER_WIDTH), "var(--ds-space-0, 0px)", "var(--ds-space-050, 4px)", isInteractive && "\n        :hover {\n          background-color: ".concat("var(--ds-background-neutral-subtle-hovered, ".concat((0, $hjKal.N30), ")"), ";\n          cursor: pointer;\n          text-decoration: none;\n        }\n\n        :focus {\n          outline: none;\n          border-color: ", "var(--ds-border-focused, ".concat((0, $hjKal.B200), ")"), ";\n        }\n\n        :active {\n          background-color: ", "var(--ds-background-neutral-subtle-pressed, ".concat((0, $hjKal.B50), ")"), ";\n        }\n      "), isDisabled && "\n        cursor: not-allowed;\n        opacity: ".concat("var(--ds-opacity-disabled, 0.5)", ";\n        pointer-events: none;\n      "));
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ var $b7ee64ec1f6abf4f$var$AvatarItem = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var avatar = _ref2.avatar, _ref2$backgroundColor = _ref2.backgroundColor, backgroundColor = _ref2$backgroundColor === void 0 ? "transparent" : _ref2$backgroundColor, children = _ref2.children, isTruncationDisabled = _ref2.isTruncationDisabled, href = _ref2.href, isDisabled = _ref2.isDisabled, onClick = _ref2.onClick, primaryText = _ref2.primaryText, secondaryText = _ref2.secondaryText, target = _ref2.target, testId = _ref2.testId, label = _ref2.label;
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            "data-testid": "".concat(testId, "--itemInner")
        } : {
            testId: "".concat(testId, "--itemInner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $b7ee64ec1f6abf4f$var$_objectSpread($b7ee64ec1f6abf4f$var$_objectSpread({}, href && (0, $6ajuI.getLinkProps)(href, target)), onClick && !href ? (0, $6ajuI.getButtonProps)(onClick) : {
            onClick: onClick
        });
    };
    return (0, $2ZUkg.jsx)((0, $2ZUkg.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $b7ee64ec1f6abf4f$var$_objectSpread($b7ee64ec1f6abf4f$var$_objectSpread($b7ee64ec1f6abf4f$var$_objectSpread($b7ee64ec1f6abf4f$var$_objectSpread({
            ref: ref,
            className: $b7ee64ec1f6abf4f$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (onClick || href) && {
            "aria-label": label
        }), {}, {
            children: (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, avatar, (0, $2ZUkg.jsx)("div", {
                css: $b7ee64ec1f6abf4f$var$avatarItemStyles
            }, (0, $2ZUkg.jsx)((0, $5gK32.default), {
                shouldTruncate: !isTruncationDisabled
            }, primaryText), (0, $2ZUkg.jsx)((0, $5gK32.default), {
                isSecondary: true,
                shouldTruncate: !isTruncationDisabled
            }, secondaryText)))
        });
        return children ? children(props) : /*#__PURE__*/ (0, $iSvIT.createElement)((0, $6ajuI.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$b7ee64ec1f6abf4f$var$AvatarItem.displayName = "AvatarItem";
var $b7ee64ec1f6abf4f$export$2e2bcd8739ae039 = $b7ee64ec1f6abf4f$var$AvatarItem;

});
parcelRegister("5gK32", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d622a8c34b0301f$export$2e2bcd8739ae039; });
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2ZUkg = parcelRequire("2ZUkg");

var $hjKal = parcelRequire("hjKal");
var $3d622a8c34b0301f$var$baseStyles = (0, $2ZUkg.css)({
    display: "block",
    margin: "var(--ds-space-0, 0px)",
    color: "var(--ds-text, ".concat((0, $hjKal.N900), ")")
});
var $3d622a8c34b0301f$var$truncateStyles = (0, $2ZUkg.css)({
    overflowX: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $3d622a8c34b0301f$var$secondaryStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $hjKal.N200), ")"),
    fontSize: "0.85em"
});
/**
 * __Text__
 *
 * Text is used internally only.
 */ var $3d622a8c34b0301f$var$Text = function Text(_ref) {
    var isSecondary = _ref.isSecondary, children = _ref.children, shouldTruncate = _ref.shouldTruncate;
    return (0, $2ZUkg.jsx)("span", {
        css: [
            $3d622a8c34b0301f$var$baseStyles,
            isSecondary && $3d622a8c34b0301f$var$secondaryStyles,
            shouldTruncate && $3d622a8c34b0301f$var$truncateStyles
        ]
    }, children);
};
var $3d622a8c34b0301f$export$2e2bcd8739ae039 = $3d622a8c34b0301f$var$Text;

});


parcelRegister("3fSeD", function(module, exports) {

$parcel$export(module.exports, "getInitials", function () { return $e3e1799a2ad56492$export$de9bdbce6502b027; });
function $e3e1799a2ad56492$export$de9bdbce6502b027(fullName) {
    return fullName.split(/[^\w]+/).reduce((result, part)=>{
        var _part_;
        if (result.length < 3 && part.length > 0) return result + ((_part_ = part[0]) === null || _part_ === void 0 ? void 0 : _part_.toUpperCase());
        else return result;
    }, "");
}

});


parcelRegister("geeeO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f07f0dc737b4293$export$2e2bcd8739ae039; });
//@ts-nocheck

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $a6bec = parcelRequire("a6bec");
const $1f07f0dc737b4293$var$DefaultHeader = ()=>{
    const intl = (0, $f6qj2.default)();
    const logoLabel = intl.formatMessage({
        id: "SiteSelectorModal.atlassianLogoLabel",
        defaultMessage: "Atlassian logo"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $a6bec.AtlassianLogo), {
        size: "medium",
        label: logoLabel
    });
};
var $1f07f0dc737b4293$export$2e2bcd8739ae039 = $1f07f0dc737b4293$var$DefaultHeader;

});
parcelRegister("a6bec", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", function () { return $75a32c8fa8428738$export$765cacec8b0843f3; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $75a32c8fa8428738$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">\n      <path fill='.concat(colors.iconColor, ' d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>\n      <path fill=').concat(colors.atlassianLogoTextColor, ' d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>\n    </svg>');
};
var $75a32c8fa8428738$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $75a32c8fa8428738$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("js0jV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65e66612367c4a55$export$2e2bcd8739ae039; });
//@ts-nocheck

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $6oKbD = parcelRequire("6oKbD");

var $jQpzH = parcelRequire("jQpzH");

var $91dew = parcelRequire("91dew");
const $65e66612367c4a55$var$SiteSelectorForm = ({ sites: sites, onNewSiteSelected: onNewSiteSelected, onSiteSelected: onSiteSelected, onSwitchAccountClick: onSwitchAccountClick, onCancelClick: onCancelClick, onSiteChanged: onSiteChanged, fullScreenView: fullScreenView })=>{
    const handleFormSubmit = (data)=>{
        if (!data.site || data.site === "") onNewSiteSelected();
        else onSiteSelected(data.site);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: handleFormSubmit,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                name: "site-selector",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $91dew.default), {
                        sites: sites,
                        onSiteChanged: onSiteChanged
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jQpzH.default), {
                        canSubmit: !submitting,
                        onSwitchAccountClick: onSwitchAccountClick,
                        onCancelClick: onCancelClick,
                        fullScreenView: fullScreenView
                    })
                ]
            }))
    });
};
var $65e66612367c4a55$export$2e2bcd8739ae039 = $65e66612367c4a55$var$SiteSelectorForm;

});
parcelRegister("jQpzH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dd35785bb945505$export$2e2bcd8739ae039; });
/* site-selector-form-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $6IiXU = parcelRequire("6IiXU");

var $kzsvd = parcelRequire("kzsvd");

var $jGhDi = parcelRequire("jGhDi");
const $2dd35785bb945505$var$SiteSelectorFormFooter = ({ canSubmit: canSubmit, onSwitchAccountClick: onSwitchAccountClick, onCancelClick: onCancelClick, fullScreenView: fullScreenView })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kzsvd.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1pfhftgi _kqswh2mm _1bsb1osq _1e0c1txw _1n261g80 _e8gh1yb4 _q8t51h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1o9zidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                        appearance: "link",
                        type: "button",
                        spacing: "none",
                        onClick: ()=>onSwitchAccountClick(),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "SiteSelectorModal.switchAccount",
                            defaultMessage: "Sign in with a different account"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfh7vkz _kiyaidpf _p7vbidpf _1t19kb7n _uj6kusic"
                    ]),
                    children: fullScreenView !== true ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_12l21y44 _1e0c1txw _1bahesu3"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                                appearance: "subtle",
                                type: "button",
                                onClick: ()=>onCancelClick(),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "SiteSelectorModal.cancel",
                                    defaultMessage: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_ahbq1y44"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: !canSubmit,
                                    iconAfter: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGhDi))), {
                                        label: "",
                                        size: "small"
                                    }),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "SiteSelectorModal.createPage",
                                        defaultMessage: "Create page"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                        appearance: "primary",
                        type: "submit",
                        isDisabled: !canSubmit,
                        className: (0, $esG4f.default)([
                            "_12l21y44 _1e0c1txw _1bahesu3"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "SiteSelectorModal.createPage",
                            defaultMessage: "Create page"
                        })
                    })
                })
            ]
        })
    });
};
const $2dd35785bb945505$var$actionContainerStyle = null;
const $2dd35785bb945505$var$leftActionsContainerStyle = null;
const $2dd35785bb945505$var$rightActionsContainerStyle = null;
const $2dd35785bb945505$var$inlineEndStyle = null;
const $2dd35785bb945505$var$primaryContainerStyle = null;
var $2dd35785bb945505$export$2e2bcd8739ae039 = $2dd35785bb945505$var$SiteSelectorFormFooter;

});
parcelRegister("kzsvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef9d2f8982363c32$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");
var $ef9d2f8982363c32$var$formFooterWrapperStyles = (0, $2ZUkg.css)({
    display: "flex",
    marginTop: "var(--ds-space-300, 24px)",
    justifyContent: "flex-end"
});
var $ef9d2f8982363c32$var$justifyContentStyles = (0, $2ZUkg.css)({
    justifyContent: "flex-start"
});
function $ef9d2f8982363c32$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? "end" : _ref$align, children = _ref.children;
    return (0, $2ZUkg.jsx)("footer", {
        css: [
            $ef9d2f8982363c32$var$formFooterWrapperStyles,
            align === "start" && $ef9d2f8982363c32$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("jGhDi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e53f9e177dc14b7a$var$_react = $e53f9e177dc14b7a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $e53f9e177dc14b7a$var$_linkExternal = $e53f9e177dc14b7a$var$_interopRequireDefault((parcelRequire("k4L8e")));
function $e53f9e177dc14b7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e53f9e177dc14b7a$var$ShortcutIcon = (props)=>/*#__PURE__*/ $e53f9e177dc14b7a$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $e53f9e177dc14b7a$var$_linkExternal.default
    }));
$e53f9e177dc14b7a$var$ShortcutIcon.displayName = "ShortcutIcon";
var $e53f9e177dc14b7a$var$_default = module.exports.default = $e53f9e177dc14b7a$var$ShortcutIcon;

});
parcelRegister("k4L8e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9d8bdc2729762c2$var$_react = $e9d8bdc2729762c2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e9d8bdc2729762c2$var$_baseNew = $e9d8bdc2729762c2$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e9d8bdc2729762c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9d8bdc2729762c2$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $e9d8bdc2729762c2$var$_react.default.createElement($e9d8bdc2729762c2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$e9d8bdc2729762c2$var$LinkExternalIcon.displayName = "LinkExternalIcon";
var $e9d8bdc2729762c2$var$_default = module.exports.default = $e9d8bdc2729762c2$var$LinkExternalIcon;

});



parcelRegister("91dew", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32424cd1d524b783$export$2e2bcd8739ae039; });
/* site-selector-radio-group.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $26kkA = parcelRequire("26kkA");

var $03MO9 = parcelRequire("03MO9");
const $32424cd1d524b783$var$SiteSelectorRadioGroup = ({ sites: sites, onSiteChanged: onSiteChanged })=>{
    const [state, setState] = (0, $iSvIT.useState)({
        fieldName: "",
        radioOptions: [],
        selectedSite: ""
    });
    const { fieldName: fieldName, radioOptions: radioOptions, selectedSite: selectedSite } = state;
    (0, $iSvIT.useEffect)(()=>{
        var _radioOptions_;
        const fieldName = "site";
        const radioOptions = getRadioOptions(sites, fieldName);
        const defaultValue = (_radioOptions_ = radioOptions[0]) === null || _radioOptions_ === void 0 ? void 0 : _radioOptions_.value;
        setState({
            fieldName: fieldName,
            radioOptions: radioOptions,
            selectedSite: defaultValue
        });
    }, [
        sites
    ]);
    const getRadioOptions = (sites, fieldName)=>{
        const radioOptions = sites.map((site)=>{
            // HOT-101715 fixes
            const { hostname: originalHostname, searchParams: searchParams } = new URL(site);
            let hostname = originalHostname;
            try {
                const continueVal = searchParams.get("continue");
                hostname = continueVal ? new URL(continueVal).hostname : originalHostname;
            } catch (e) {}
            return {
                name: fieldName,
                value: site,
                label: hostname
            };
        });
        // Include option to "Start a new site"
        radioOptions.push({
            name: fieldName,
            value: "",
            label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "SiteSelectorModal.startASite",
                defaultMessage: "Start a new site"
            })
        });
        return radioOptions;
    };
    const onValueChange = (event)=>{
        onSiteChanged(); // In our custom onChange handler, we need to manage the RadioGroup state in our component's state
        const newValue = event.currentTarget.getAttribute("value");
        const newSiteSelected = newValue ? newValue : undefined;
        setState((0, $6iHNw._)((0, $7Knp0._)({}, state), {
            selectedSite: newSiteSelected
        }));
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
        name: fieldName,
        label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "SiteSelectorModal.selectASite",
            defaultMessage: "Select a site"
        }),
        defaultValue: selectedSite,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_c71l4kif _18m91wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $03MO9.default), (0, $6iHNw._)((0, $7Knp0._)({}, fieldProps), {
                    options: radioOptions,
                    onChange: onValueChange
                }))
            })
    });
};
const $32424cd1d524b783$var$radioGroupStyles = null;
var $32424cd1d524b783$export$2e2bcd8739ae039 = $32424cd1d524b783$var$SiteSelectorRadioGroup;

});
parcelRegister("03MO9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00b62428ef657903$export$2e2bcd8739ae039; });

var $8Ip7y = parcelRequire("8Ip7y");

var $i2DeQ = parcelRequire("i2DeQ");

var $60IjO = parcelRequire("60IjO");

var $iSvIT = parcelRequire("iSvIT");

var $aUn4O = parcelRequire("aUn4O");

var $7Wkup = parcelRequire("7Wkup");
var $00b62428ef657903$var$noOptions = [];
function $00b62428ef657903$export$2e2bcd8739ae039(props) {
    var onChange = props.onChange, _props$options = props.options, options = _props$options === void 0 ? $00b62428ef657903$var$noOptions : _props$options, propValue = props.value, defaultValue = props.defaultValue, isDisabled = props.isDisabled, isRequired = props.isRequired, isInvalid = props.isInvalid, _props$onInvalid = props.onInvalid, onInvalid = _props$onInvalid === void 0 ? (0, $aUn4O.default) : _props$onInvalid, name = props.name, analyticsContext = props.analyticsContext, ariaLabelledBy = props["aria-labelledby"];
    var _useState = (0, $iSvIT.useState)(propValue !== undefined ? propValue : defaultValue), _useState2 = (0, $60IjO.default)(_useState, 2), selectedValue = _useState2[0], setSelectedValue = _useState2[1];
    var onRadioChange = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    var value = typeof propValue !== "undefined" ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy
    }, options.map(function(_ref, index) {
        var optionProps = (0, $i2DeQ.default)({}, ((0, $8Ip7y.default)(_ref), _ref));
        if (typeof isDisabled !== "undefined") optionProps.isDisabled = isDisabled;
        var isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7Wkup.default), (0, $i2DeQ.default)({}, optionProps, {
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        }));
    }));
}

});
parcelRegister("8Ip7y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6585eb3eb9d0b5ad$export$2e2bcd8739ae039; });
function $6585eb3eb9d0b5ad$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}

});

parcelRegister("i2DeQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d226d9d5997a9e1b$export$2e2bcd8739ae039; });
function $d226d9d5997a9e1b$export$2e2bcd8739ae039() {
    return $d226d9d5997a9e1b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d226d9d5997a9e1b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("60IjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46051ee9947a54d6$export$2e2bcd8739ae039; });

var $1gXVk = parcelRequire("1gXVk");

var $2dJKc = parcelRequire("2dJKc");

var $56Mgq = parcelRequire("56Mgq");

var $667r5 = parcelRequire("667r5");
function $46051ee9947a54d6$export$2e2bcd8739ae039(r, e) {
    return (0, $1gXVk.default)(r) || (0, $2dJKc.default)(r, e) || (0, $56Mgq.default)(r, e) || (0, $667r5.default)();
}

});
parcelRegister("1gXVk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ed5c4aaad0df6fd$export$2e2bcd8739ae039; });
function $0ed5c4aaad0df6fd$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("2dJKc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19e047846fcf894f$export$2e2bcd8739ae039; });
function $19e047846fcf894f$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("56Mgq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b82f3841bbb9861$export$2e2bcd8739ae039; });

var $gsMpC = parcelRequire("gsMpC");
function $3b82f3841bbb9861$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gsMpC.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gsMpC.default)(r, a) : void 0;
    }
}

});
parcelRegister("gsMpC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfc4d082f6c5c28a$export$2e2bcd8739ae039; });
function $bfc4d082f6c5c28a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("667r5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4709123b317bbd01$export$2e2bcd8739ae039; });
function $4709123b317bbd01$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("aUn4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f1108e413d5c6e7$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $7f1108e413d5c6e7$export$2e2bcd8739ae039() {}

});

parcelRegister("7Wkup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c7dd7f82d1b56fa$export$2e2bcd8739ae039; });

var $i2DeQ = parcelRequire("i2DeQ");

var $fkzGu = parcelRequire("fkzGu");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $a1y4y = parcelRequire("a1y4y");

var $aUn4O = parcelRequire("aUn4O");

var $4vCI7 = parcelRequire("4vCI7");

var $13fEK = parcelRequire("13fEK");

var $caUDZ = parcelRequire("caUDZ");

var $f4wU4 = parcelRequire("f4wU4");

var $ibEJ6 = parcelRequire("ibEJ6");
var $5c7dd7f82d1b56fa$var$_excluded = [
    "ariaLabel",
    "isDisabled",
    "isRequired",
    "isInvalid",
    "isChecked",
    "label",
    "mode",
    "name",
    "onChange",
    "value",
    "testId",
    "analyticsContext"
];
var $5c7dd7f82d1b56fa$var$packageName = "@atlaskit/radio";
var $5c7dd7f82d1b56fa$var$packageVersion = "5.6.10";
var $5c7dd7f82d1b56fa$var$fontFamily = (0, $f4wU4.fontFamily)();
var $5c7dd7f82d1b56fa$var$noop = (0, $aUn4O.default);
var $5c7dd7f82d1b56fa$var$labelPaddingStyles = (0, $2ZUkg.css)({
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)")
});
var $5c7dd7f82d1b56fa$var$labelStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box",
    position: "relative",
    alignItems: "flex-start",
    fontFamily: $5c7dd7f82d1b56fa$var$fontFamily,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "&[data-disabled]": {
        color: "var(--ds-text-disabled, ".concat((0, $13fEK.N80), ")"),
        cursor: "not-allowed"
    }
});
var $5c7dd7f82d1b56fa$var$lightLabelStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, ".concat((0, $13fEK.N900), ")")
});
var $5c7dd7f82d1b56fa$var$darkLabelStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, ".concat((0, $13fEK.DN600), ")")
});
var $5c7dd7f82d1b56fa$var$radioStyles = (0, $2ZUkg.css)({
    display: "flex",
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
    The circle should be 14px * 14px centred in a 24px * 24px box.
    This is inclusive of a 2px border and inner circle with 2px radius.
    There is a Chrome bug that makes the circle become an oval and the
    inner circle not be centred at various zoom levels. This bug is fixed
    in all browsers if a scale of 14/24 is applied.
  */ width: "24px",
    height: "24px",
    margin: "var(--ds-space-0, 0px)",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    backgroundColor: "var(--radio-background-color)",
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
    inner circle not be centred at various zoom levels */ border: "".concat((0, $4vCI7.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-width, 1px)" : "calc(2px * 12 / 7)", " solid var(--radio-border-color)"),
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: "none",
    outline: "none",
    /*
    Change the variables --radio-background-color, --radio-border-color,
    -radio-dot-color and -radio-dot-opacity according to user interactions.
    All other variables are constant
  */ "--radio-background-color": "var(--local-background)",
    "--radio-border-color": "var(--local-border)",
    "--radio-dot-color": "var(--local-dot-checked)",
    "--radio-dot-opacity": 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: "scale(calc(7 / 12))",
    transition: "border-color 0.2s ease-in-out, background-color 0.2s ease-in-out",
    verticalAlign: "top",
    WebkitAppearance: "none",
    "&::after": {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: "calc(4px * 12 / 7)",
        height: "calc(4px * 12 / 7)",
        position: "absolute",
        background: "var(--radio-dot-color)",
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: "var(--radio-dot-opacity)",
        transition: "background-color 0.2s ease-in-out, opacity 0.2s ease-in-out"
    },
    "&:hover": {
        "--radio-background-color": "var(--local-background-hover)",
        "--radio-border-color": "var(local-border-hover)"
    },
    "&:active": {
        "--radio-background-color": "var(--local-background-active)"
    },
    "&:focus": {
        "--radio-border-color": "var(--local-border-focus)"
    },
    "&:checked": {
        "--radio-background-color": "var(--local-background-checked)",
        "--radio-border-color": "var(--local-background-checked)",
        "--radio-dot-opacity": 1
    },
    "&:checked:hover": {
        "--radio-background-color": "var(--local-background-checked-hover)",
        "--radio-border-color": "var(--local-background-checked-hover)"
    },
    "&:checked:active": {
        "--radio-background-color": "var(--local-background-checked-active)",
        "--radio-border-color": "var(--local-border-hover)",
        "--radio-dot-color": "var(--local-dot-active)"
    },
    "&:checked:focus": {
        "--radio-border-color": "var(--local-border-focus)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "&[data-invalid], &:checked[data-invalid]": {
        "--radio-border-color": "var(--local-invalid)"
    },
    "&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]": {
        cursor: "not-allowed",
        "--radio-background-color": "var(--local-background-disabled)",
        "--radio-border-color": "var(--local-border-disabled)",
        "--radio-dot-color": "var(--local-dot-disabled)"
    }
});
var $5c7dd7f82d1b56fa$var$RadioWithMode = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function Radio(props, ref) {
    var ariaLabel = props.ariaLabel, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, isRequired = props.isRequired, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isChecked = props.isChecked, isChecked = _props$isChecked === void 0 ? false : _props$isChecked, label = props.label, mode = props.mode, name = props.name, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? $5c7dd7f82d1b56fa$var$noop : _props$onChange, value = props.value, testId = props.testId, analyticsContext = props.analyticsContext, rest = (0, $fkzGu.default)(props, $5c7dd7f82d1b56fa$var$_excluded);
    var onChangeAnalytics = (0, $a1y4y.usePlatformLeafEventHandler)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "radio",
        packageName: $5c7dd7f82d1b56fa$var$packageName,
        packageVersion: $5c7dd7f82d1b56fa$var$packageVersion
    });
    var radioCustomProperties = (0, $iSvIT.useMemo)(function() {
        return (0, $2ZUkg.css)((0, $ibEJ6.default)(mode));
    }, [
        mode
    ]);
    return (0, $2ZUkg.jsx)("label", {
        "data-testid": testId && "".concat(testId, "--radio-label"),
        "data-disabled": isDisabled ? "true" : undefined,
        css: [
            $5c7dd7f82d1b56fa$var$labelStyles,
            mode === "light" ? $5c7dd7f82d1b56fa$var$lightLabelStyles : $5c7dd7f82d1b56fa$var$darkLabelStyles
        ]
    }, (0, $2ZUkg.jsx)("input", (0, $i2DeQ.default)({}, rest, {
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && "".concat(testId, "--radio-input"),
        "data-invalid": isInvalid ? "true" : undefined,
        css: [
            $5c7dd7f82d1b56fa$var$radioStyles,
            radioCustomProperties
        ],
        ref: ref
    })), label ? (0, $2ZUkg.jsx)("span", {
        css: $5c7dd7f82d1b56fa$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ var $5c7dd7f82d1b56fa$var$Radio = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function Radio(props, ref) {
    return (0, $2ZUkg.jsx)((0, $caUDZ.default).Consumer, null, function(_ref) {
        var mode = _ref.mode;
        return (0, $2ZUkg.jsx)($5c7dd7f82d1b56fa$var$RadioWithMode, (0, $i2DeQ.default)({}, props, {
            ref: ref,
            mode: mode
        }));
    });
}));
var $5c7dd7f82d1b56fa$export$2e2bcd8739ae039 = $5c7dd7f82d1b56fa$var$Radio;

});
parcelRegister("fkzGu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b294676afa724632$export$2e2bcd8739ae039; });

var $bOR0g = parcelRequire("bOR0g");
function $b294676afa724632$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $bOR0g.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("bOR0g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89ad7a8c3dcf6a5a$export$2e2bcd8739ae039; });
function $89ad7a8c3dcf6a5a$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("4vCI7", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $348815ce1f7967a3$export$470e5c2be1411c89; });

var $lOVSG = parcelRequire("lOVSG");
function $348815ce1f7967a3$export$ba05d765b8392e5e(flagResolver) {
    (0, $lOVSG.setBooleanResolver)(flagResolver);
}
function $348815ce1f7967a3$export$470e5c2be1411c89(name) {
    return (0, $lOVSG.resolveBooleanFlag)(name);
}

});
parcelRegister("lOVSG", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $fe2b2a6fb04deccd$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $fe2b2a6fb04deccd$export$6333b6aff9fc6275; });

var $hmXxK = parcelRequire("hmXxK");

var $XAEGR = parcelRequire("XAEGR");
var $fe2b2a6fb04deccd$var$pkgName = "@atlaskit/platform-feature-flags";
var $fe2b2a6fb04deccd$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $fe2b2a6fb04deccd$var$hasProcessEnv = typeof $XAEGR !== "undefined" && typeof $XAEGR.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $fe2b2a6fb04deccd$var$ENV_ENABLE_PLATFORM_FF = $fe2b2a6fb04deccd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $fe2b2a6fb04deccd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $fe2b2a6fb04deccd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $fe2b2a6fb04deccd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $fe2b2a6fb04deccd$var$ENV_ENABLE_PLATFORM_FF || $fe2b2a6fb04deccd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $fe2b2a6fb04deccd$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $fe2b2a6fb04deccd$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$fe2b2a6fb04deccd$var$globalVar[$fe2b2a6fb04deccd$export$7e41b1b2bdee3f98] = $fe2b2a6fb04deccd$var$globalVar[$fe2b2a6fb04deccd$export$7e41b1b2bdee3f98] || $fe2b2a6fb04deccd$var$DEFAULT_PFF_GLOBAL;
function $fe2b2a6fb04deccd$export$f2b591175b3e424c(resolver) {
    $fe2b2a6fb04deccd$var$globalVar[$fe2b2a6fb04deccd$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $fe2b2a6fb04deccd$export$6333b6aff9fc6275(flagKey) {
    if ($fe2b2a6fb04deccd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $hmXxK.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $fe2b2a6fb04deccd$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $fe2b2a6fb04deccd$var$globalVar[$fe2b2a6fb04deccd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("hmXxK", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $ca52adcdf3e0d989$export$1c9f709888824e05; });
var $ca52adcdf3e0d989$var$_ref, $ca52adcdf3e0d989$var$_globalThis$process, $ca52adcdf3e0d989$var$_globalThis$process$e, $ca52adcdf3e0d989$var$_globalThis$process2, $ca52adcdf3e0d989$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ca52adcdf3e0d989$var$TESTS_MODE = ($ca52adcdf3e0d989$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($ca52adcdf3e0d989$var$_globalThis$process = globalThis.process) === null || $ca52adcdf3e0d989$var$_globalThis$process === void 0 ? void 0 : ($ca52adcdf3e0d989$var$_globalThis$process$e = $ca52adcdf3e0d989$var$_globalThis$process.env) === null || $ca52adcdf3e0d989$var$_globalThis$process$e === void 0 ? void 0 : $ca52adcdf3e0d989$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $ca52adcdf3e0d989$var$_ref !== void 0) ? $ca52adcdf3e0d989$var$_ref : false;
var $ca52adcdf3e0d989$var$DEBUG_MODE = !$ca52adcdf3e0d989$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($ca52adcdf3e0d989$var$_globalThis$process2 = globalThis.process) === null || $ca52adcdf3e0d989$var$_globalThis$process2 === void 0 ? void 0 : ($ca52adcdf3e0d989$var$_globalThis$process2$ = $ca52adcdf3e0d989$var$_globalThis$process2.env) === null || $ca52adcdf3e0d989$var$_globalThis$process2$ === void 0 ? void 0 : $ca52adcdf3e0d989$var$_globalThis$process2$.NODE_ENV) !== "production";
var $ca52adcdf3e0d989$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ca52adcdf3e0d989$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("13fEK", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $0c423741a6796c79$export$4a7404f376229999; });
$parcel$export(module.exports, "B50", function () { return $0c423741a6796c79$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $0c423741a6796c79$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $0c423741a6796c79$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $0c423741a6796c79$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $0c423741a6796c79$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $0c423741a6796c79$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $0c423741a6796c79$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $0c423741a6796c79$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $0c423741a6796c79$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $0c423741a6796c79$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $0c423741a6796c79$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $0c423741a6796c79$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $0c423741a6796c79$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $0c423741a6796c79$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $0c423741a6796c79$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $0c423741a6796c79$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN200", function () { return $0c423741a6796c79$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN90", function () { return $0c423741a6796c79$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $0c423741a6796c79$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN30", function () { return $0c423741a6796c79$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN10", function () { return $0c423741a6796c79$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $0c423741a6796c79$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7NnzT = parcelRequire("7NnzT");
var $0c423741a6796c79$export$4b84fd0e2c617bd = "#FFEBE6";
var $0c423741a6796c79$export$b34b069eff244586 = "#FFBDAD";
var $0c423741a6796c79$export$be802dd0d8b57f35 = "#FF8F73";
var $0c423741a6796c79$export$60847d42f9da92a6 = "#FF7452";
var $0c423741a6796c79$export$4a7404f376229999 = "#FF5630";
var $0c423741a6796c79$export$2010d0fb4295b346 = "#DE350B";
var $0c423741a6796c79$export$2837b5a1a71d5c02 = "#BF2600";
var $0c423741a6796c79$export$8d9596b529bbb9cf = "#FFFAE6";
var $0c423741a6796c79$export$41060a744ab0b7ae = "#FFF0B3";
var $0c423741a6796c79$export$1cc05bbbf340e559 = "#FFE380";
var $0c423741a6796c79$export$5aae31392d72caaa = "#FFC400";
var $0c423741a6796c79$export$c6930421db9fa514 = "#FFAB00";
var $0c423741a6796c79$export$59619663aa6500fb = "#FF991F";
var $0c423741a6796c79$export$874739ea9e379ab6 = "#FF8B00";
var $0c423741a6796c79$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0c423741a6796c79$export$69a3bf21b9686c2b = "#ABF5D1";
var $0c423741a6796c79$export$afbce1382ec95f73 = "#79F2C0";
var $0c423741a6796c79$export$747d86715d4175de = "#57D9A3";
var $0c423741a6796c79$export$940e1f69e873f202 = "#36B37E";
var $0c423741a6796c79$export$a49394138f7b8e85 = "#00875A";
var $0c423741a6796c79$export$6fa04827ac68a4fb = "#006644";
var $0c423741a6796c79$export$226de0355ed012f8 = "#DEEBFF";
var $0c423741a6796c79$export$8c13c2ee36917869 = "#B3D4FF";
var $0c423741a6796c79$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0c423741a6796c79$export$215b7063051591f1 = "#2684FF";
var $0c423741a6796c79$export$e62e8919cca44969 = "#0065FF";
var $0c423741a6796c79$export$b3de0ae08da2ce64 = "#0052CC";
var $0c423741a6796c79$export$a6ee3d71bc067634 = "#0747A6";
var $0c423741a6796c79$export$363e4475840015bb = "#EAE6FF";
var $0c423741a6796c79$export$4b0a4417ed59760f = "#C0B6F2";
var $0c423741a6796c79$export$6011520a64d9a187 = "#998DD9";
var $0c423741a6796c79$export$a7175d4e9206bc80 = "#8777D9";
var $0c423741a6796c79$export$b48405b95304b5a1 = "#6554C0";
var $0c423741a6796c79$export$c71e4279dd54a18d = "#5243AA";
var $0c423741a6796c79$export$147899de772240ec = "#403294";
var $0c423741a6796c79$export$2cf711fe14c66f06 = "#E6FCFF";
var $0c423741a6796c79$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0c423741a6796c79$export$776c9c497ef08533 = "#79E2F2";
var $0c423741a6796c79$export$69cb3ca10c1e330e = "#00C7E6";
var $0c423741a6796c79$export$9dc1ef0f3f48059b = "#00B8D9";
var $0c423741a6796c79$export$7c835c78b6fcdef8 = "#00A3BF";
var $0c423741a6796c79$export$6036577f95c3877e = "#008DA6";
var $0c423741a6796c79$export$29a4f05edc054374 = "#FFFFFF";
var $0c423741a6796c79$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0c423741a6796c79$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0c423741a6796c79$export$3e51e8f1440314ba = "#EBECF0";
var $0c423741a6796c79$export$1ce2d1575d444ceb = "#DFE1E6";
var $0c423741a6796c79$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0c423741a6796c79$export$c2e91cbeada39b8b = "#B3BAC5";
var $0c423741a6796c79$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0c423741a6796c79$export$eaa8c8a70ac22806 = "#97A0AF";
var $0c423741a6796c79$export$7c87d337fb91a97d = "#8993A4";
var $0c423741a6796c79$export$d6447c357493214f = "#7A869A";
var $0c423741a6796c79$export$f563ee71e9ee74cd = "#6B778C";
var $0c423741a6796c79$export$e2ef2124cf4024b1 = "#5E6C84";
var $0c423741a6796c79$export$eece5f492e429f08 = "#505F79";
var $0c423741a6796c79$export$c39c0fe0f26207ae = "#42526E";
var $0c423741a6796c79$export$7090862dc3038a9f = "#344563";
var $0c423741a6796c79$export$ad0bacf983b7ddaa = "#253858";
var $0c423741a6796c79$export$7d61b15e0da132af = "#172B4D";
var $0c423741a6796c79$export$fbda843f0a27fe96 = "#091E42";
var $0c423741a6796c79$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0c423741a6796c79$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0c423741a6796c79$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0c423741a6796c79$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0c423741a6796c79$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0c423741a6796c79$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0c423741a6796c79$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0c423741a6796c79$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0c423741a6796c79$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0c423741a6796c79$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0c423741a6796c79$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0c423741a6796c79$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0c423741a6796c79$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0c423741a6796c79$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0c423741a6796c79$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0c423741a6796c79$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0c423741a6796c79$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0c423741a6796c79$export$2f6319cf7d736c2a = "#E6EDFA";
var $0c423741a6796c79$export$95126bc8884d6634 = "#DCE5F5";
var $0c423741a6796c79$export$8338d8c35d44ff1 = "#CED9EB";
var $0c423741a6796c79$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0c423741a6796c79$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0c423741a6796c79$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0c423741a6796c79$export$97e81faa16a182c7 = "#8C9CB8";
var $0c423741a6796c79$export$bfe21c59123ecf33 = "#7988A3";
var $0c423741a6796c79$export$ee82aa2ea6a1558 = "#67758F";
var $0c423741a6796c79$export$682927c6ed76be02 = "#56637A";
var $0c423741a6796c79$export$91fd9994c5be9757 = "#455166";
var $0c423741a6796c79$export$d281fbfe3cff2df6 = "#3B475C";
var $0c423741a6796c79$export$3902c91d8b98a753 = "#313D52";
var $0c423741a6796c79$export$8e8133c1ba5845b5 = "#283447";
var $0c423741a6796c79$export$33ff357f6620b39 = "#202B3D";
var $0c423741a6796c79$export$633847cf062b69e0 = "#1B2638";
var $0c423741a6796c79$export$9776a6e503bdbf76 = "#121A29";
var $0c423741a6796c79$export$6c813d5160dff5db = "#0E1624";
var $0c423741a6796c79$export$3d4f271a500072a = "#0D1424";
var $0c423741a6796c79$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0c423741a6796c79$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0c423741a6796c79$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0c423741a6796c79$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0c423741a6796c79$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0c423741a6796c79$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0c423741a6796c79$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0c423741a6796c79$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0c423741a6796c79$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0c423741a6796c79$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0c423741a6796c79$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0c423741a6796c79$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0c423741a6796c79$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0c423741a6796c79$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0c423741a6796c79$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0c423741a6796c79$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0c423741a6796c79$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $0c423741a6796c79$export$8ce1fd94bee2f412 = (0, $7NnzT.default)({
    light: "var(--ds-surface, ".concat($0c423741a6796c79$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($0c423741a6796c79$export$633847cf062b69e0, ")")
});
var $0c423741a6796c79$export$b861914ea877b580 = (0, $7NnzT.default)({
    light: "var(--ds-background-selected, ".concat($0c423741a6796c79$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($0c423741a6796c79$export$8c13c2ee36917869, ")")
});
var $0c423741a6796c79$export$3f1b020df94387af = (0, $7NnzT.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($0c423741a6796c79$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($0c423741a6796c79$export$d281fbfe3cff2df6, ")")
});
var $0c423741a6796c79$export$c0183dbab98ca63e = (0, $7NnzT.default)({
    light: "var(--ds-surface-overlay, ".concat($0c423741a6796c79$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($0c423741a6796c79$export$8e8133c1ba5845b5, ")")
});
var $0c423741a6796c79$export$6f093cfa640b7166 = (0, $7NnzT.default)({
    light: "var(--ds-text, ".concat($0c423741a6796c79$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($0c423741a6796c79$export$5368d76ae4fbbda7, ")")
});
var $0c423741a6796c79$export$42f8e9c698766e7a = (0, $7NnzT.default)({
    light: "var(--ds-text, ".concat($0c423741a6796c79$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($0c423741a6796c79$export$5368d76ae4fbbda7, ")")
});
var $0c423741a6796c79$export$c2d157ca1c34b6e3 = (0, $7NnzT.default)({
    light: "var(--ds-text-selected, ".concat($0c423741a6796c79$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($0c423741a6796c79$export$b3de0ae08da2ce64, ")")
});
var $0c423741a6796c79$export$1905ba28d7cf066f = (0, $7NnzT.default)({
    light: "var(--ds-text-subtlest, ".concat($0c423741a6796c79$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($0c423741a6796c79$export$97e81faa16a182c7, ")")
});
var $0c423741a6796c79$export$bd9002130d306d39 = (0, $7NnzT.default)({
    light: "var(--ds-text-subtlest, ".concat($0c423741a6796c79$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($0c423741a6796c79$export$bfe21c59123ecf33, ")")
});
var $0c423741a6796c79$export$46e4a324ac90507f = (0, $7NnzT.default)({
    light: "var(--ds-text, ".concat($0c423741a6796c79$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($0c423741a6796c79$export$5368d76ae4fbbda7, ")")
});
var $0c423741a6796c79$export$79f3f2b82beb0d36 = (0, $7NnzT.default)({
    light: "var(--ds-text-subtlest, ".concat($0c423741a6796c79$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($0c423741a6796c79$export$97e81faa16a182c7, ")")
});
var $0c423741a6796c79$export$7bb0d5c671655cc4 = (0, $7NnzT.default)({
    light: $0c423741a6796c79$export$9fdfb749e33cdf97,
    dark: $0c423741a6796c79$export$8e8133c1ba5845b5
});
var $0c423741a6796c79$export$9c30223ca0a664fb = (0, $7NnzT.default)({
    light: "var(--ds-link, ".concat($0c423741a6796c79$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($0c423741a6796c79$export$ecfc1dff386a3e7a, ")")
});
var $0c423741a6796c79$export$7ed258b0728b004b = (0, $7NnzT.default)({
    light: "var(--ds-link-pressed, ".concat($0c423741a6796c79$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($0c423741a6796c79$export$215b7063051591f1, ")")
});
var $0c423741a6796c79$export$dfa920d8decc8a59 = (0, $7NnzT.default)({
    light: "var(--ds-link-pressed, ".concat($0c423741a6796c79$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($0c423741a6796c79$export$ecfc1dff386a3e7a, ")")
});
var $0c423741a6796c79$export$6069e6ad5c78f632 = (0, $7NnzT.default)({
    light: "var(--ds-border-focused, ".concat($0c423741a6796c79$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($0c423741a6796c79$export$215b7063051591f1, ")")
});
var $0c423741a6796c79$export$9ad721cf3b3debe0 = (0, $7NnzT.default)({
    light: "var(--ds-background-brand-bold, ".concat($0c423741a6796c79$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($0c423741a6796c79$export$ecfc1dff386a3e7a, ")")
});
var $0c423741a6796c79$export$2aa0182783e7e9de = (0, $7NnzT.default)({
    light: $0c423741a6796c79$export$b3de0ae08da2ce64,
    dark: $0c423741a6796c79$export$ecfc1dff386a3e7a
});
var $0c423741a6796c79$export$8bf7dff220b82b4a = (0, $7NnzT.default)({
    light: $0c423741a6796c79$export$9dc1ef0f3f48059b,
    dark: $0c423741a6796c79$export$69cb3ca10c1e330e
});
var $0c423741a6796c79$export$e13cce2a2d16a9d4 = (0, $7NnzT.default)({
    light: $0c423741a6796c79$export$b48405b95304b5a1,
    dark: $0c423741a6796c79$export$6011520a64d9a187
});
var $0c423741a6796c79$export$a90204d1394caf30 = (0, $7NnzT.default)({
    light: $0c423741a6796c79$export$4a7404f376229999,
    dark: $0c423741a6796c79$export$4a7404f376229999
});
var $0c423741a6796c79$export$594c5a8758200c32 = (0, $7NnzT.default)({
    light: $0c423741a6796c79$export$c6930421db9fa514,
    dark: $0c423741a6796c79$export$c6930421db9fa514
});
var $0c423741a6796c79$export$955a2ebd2fb142ae = (0, $7NnzT.default)({
    light: $0c423741a6796c79$export$940e1f69e873f202,
    dark: $0c423741a6796c79$export$940e1f69e873f202
});
var $0c423741a6796c79$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($0c423741a6796c79$export$8d43898f60b96a82, ")");
};

});
parcelRegister("7NnzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5acf661d8bc1f1ef$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $eG5Gh = parcelRequire("eG5Gh");
// Unpack custom variants, and get correct value for the current theme
function $5acf661d8bc1f1ef$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $eG5Gh.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $5acf661d8bc1f1ef$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $5acf661d8bc1f1ef$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $eG5Gh.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("eG5Gh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaf9650de4f4eb64$export$2e2bcd8739ae039; });

var $f4wU4 = parcelRequire("f4wU4");
function $aaf9650de4f4eb64$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $f4wU4.CHANNEL) in props.theme) return props.theme[0, $f4wU4.CHANNEL];
        else if ("mode" in props.theme && (0, $f4wU4.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $f4wU4.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("f4wU4", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $af90c0ade0961cab$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $af90c0ade0961cab$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $af90c0ade0961cab$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "fontFamily", function () { return $af90c0ade0961cab$export$a5975749f0374264; });

var $lTA99 = parcelRequire("lTA99");

var $13fEK = parcelRequire("13fEK");
var $af90c0ade0961cab$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $af90c0ade0961cab$export$c93026a968943f95 = "light";
var $af90c0ade0961cab$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $af90c0ade0961cab$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $af90c0ade0961cab$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $af90c0ade0961cab$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $af90c0ade0961cab$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $af90c0ade0961cab$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $af90c0ade0961cab$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $af90c0ade0961cab$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $13fEK.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $af90c0ade0961cab$export$6d8204c2cb2e06b8() / 4;
    (0, $lTA99.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $af90c0ade0961cab$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $af90c0ade0961cab$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $af90c0ade0961cab$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $lTA99.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $af90c0ade0961cab$export$ba1d834b86d72a09 = $af90c0ade0961cab$export$a1b3edb637fb4f35;
var $af90c0ade0961cab$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $13fEK.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $13fEK.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $13fEK.N30A), ")")
            }
        }
    };
};

});
parcelRegister("lTA99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff0ac5ffa2a01304$export$2e2bcd8739ae039; });

var $kbrDZ = parcelRequire("kbrDZ");

var $XAEGR = parcelRequire("XAEGR");
function $ff0ac5ffa2a01304$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $kbrDZ.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $ff0ac5ffa2a01304$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("kbrDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb1a474034dd91c0$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $eb1a474034dd91c0$var$printed = {};
function $eb1a474034dd91c0$export$2e2bcd8739ae039(message) {
    if ($eb1a474034dd91c0$var$printed[message]) return;
    $eb1a474034dd91c0$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});






parcelRegister("caUDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dd25b87485ad1e7$export$2e2bcd8739ae039; });

var $4bl71 = parcelRequire("4bl71");
// Create default global light theme
var $8dd25b87485ad1e7$var$_createTheme = (0, $4bl71.createTheme)(function() {
    return {
        mode: "light"
    };
}), $8dd25b87485ad1e7$var$Provider = $8dd25b87485ad1e7$var$_createTheme.Provider, $8dd25b87485ad1e7$var$Consumer = $8dd25b87485ad1e7$var$_createTheme.Consumer, $8dd25b87485ad1e7$export$7692396083754928 = $8dd25b87485ad1e7$var$_createTheme.useTheme;
var $8dd25b87485ad1e7$export$2e2bcd8739ae039 = {
    Provider: $8dd25b87485ad1e7$var$Provider,
    Consumer: $8dd25b87485ad1e7$var$Consumer
};

});
parcelRegister("4bl71", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $30b890f2d78af96b$export$25d302a5b900a763; });

var $fkzGu = parcelRequire("fkzGu");

var $iSvIT = parcelRequire("iSvIT");
var $30b890f2d78af96b$var$_excluded = [
    "children"
];
function $30b890f2d78af96b$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $fkzGu.default)(props, $30b890f2d78af96b$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("ibEJ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3d8d8863709b17a$export$2e2bcd8739ae039; });

var $4vCI7 = parcelRequire("4vCI7");

var $13fEK = parcelRequire("13fEK");
var $d3d8d8863709b17a$var$radioThemeColors = {
    light: {
        background: "var(--ds-background-input, ".concat((0, $13fEK.N10), ")"),
        backgroundHover: "var(--ds-background-input-hovered, ".concat((0, $13fEK.N30), ")"),
        backgroundActive: "var(--ds-background-input-pressed, ".concat((0, $13fEK.N30), ")"),
        backgroundChecked: "var(--ds-background-selected-bold, ".concat((0, $13fEK.B400), ")"),
        backgroundCheckedHover: "var(--ds-background-selected-bold-hovered, ".concat((0, $13fEK.B300), ")"),
        backgroundCheckedActive: "var(--ds-background-selected-bold-pressed, ".concat((0, $13fEK.B50), ")"),
        backgroundDisabled: "var(--ds-background-disabled, ".concat((0, $13fEK.N20), ")"),
        dotChecked: "var(--ds-icon-inverse, ".concat((0, $13fEK.N10), ")"),
        dotDisabled: "var(--ds-icon-disabled, ".concat((0, $13fEK.N70), ")"),
        dotActive: "var(--ds-icon-inverse, ".concat((0, $13fEK.B400), ")"),
        border: (0, $4vCI7.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $13fEK.N100), ")") : "var(--ds-border-input, ".concat((0, $13fEK.N40), ")"),
        borderHover: (0, $4vCI7.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $13fEK.N100), ")") : "var(--ds-border-input, ".concat((0, $13fEK.N40), ")"),
        borderDisabled: "var(--ds-border-disabled, ".concat((0, $13fEK.N20), ")"),
        borderFocus: "var(--ds-border-focused, ".concat((0, $13fEK.B100), ")")
    },
    dark: {
        background: "var(--ds-background-input, ".concat((0, $13fEK.DN10), ")"),
        backgroundHover: "var(--ds-background-input-hovered, ".concat((0, $13fEK.DN30), ")"),
        backgroundActive: "var(--ds-background-input-pressed, ".concat((0, $13fEK.B200), ")"),
        backgroundChecked: "var(--ds-background-selected-bold, ".concat((0, $13fEK.B400), ")"),
        backgroundCheckedHover: "var(--ds-background-selected-bold-hovered, ".concat((0, $13fEK.B75), ")"),
        backgroundCheckedActive: "var(--ds-background-selected-bold-pressed, ".concat((0, $13fEK.B200), ")"),
        backgroundDisabled: "var(--ds-background-disabled, ".concat((0, $13fEK.DN10), ")"),
        dotChecked: "var(--ds-icon-inverse, ".concat((0, $13fEK.DN10), ")"),
        dotDisabled: "var(--ds-icon-disabled, ".concat((0, $13fEK.DN90), ")"),
        dotActive: "var(--ds-icon-inverse, ".concat((0, $13fEK.DN10), ")"),
        border: (0, $4vCI7.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $13fEK.DN200), ")") : "var(--ds-border-input, ".concat((0, $13fEK.DN80), ")"),
        borderHover: "var(--ds-border-input, ".concat((0, $13fEK.DN200), ")"),
        borderDisabled: "var(--ds-border-disabled, ".concat((0, $13fEK.DN10), ")"),
        borderFocus: "var(--ds-border-focused, ".concat((0, $13fEK.B75), ")")
    }
};
function $d3d8d8863709b17a$export$2e2bcd8739ae039(mode) {
    var radioColors = $d3d8d8863709b17a$var$radioThemeColors[mode];
    return {
        "--local-background": radioColors.background,
        "--local-background-active": radioColors.backgroundActive,
        "--local-background-checked": radioColors.backgroundChecked,
        "--local-background-checked-active": radioColors.backgroundCheckedActive,
        "--local-background-checked-hover": radioColors.backgroundCheckedHover,
        "--local-background-disabled": radioColors.backgroundDisabled,
        "--local-background-hover": radioColors.backgroundHover,
        "--local-border": radioColors.border,
        "--local-border-disabled": radioColors.borderDisabled,
        "--local-border-hover": radioColors.borderHover,
        "--local-border-focus": radioColors.borderFocus,
        "--local-dot-active": radioColors.dotActive,
        "--local-dot-checked": radioColors.dotChecked,
        "--local-dot-disabled": radioColors.dotDisabled,
        "--local-invalid": "var(--ds-icon-danger, ".concat((0, $13fEK.R300), ")")
    };
}

});







parcelRegister("5ZKRm", function(module, exports) {

$parcel$export(module.exports, "useSiteSelectorContext", function () { return $c240887ff756aef4$export$dbbe4555f7289739; });
$parcel$export(module.exports, "SiteSelectorContextProvider", function () { return $c240887ff756aef4$export$a22f7f4f54f972b1; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");

var $hG0Y6 = parcelRequire("hG0Y6");

var $3FBn4 = parcelRequire("3FBn4");

var $5wOn9 = parcelRequire("5wOn9");

var $4himv = parcelRequire("4himv");

var $fpAKp = parcelRequire("fpAKp");

var $3upvw = parcelRequire("3upvw");
const $c240887ff756aef4$export$c8b55b9bec89387e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext(null);
const $c240887ff756aef4$export$dbbe4555f7289739 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useContext($c240887ff756aef4$export$c8b55b9bec89387e);
    if (!context) throw new Error("useSiteSelectorContext must be used within a SiteSelectorContextProvider");
    return context;
};
const $c240887ff756aef4$export$a22f7f4f54f972b1 = ({ productKey: productKey, children: children, internalLinkAfterIdentity: internalLinkAfterIdentity, redirectToIdentity: redirectToIdentity = false, selectedTemplateLabel: selectedTemplateLabel, analyticsPrefix: analyticsPrefix, referer: referer = "wacdirect" })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const selectedTemplate = (0, $iSvIT.useRef)(null);
    const userProfile = (0, $5wOn9.useLoggedInUser)();
    const { sites: aisSites } = (0, $4himv.useSitesContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const localizedSignupHref = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup");
    const siteUrls = (0, $iSvIT.useMemo)(()=>{
        var _aisSites_filter_map;
        return (_aisSites_filter_map = aisSites === null || aisSites === void 0 ? void 0 : aisSites.filter((site)=>site.products.includes(productKey)).map((site)=>site.url)) !== null && _aisSites_filter_map !== void 0 ? _aisSites_filter_map : [];
    }, [
        aisSites,
        productKey
    ]);
    const isJiraProduct = (productKey)=>{
        return [
            (0, $iFd5d.ProductKeys).JIRA_CORE,
            (0, $iFd5d.ProductKeys).JIRA_SERVICE_DESK,
            (0, $iFd5d.ProductKeys).JIRA_SOFTWARE,
            (0, $iFd5d.ProductKeys).JIRA_PRODUCT_DISCOVERY
        ].includes(productKey);
    };
    const getEventName = (eventName)=>{
        return `${analyticsPrefix}.${eventName}`;
    };
    const getCloudSignupUrl = (0, $iSvIT.useCallback)(()=>{
        if (!selectedTemplate.current) return "";
        const { templateId: templateId, templateName: templateName, productKey: productKey } = selectedTemplate.current;
        let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
        if (isJiraProduct(productKey)) {
            const urlParams = new URLSearchParams(location.search);
            if (!urlParams.has("p")) urlParams.append("templateModal", templateId);
            url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
        } else if (productKey === (0, $iFd5d.ProductKeys).CONFLUENCE) {
            const continueUrl = `${(0, $hG0Y6.Environment).getWacIntegrationUrl()}${internalLinkAfterIdentity !== null && internalLinkAfterIdentity !== void 0 ? internalLinkAfterIdentity : ""}?templateId=${templateId + encodeURIComponent("&templateName=" + encodeURIComponent(templateName))}`;
            url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
        }
        return url;
    }, [
        localizedSignupHref,
        internalLinkAfterIdentity
    ]);
    const getIdentityUrl = (0, $iSvIT.useCallback)((templateId, templateName)=>{
        const loginUrl = `${(0, $hG0Y6.Environment).getIdentityBaseUrl()}/login?`;
        const continueUrl = `${(0, $hG0Y6.Environment).getWacIntegrationUrl()}${internalLinkAfterIdentity !== null && internalLinkAfterIdentity !== void 0 ? internalLinkAfterIdentity : ""}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
        return `${loginUrl}&continue=${encodeURIComponent(continueUrl)}`;
    }, [
        internalLinkAfterIdentity
    ]);
    const getCloudExistingUrl = (siteUrl, templateId)=>{
        if (productKey !== (0, $iFd5d.ProductKeys).CONFLUENCE) return `${siteUrl}/jira/create-project?templateId=${templateId}`;
        const templateSplit = templateId.split(":");
        if (templateSplit[0] === "whiteboard") return `${siteUrl}/wiki/login.action?os_destination=${encodeURIComponent(`/create-content/whiteboard?insertTemplateWithKey=${templateSplit[1]}&redirect=true&referer=${referer}`)}`;
        return `${siteUrl}/wiki/login.action?os_destination=%2Frest%2Fcreate-dialog%2F1.0%2Fcontent%2Fblueprint%2FgetGlobalFabricBlueprintDraft%3Fredirect%3Dtrue%26blueprintModule%3D${templateId}%26referer%3D${referer}`;
    };
    const tryToUseTemplate = (0, $iSvIT.useCallback)(()=>{
        if (!selectedTemplate.current) return;
        const { templateId: templateId, templateName: templateName } = selectedTemplate.current;
        if (siteUrls.length > 0) setIsOpen(true);
        else if (redirectToIdentity && internalLinkAfterIdentity) location.href = getIdentityUrl(templateId, templateName);
        else location.href = getCloudSignupUrl();
    }, [
        siteUrls,
        redirectToIdentity,
        internalLinkAfterIdentity,
        getIdentityUrl,
        getCloudSignupUrl
    ]);
    const openModalForTemplate = (0, $iSvIT.useCallback)((template, isCallOnProductNav)=>{
        selectedTemplate.current = template;
        var _template_productKey;
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "linkButton",
            attributes: {
                templateName: template.templateName,
                label: template.templateName,
                path: location.pathname,
                event_type: "ui",
                url: location.href,
                product: (_template_productKey = template.productKey) !== null && _template_productKey !== void 0 ? _template_productKey : productKey,
                templateId: template.templateId,
                loginUserDetected: userProfile.isUserLoggedIn,
                trackEventName: getEventName("clicked-use-template"),
                eventContainer: isCallOnProductNav ? "product-nav" : ""
            }
        }).fire();
        tryToUseTemplate();
    }, [
        createAnalyticsEvent,
        userProfile.isUserLoggedIn,
        tryToUseTemplate,
        productKey
    ]);
    const switchAccount = ()=>{
        if (!selectedTemplate.current) return;
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "linkButton",
            attributes: {
                trackEventName: getEventName("clicked-switch-account")
            }
        }).fire();
        const { templateId: templateId, templateName: templateName } = selectedTemplate.current;
        if (productKey === (0, $iFd5d.ProductKeys).CONFLUENCE) {
            const continueUrl = `${(0, $hG0Y6.Environment).getWacIntegrationUrl()}${internalLinkAfterIdentity}?templateId=${templateId}&templateName=${encodeURIComponent(templateName)}`;
            location.href = (0, $hG0Y6.Environment).getIdSwitchUserUrl(continueUrl);
        } else location.href = (0, $hG0Y6.Environment).getIdSwitchUserUrl();
    };
    const siteSelected = (site)=>{
        var _selectedTemplate_current, _selectedTemplate_current1;
        createAnalyticsEvent({
            actionSubject: "linkButton",
            action: "clicked",
            attributes: {
                site: site,
                bluePrintModule: (_selectedTemplate_current = selectedTemplate.current) === null || _selectedTemplate_current === void 0 ? void 0 : _selectedTemplate_current.templateId,
                eventName: "project-created-(client)",
                createdUsing: "templateWac",
                userId: userProfile.accountId,
                product: productKey,
                learnMore: referer === "learnMore",
                trackEventName: getEventName("submitted-existing-site")
            }
        }).fire();
        if (selectedTemplate.current) location.href = getCloudExistingUrl(site, (_selectedTemplate_current1 = selectedTemplate.current) === null || _selectedTemplate_current1 === void 0 ? void 0 : _selectedTemplate_current1.templateId);
    };
    const newSiteSelected = ()=>{
        var _selectedTemplate_current;
        createAnalyticsEvent({
            actionSubject: "linkButton",
            action: "clicked",
            attributes: {
                bluePrintModule: (_selectedTemplate_current = selectedTemplate.current) === null || _selectedTemplate_current === void 0 ? void 0 : _selectedTemplate_current.templateId,
                createdUsing: "templateWac",
                userId: userProfile.accountId,
                product: productKey,
                learnMore: referer === "learnMore",
                trackEventName: getEventName("submitted-new-site")
            }
        }).fire();
        location.href = getCloudSignupUrl();
    };
    const closeModal = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "linkButton",
            attributes: {
                trackEventName: getEventName("clicked-modal-closed")
            }
        }).fire();
        selectedTemplate.current = null;
        setIsOpen(false);
    };
    const siteChanged = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "linkButton",
            attributes: {
                trackEventName: getEventName("changed-selected-site")
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)($c240887ff756aef4$export$c8b55b9bec89387e.Provider, {
        value: {
            openModalForTemplate: openModalForTemplate
        },
        children: [
            children,
            isOpen && /*#__PURE__*/ (0, $loA2J.jsx)((0, $3upvw.default), {
                isOpen: isOpen,
                header: selectedTemplate.current ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $fpAKp.default), {
                    productKey: selectedTemplate.current.productKey,
                    templateName: selectedTemplate.current.templateName,
                    selectedLabel: selectedTemplateLabel
                }) : null,
                onSwitchAccountClick: switchAccount,
                onSiteSelected: siteSelected,
                onSiteChanged: siteChanged,
                onNewSiteSelected: newSiteSelected,
                onModalClose: closeModal,
                userEmail: userProfile.email || "",
                sites: siteUrls,
                userName: userProfile.name || "",
                avatarSrc: userProfile.picture
            })
        ]
    });
};

});
parcelRegister("fpAKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d4f9b48a7f306ae$export$2e2bcd8739ae039; });
/* product-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");

var $4XrxY = parcelRequire("4XrxY");
const $5d4f9b48a7f306ae$var$ProductHeader = ({ productKey: productKey, templateName: templateName, selectedLabel: selectedLabel })=>{
    const intl = (0, $f6qj2.default)();
    const getBrand = (productKey)=>{
        switch(productKey){
            case (0, $iFd5d.ProductKeys).JIRA_SOFTWARE:
                return "jirasoftware";
            case (0, $iFd5d.ProductKeys).JIRA_SERVICE_DESK:
                return "jiraservicemanagement";
            case (0, $iFd5d.ProductKeys).JIRA_CORE:
                return "jiraworkmanagement";
            case (0, $iFd5d.ProductKeys).CONFLUENCE:
            default:
                return "confluence";
        }
    };
    const youSelectedLabel = intl.formatMessage({
        id: "SiteSelectorModal.modalHeader.youSelected",
        defaultMessage: "You selected"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4x201mjv"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
                type: "logo",
                appearance: "brand",
                brand: getBrand(productKey)
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz"
                ]),
                children: [
                    selectedLabel !== null && selectedLabel !== void 0 ? selectedLabel : youSelectedLabel,
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_k48p8n31 _bozg14y2"
                        ]),
                        children: templateName
                    })
                ]
            })
        ]
    });
};
const $5d4f9b48a7f306ae$var$subHeadlineStyle = null;
const $5d4f9b48a7f306ae$var$selectedTemplateStyle = null;
const $5d4f9b48a7f306ae$var$logoWrapperStyle = null;
var $5d4f9b48a7f306ae$export$2e2bcd8739ae039 = $5d4f9b48a7f306ae$var$ProductHeader;

});




parcelRegister("4Cacz", function(module, exports) {

$parcel$export(module.exports, "GuardNav", function () { return $59641f41c7daf66c$export$941339143e9f5522; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $a0rKx = parcelRequire("a0rKx");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $8ltM2 = parcelRequire("8ltM2");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $59641f41c7daf66c$var$GuardLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $a0rKx.GuardLogo), {
        appearance: "brand"
    });
};
const $59641f41c7daf66c$export$941339143e9f5522 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow: openCrossFlow } = (0, $8ltM2.useCrossFlowFrontendTouchpoint)({
        edition: (0, $iFd5d.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $3FBn4.useLocalizedHref)("/software/guard/capabilities");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/guard/pricing");
    const guideHref = (0, $3FBn4.useLocalizedHref)("/software/guard/guide#getting-started");
    const demoHref = (0, $3FBn4.useLocalizedHref)("/software/guard/demo");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($59641f41c7daf66c$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "GuardPageTemplate.navbar.guard-logo",
                defaultMessage: "Guard logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($59641f41c7daf66c$var$GuardLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "capabilities",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.capabilities",
                        defaultMessage: "Capabilities"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: capabilitiesHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: pricingHref
                },
                {
                    globalLinksKey: "guide",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.guide",
                        defaultMessage: "Guide"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: guideHref
                },
                {
                    globalLinksKey: "demo",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.demo",
                        defaultMessage: "Demo"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: demoHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-guard",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "capabilities",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.capabilities",
                                defaultMessage: "Capabilities"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: capabilitiesHref
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: pricingHref
                        },
                        {
                            globalLinksKey: "guide",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.guide",
                                defaultMessage: "Guide"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: guideHref
                        },
                        {
                            globalLinksKey: "demo",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.demo",
                                defaultMessage: "Demo"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: demoHref
                        }
                    ]
                }
            ]
        })
    });
};

});
parcelRegister("a0rKx", function(module, exports) {

$parcel$export(module.exports, "GuardLogo", function () { return $748f6df228342c19$export$a4a891d202775deb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $748f6df228342c19$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">\n      <path\n        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"\n        fill="'.concat(colors.iconColor, '"\n      />\n      <path\n        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $748f6df228342c19$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Guard" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $748f6df228342c19$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("j6Axx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c253c89c6f96043e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $8ltM2 = parcelRequire("8ltM2");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $c253c89c6f96043e$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $c253c89c6f96043e$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $8ltM2.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $iFd5d.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $iFd5d.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$c253c89c6f96043e$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $c253c89c6f96043e$export$2e2bcd8739ae039 = $c253c89c6f96043e$var$JiraProductDiscoveryNavV2;

});

parcelRegister("dJVgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95299be710b4e4ff$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("i8kxh");
var $iFd5d = parcelRequire("iFd5d");
parcelRequire("3LLDq");
var $8ltM2 = parcelRequire("8ltM2");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $hbBKK = parcelRequire("hbBKK");

var $9g0oR = parcelRequire("9g0oR");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("wXgqV");
var $6TGlD = parcelRequire("6TGlD");
parcelRequire("5goCs");
var $epQac = parcelRequire("epQac");
const $95299be710b4e4ff$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $95299be710b4e4ff$var$JiraSoftwareNav = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    var _newLinks_find, _newLinks_find1;
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $8ltM2.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $iFd5d.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $iFd5d.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $iSvIT.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, [
        openCrossFlow,
        productNavCtaCTAClickFunction,
        isUseOpenCrossFlow
    ]);
    const solutionsDropdownStyles = (0, $iSvIT.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/marketing");
    const engineeringHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/engineering");
    const designHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/design");
    const operationsHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/operations");
    const itHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/it");
    // Use Cases Hrefs
    const planningHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/planning");
    const campaignManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/campaign-management");
    const agileProjectManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/agile-project-management");
    const programManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/program-management");
    //Company Size Hrefs
    const enterpriseHref = (0, $3FBn4.useLocalizedHref)("/software/jira/enterprise");
    const solutionsDropdown = (0, $iSvIT.useMemo)(()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.teams.header",
                        defaultMessage: "Teams"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.marketing",
                                defaultMessage: "Marketing"
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.engineering",
                                defaultMessage: "Engineering"
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.design",
                                defaultMessage: "Design"
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.operations",
                                defaultMessage: "Operations"
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.it",
                                defaultMessage: "IT"
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.useCases.header",
                        defaultMessage: "Use Cases"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.planning",
                                defaultMessage: "Planning"
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.campaign-management",
                                defaultMessage: "Campaign Management"
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.agile-project-management",
                                defaultMessage: "Agile Project Management"
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.program-management",
                                defaultMessage: "Program Management"
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.companySize.header",
                        defaultMessage: "Company Size"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.companySize.enterprise",
                                defaultMessage: "Enterprise"
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const featuresHref = (0, $3FBn4.useLocalizedHref)("/software/jira/features");
    const productGuideHref = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const templatesHref = (0, $3FBn4.useLocalizedHref)("/software/jira/templates");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/jira/pricing");
    const productLogoHref = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const templateCategoriesShown = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraTemplatesDxpMigration);
    const featuresDropdownShown = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraFeaturesSubNav);
    const templatesLinkContent = (0, $iSvIT.useMemo)(()=>{
        const common = {
            globalLinksKey: "templates",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.templates",
                defaultMessage: "Templates"
            }),
            productKey: "jira"
        };
        return templateCategoriesShown ? (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $epQac.TemplateCategoriesDropdown), {}),
            dropdownType: "templates",
            containerPosition: "relative"
        }) : (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: false,
            href: templatesHref
        });
    }, [
        templatesHref,
        templateCategoriesShown
    ]);
    const featuresLinkContent = (0, $iSvIT.useMemo)(()=>{
        const common = {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.features",
                defaultMessage: "Features"
            }),
            productKey: "jira"
        };
        return featuresDropdownShown ? (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6TGlD.FeaturesDropdown), {}),
            dropdownType: "features",
            containerPosition: "relative"
        }) : (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: false,
            href: featuresHref
        });
    }, [
        featuresHref,
        featuresDropdownShown
    ]);
    const newLinks = (0, $iSvIT.useMemo)(()=>[
            featuresLinkContent,
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                productKey: "jira",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                dropdownType: "solutions",
                content: solutionsDropdown
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            }
        ], [
        intl,
        featuresHref,
        solutionsDropdown,
        solutionsDropdownStyles,
        productGuideHref,
        templatesHref,
        pricingHref
    ]);
    const links = (0, $iSvIT.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: featuresHref
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            },
            {
                globalLinksKey: "enterprise",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.enterprise",
                    defaultMessage: "Enterprise"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: enterpriseHref
            }
        ], [
        enterpriseHref,
        featuresHref,
        intl,
        pricingHref,
        productGuideHref,
        templatesHref
    ]);
    const globalNavItemKeys = (0, $iSvIT.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: productLogoHref,
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($95299be710b4e4ff$var$JiraLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "JiraeSoftwarePageTemplate.navbar.getitfree",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($95299be710b4e4ff$var$JiraLogo, {}),
            navigationTrynowCtaText: intl.formatMessage({
                id: "JiraFeatureSoftwarePageTemplate.heroCTA",
                defaultMessage: "Get it free"
            }),
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            productPageNavLinks: newLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira",
                    mobileLinksProps: newLinks
                }
            ],
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: (_newLinks_find = newLinks.find((link)=>link.globalLinksKey === "solutions")) === null || _newLinks_find === void 0 ? void 0 : _newLinks_find.content
                },
                {
                    menuPageKey: "templates",
                    menuPageObjects: (_newLinks_find1 = newLinks.find((link)=>link.globalLinksKey === "templates")) === null || _newLinks_find1 === void 0 ? void 0 : _newLinks_find1.content
                }
            ]
        })
    });
};
$95299be710b4e4ff$var$JiraSoftwareNav.displayName = "JiraSoftwareNav";
var $95299be710b4e4ff$export$2e2bcd8739ae039 = $95299be710b4e4ff$var$JiraSoftwareNav;

});
parcelRegister("wXgqV", function(module, exports) {
$parcel$export(module.exports, "FeaturesDropdown", function () { return (parcelRequire("6TGlD")).FeaturesDropdown; });
parcelRequire("6TGlD");

});
parcelRegister("6TGlD", function(module, exports) {

$parcel$export(module.exports, "FeaturesDropdown", function () { return $931d8f64452f5962$export$ad0d22100914784b; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $9g0oR = parcelRequire("9g0oR");
const $931d8f64452f5962$export$ad0d22100914784b = ()=>{
    const locale = (0, $3FBn4.useLocale)();
    const intl = (0, $f6qj2.default)();
    const allFeaturesLink = {
        text: intl.formatMessage({
            id: "jira.FeaturesDropdown.allFeatures",
            defaultMessage: "All Features"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/features",
            locale: locale
        })
    };
    const featureLinks = [
        {
            text: intl.formatMessage({
                id: "jira.FeaturesDropdown.rovo",
                defaultMessage: "Rovo in Jira"
            }),
            href: (0, $3FBn4.getLocalizedHref)({
                href: "/software/jira/ai",
                locale: locale
            })
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allFeaturesLink,
                    ...featureLinks
                ]
            }
        ]
    });
};

});


parcelRegister("5goCs", function(module, exports) {
$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return (parcelRequire("epQac")).TemplateCategoriesDropdown; });
parcelRequire("epQac");

});
parcelRegister("epQac", function(module, exports) {

$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return $b829a312c9341cb7$export$8bb7e16f8f8a7ba6; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $9g0oR = parcelRequire("9g0oR");
parcelRequire("jF7is");
var $ijtPZ = parcelRequire("ijtPZ");
const $b829a312c9341cb7$export$8bb7e16f8f8a7ba6 = ()=>{
    const locale = (0, $3FBn4.useLocale)();
    const intl = (0, $f6qj2.default)();
    const { data: data } = (0, $ijtPZ.useJiraTemplateCategories)();
    const allTemplateLink = {
        text: intl.formatMessage({
            id: "ira.TemplateCategoriesDropdown.allTemplates",
            defaultMessage: "All templates"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/templates",
            locale: locale
        })
    };
    const templateLinks = data.map((category)=>({
            text: category.categoryNameExternal,
            href: (0, $3FBn4.getLocalizedHref)({
                href: `/software/jira/templates/${category.urlSlug}`,
                locale: locale
            })
        }));
    const jsmTemplatesLink = {
        text: intl.formatMessage({
            id: "Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates",
            defaultMessage: "Jira Service Management templates"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/templates/service-management",
            locale: locale
        }),
        anchorProps: {
            target: "_blank"
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allTemplateLink,
                    ...templateLinks
                ]
            },
            {
                links: [
                    jsmTemplatesLink
                ]
            }
        ]
    });
};

});
parcelRegister("jF7is", function(module, exports) {
$parcel$export(module.exports, "useJiraTemplateCategories", function () { return (parcelRequire("ijtPZ")).useJiraTemplateCategories; });
parcelRequire("8FQ7c");
parcelRequire("ijtPZ");

});
parcelRegister("8FQ7c", function(module, exports) {

$parcel$export(module.exports, "getTemplateCategories", function () { return $439693367266da4f$export$819167f3de5f32cb; });

var $loA5d = parcelRequire("loA5d");

var $kNCWT = parcelRequire("kNCWT");
let $439693367266da4f$var$_ = (t)=>t, $439693367266da4f$var$t;
const $439693367266da4f$var$JIRA_PRODUCT_INTERNAL_TITLE = "Jira Cloud Product";
const $439693367266da4f$export$52bf0b65d881440d = (0, $loA5d.gql)($439693367266da4f$var$t || ($439693367266da4f$var$t = $439693367266da4f$var$_`
query ($locale: String) {
  taxonomyTemplateCategoryCollection(
    locale: $locale
    limit: 100,
    where: {
      product: {
        internalTitle: "${0}"
      }
    }
    # for the short-term, sort-ordering is done via the internal-name
    # todo: GWP-6125 implement a long term sort-ordering solution
    order: categoryNameInternal_ASC
  ) {
    items {
      sys {
        id
      }
      categoryNameInternal
      categoryNameExternal
      urlSlug
    }
  }
}
`), $439693367266da4f$var$JIRA_PRODUCT_INTERNAL_TITLE);
const $439693367266da4f$export$819167f3de5f32cb = (args)=>{
    const { locale: locale } = args;
    return (0, $loA5d.request)({
        url: (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL),
        document: $439693367266da4f$export$52bf0b65d881440d,
        variables: {
            locale: locale
        },
        requestHeaders: {
            Authorization: `Bearer ${window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};

});
parcelRegister("loA5d", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $f937d4321ee3da05$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "gql", function () { return $f937d4321ee3da05$export$72e4926bf8358653; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $8JaQT = parcelRequire("8JaQT");

var $42TZw = parcelRequire("42TZw");

var $gUOuz = parcelRequire("gUOuz");

var $Llgr7 = parcelRequire("Llgr7");

var $lKnm7 = parcelRequire("lKnm7");

var $2bAdR = parcelRequire("2bAdR");

var $bbHBz = parcelRequire("bbHBz");
/**
 * Convert the given headers configuration into a plain object.
 */ const $f937d4321ee3da05$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $2bAdR && $2bAdR.Headers && headers instanceof $2bAdR.Headers) oHeaders = (0, $42TZw.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $f937d4321ee3da05$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $f937d4321ee3da05$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($f937d4321ee3da05$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $f937d4321ee3da05$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $f937d4321ee3da05$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = (0, $7Knp0._)({}, params.headers);
        let queryParams = ``;
        let body = undefined;
        var _fetchOptions_jsonSerializer;
        if (method === `POST`) {
            body = $f937d4321ee3da05$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $f937d4321ee3da05$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: (_fetchOptions_jsonSerializer = fetchOptions.jsonSerializer) !== null && _fetchOptions_jsonSerializer !== void 0 ? _fetchOptions_jsonSerializer : (0, $8JaQT.defaultJsonSerializer)
        });
        const init = (0, $7Knp0._)({
            method: method,
            headers: headers,
            body: body
        }, fetchOptions);
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware((0, $6iHNw._)((0, $7Knp0._)({}, init), {
                url: url,
                operationName: operationName,
                variables: variables
            })));
            const { url: urlNew } = result, initNew = (0, $akGnX._)(result, [
                "url"
            ]);
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $f937d4321ee3da05$export$b0f268a6eae2cdf1 {
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $gUOuz.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const _this_requestConfig = this.requestConfig, { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($2bAdR))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware } = _this_requestConfig, fetchOptions = (0, $akGnX._)(_this_requestConfig, [
            "headers",
            "fetch",
            "method",
            "requestMiddleware",
            "responseMiddleware"
        ]);
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $Llgr7.resolveRequestDocument)(requestOptions.document);
        return $f937d4321ee3da05$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: (0, $7Knp0._)({}, $f937d4321ee3da05$var$resolveHeaders($f937d4321ee3da05$var$callOrIdentity(headers)), $f937d4321ee3da05$var$resolveHeaders(requestOptions.requestHeaders)),
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $gUOuz.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const _this_requestConfig = this.requestConfig, { headers: headers } = _this_requestConfig, fetchOptions = (0, $akGnX._)(_this_requestConfig, [
            "headers"
        ]);
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $Llgr7.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        var _this_requestConfig_fetch;
        return $f937d4321ee3da05$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: (0, $7Knp0._)({}, $f937d4321ee3da05$var$resolveHeaders($f937d4321ee3da05$var$callOrIdentity(headers)), $f937d4321ee3da05$var$resolveHeaders(batchRequestOptions.requestHeaders)),
            operationName: undefined,
            fetch: (_this_requestConfig_fetch = this.requestConfig.fetch) !== null && _this_requestConfig_fetch !== void 0 ? _this_requestConfig_fetch : (0, (/*@__PURE__*/$parcel$interopDefault($2bAdR))),
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $gUOuz.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const _this_requestConfig = this.requestConfig, { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($2bAdR))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware } = _this_requestConfig, fetchOptions = (0, $akGnX._)(_this_requestConfig, [
                "headers",
                "fetch",
                "method",
                "requestMiddleware",
                "responseMiddleware"
            ]);
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $Llgr7.resolveRequestDocument)(rawRequestOptions.query);
            return $f937d4321ee3da05$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: (0, $7Knp0._)({}, $f937d4321ee3da05$var$resolveHeaders($f937d4321ee3da05$var$callOrIdentity(headers)), $f937d4321ee3da05$var$resolveHeaders(rawRequestOptions.requestHeaders)),
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
}
const $f937d4321ee3da05$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    var _params_method;
    const fetcher = $f937d4321ee3da05$var$createHttpMethodFetcher((0, $42TZw.uppercase)((_params_method = params.method) !== null && _params_method !== void 0 ? _params_method : `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    var _fetchOptions_jsonSerializer;
    const result = await $f937d4321ee3da05$var$getResult(response, (_fetchOptions_jsonSerializer = fetchOptions.jsonSerializer) !== null && _fetchOptions_jsonSerializer !== void 0 ? _fetchOptions_jsonSerializer : (0, $8JaQT.defaultJsonSerializer));
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const _ref = Array.isArray(result) ? result : result, { errors: _ } = _ref, rest = (0, $akGnX._)(_ref, [
            "errors"
        ]);
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return (0, $6iHNw._)((0, $7Knp0._)({}, dataEnvelope), {
            headers: response.headers,
            status: response.status
        });
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new (0, $lKnm7.ClientError)(// @ts-expect-error TODO
        (0, $6iHNw._)((0, $7Knp0._)({}, errorResult), {
            status: response.status,
            headers: response.headers
        }), {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $f937d4321ee3da05$export$3052fa16c23a17ef = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $gUOuz.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $f937d4321ee3da05$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.rawRequest((0, $7Knp0._)({}, requestOptions));
};
// prettier-ignore
// eslint-disable-next-line
async function $f937d4321ee3da05$export$b5fe3f66a567bec0(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $gUOuz.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $f937d4321ee3da05$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.request((0, $7Knp0._)({}, requestOptions));
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $f937d4321ee3da05$export$72420c3222c11ca1 = async (...args)=>{
    const params = $f937d4321ee3da05$var$parseBatchRequestsArgsExtended(args);
    const client = new $f937d4321ee3da05$export$b0f268a6eae2cdf1(params.url);
    return client.batchRequests(params);
};
const $f937d4321ee3da05$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $f937d4321ee3da05$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer !== null && jsonSerializer !== void 0 ? jsonSerializer : (0, $8JaQT.defaultJsonSerializer);
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $f937d4321ee3da05$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $f937d4321ee3da05$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
const $f937d4321ee3da05$export$72e4926bf8358653 = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
var $f937d4321ee3da05$export$2e2bcd8739ae039 = $f937d4321ee3da05$export$b5fe3f66a567bec0;

});
parcelRegister("8JaQT", function(module, exports) {

$parcel$export(module.exports, "defaultJsonSerializer", function () { return $65aaf1b4daf2f5dd$export$94978876ea00418f; });
const $65aaf1b4daf2f5dd$export$94978876ea00418f = JSON;

});

parcelRegister("42TZw", function(module, exports) {

$parcel$export(module.exports, "uppercase", function () { return $2f22c802412ba8aa$export$6cfe151e6b925e83; });
$parcel$export(module.exports, "HeadersInstanceToPlainObject", function () { return $2f22c802412ba8aa$export$8cbbf7c85c69d7bd; });
const $2f22c802412ba8aa$export$6cfe151e6b925e83 = (str)=>str.toUpperCase();
const $2f22c802412ba8aa$export$8cbbf7c85c69d7bd = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};

});

parcelRegister("gUOuz", function(module, exports) {

$parcel$export(module.exports, "parseRequestArgs", function () { return $c5090afbd2d358dc$export$23fbebc38045fef1; });
$parcel$export(module.exports, "parseRawRequestArgs", function () { return $c5090afbd2d358dc$export$915c311301d24138; });
$parcel$export(module.exports, "parseBatchRequestArgs", function () { return $c5090afbd2d358dc$export$db48f1a2d994371; });
$parcel$export(module.exports, "parseRequestExtendedArgs", function () { return $c5090afbd2d358dc$export$77a1c1c6dd0fc83d; });
$parcel$export(module.exports, "parseRawRequestExtendedArgs", function () { return $c5090afbd2d358dc$export$7dbb6e4001743509; });
const $c5090afbd2d358dc$export$23fbebc38045fef1 = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$915c311301d24138 = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$db48f1a2d994371 = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$77a1c1c6dd0fc83d = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$7dbb6e4001743509 = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};

});

parcelRegister("Llgr7", function(module, exports) {

$parcel$export(module.exports, "resolveRequestDocument", function () { return $08e4e2824a10a250$export$8a71244cbc138170; });

var $23Ewe = parcelRequire("23Ewe");
var $gX72x = parcelRequire("gX72x");
/**
 * helpers
 */ const $08e4e2824a10a250$var$extractOperationName = (document)=>{
    var _operationDefinitions__name, _operationDefinitions_;
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = (_operationDefinitions_ = operationDefinitions[0]) === null || _operationDefinitions_ === void 0 ? void 0 : (_operationDefinitions__name = _operationDefinitions_.name) === null || _operationDefinitions__name === void 0 ? void 0 : _operationDefinitions__name.value;
    return operationName;
};
const $08e4e2824a10a250$export$8a71244cbc138170 = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $23Ewe.parse)(document);
            operationName = $08e4e2824a10a250$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $08e4e2824a10a250$var$extractOperationName(document);
    return {
        query: (0, $gX72x.print)(document),
        operationName: operationName
    };
};

});

parcelRegister("lKnm7", function(module, exports) {

$parcel$export(module.exports, "ClientError", function () { return $fd5002cdc1e73ea3$export$bb8c263ad32caa8; });
class $fd5002cdc1e73ea3$export$bb8c263ad32caa8 extends Error {
    static extractMessage(response) {
        var _response_errors_, _response_errors;
        var _response_errors__message;
        return (_response_errors__message = (_response_errors = response.errors) === null || _response_errors === void 0 ? void 0 : (_response_errors_ = _response_errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.message) !== null && _response_errors__message !== void 0 ? _response_errors__message : `GraphQL Error (Code: ${response.status})`;
    }
    constructor(response, request){
        const message = `${$fd5002cdc1e73ea3$export$bb8c263ad32caa8.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $fd5002cdc1e73ea3$export$bb8c263ad32caa8.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $fd5002cdc1e73ea3$export$bb8c263ad32caa8);
    }
}

});

parcelRegister("2bAdR", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("bbHBz", function(module, exports) {
/* eslint-disable */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $Llgr7 = parcelRequire("Llgr7");

var $lKnm7 = parcelRequire("lKnm7");
// import type WebSocket from 'ws'
const $82528bd6da91277a$var$CONNECTION_INIT = `connection_init`;
const $82528bd6da91277a$var$CONNECTION_ACK = `connection_ack`;
const $82528bd6da91277a$var$PING = `ping`;
const $82528bd6da91277a$var$PONG = `pong`;
const $82528bd6da91277a$var$SUBSCRIBE = `subscribe`;
const $82528bd6da91277a$var$NEXT = `next`;
const $82528bd6da91277a$var$ERROR = `error`;
const $82528bd6da91277a$var$COMPLETE = `complete`;
class $82528bd6da91277a$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $82528bd6da91277a$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
}
class $82528bd6da91277a$export$5eb90cb6288c26cf {
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($82528bd6da91277a$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($82528bd6da91277a$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $Llgr7.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($82528bd6da91277a$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($82528bd6da91277a$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $82528bd6da91277a$var$parseMessage(e.data);
                switch(message.type){
                    case $82528bd6da91277a$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $82528bd6da91277a$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($82528bd6da91277a$var$Pong(r).text));
                        else socket.send($82528bd6da91277a$var$Pong(null).text);
                        return;
                    case $82528bd6da91277a$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $82528bd6da91277a$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new (0, $lKnm7.ClientError)((0, $6iHNw._)((0, $7Knp0._)({}, message.payload), {
                            status: 200
                        }), {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $82528bd6da91277a$var$ERROR:
                        subscriber.error && subscriber.error(new (0, $lKnm7.ClientError)({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $82528bd6da91277a$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
}
$82528bd6da91277a$export$5eb90cb6288c26cf.PROTOCOL = `graphql-transport-ws`;
// Helper functions
function $82528bd6da91277a$var$parseMessage(data, f = (a)=>a) {
    const m = $82528bd6da91277a$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $82528bd6da91277a$var$ConnectionInit(payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$CONNECTION_INIT, payload);
}
function $82528bd6da91277a$var$Ping(payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$PING, payload, undefined);
}
function $82528bd6da91277a$var$Pong(payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$PONG, payload, undefined);
}
function $82528bd6da91277a$var$Subscribe(id, payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$SUBSCRIBE, payload, id);
}
function $82528bd6da91277a$var$Complete(id) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$COMPLETE, undefined, id);
}

});



parcelRegister("ijtPZ", function(module, exports) {

$parcel$export(module.exports, "useJiraTemplateCategories", function () { return $d9bdcf0f19bc293e$export$ef1e726410cc2d37; });

var $iSvIT = parcelRequire("iSvIT");

var $3FBn4 = parcelRequire("3FBn4");

var $1FkY0 = parcelRequire("1FkY0");

var $8FQ7c = parcelRequire("8FQ7c");
// cache data per locale to optimize duplicate queries
const $d9bdcf0f19bc293e$var$cache = new Map();
const $d9bdcf0f19bc293e$export$d2adf65b87e47523 = ()=>{
    $d9bdcf0f19bc293e$var$cache.clear();
};
const $d9bdcf0f19bc293e$export$ef1e726410cc2d37 = ()=>{
    const locale = (0, $3FBn4.useLocale)();
    const mappedLocale = (0, $1FkY0.WAC_TO_CPAPI_LOCALE_MAP)[locale];
    // initialize state from cache if available
    const cacheEntry = mappedLocale ? $d9bdcf0f19bc293e$var$cache.get(mappedLocale) : undefined;
    var _cacheEntry_data;
    const [data, setData] = (0, $iSvIT.useState)((_cacheEntry_data = cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.data) !== null && _cacheEntry_data !== void 0 ? _cacheEntry_data : []);
    const [loading, setLoading] = (0, $iSvIT.useState)(false);
    const [error, setError] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        // if we don't have a mapped locale, do nothing
        if (!mappedLocale) return;
        const existingCache = $d9bdcf0f19bc293e$var$cache.get(mappedLocale);
        // if we already have cached data, use it
        if ((existingCache === null || existingCache === void 0 ? void 0 : existingCache.data) && !existingCache.promise) {
            setData(existingCache.data);
            return;
        }
        // if a fetch is already in progress, wait for it
        if (existingCache === null || existingCache === void 0 ? void 0 : existingCache.promise) {
            setLoading(true);
            existingCache.promise.then((items)=>{
                setData(items);
                setLoading(false);
            }).catch((err)=>{
                setError(err);
                setLoading(false);
            });
            return;
        }
        // start a new fetch
        setLoading(true);
        setError(null);
        const fetchPromise = (0, $8FQ7c.getTemplateCategories)({
            // @ts-ignore
            locale: mappedLocale
        }).then((response)=>{
            var _response_taxonomyTemplateCategoryCollection_items;
            const items = (_response_taxonomyTemplateCategoryCollection_items = response.taxonomyTemplateCategoryCollection.items) !== null && _response_taxonomyTemplateCategoryCollection_items !== void 0 ? _response_taxonomyTemplateCategoryCollection_items : [];
            // update cache with data and clear promise
            $d9bdcf0f19bc293e$var$cache.set(mappedLocale, {
                data: items,
                promise: null
            });
            setData(items);
            setLoading(false);
            return items;
        }).catch((err)=>{
            // clear promise on error
            const entry = $d9bdcf0f19bc293e$var$cache.get(mappedLocale);
            if (entry) entry.promise = null;
            setError(err);
            setLoading(false);
            throw err;
        });
        var _existingCache_data;
        // store the in-flight promise
        $d9bdcf0f19bc293e$var$cache.set(mappedLocale, {
            data: (_existingCache_data = existingCache === null || existingCache === void 0 ? void 0 : existingCache.data) !== null && _existingCache_data !== void 0 ? _existingCache_data : [],
            promise: fetchPromise
        });
    }, [
        locale,
        mappedLocale
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};

});
parcelRegister("1FkY0", function(module, exports) {

$parcel$export(module.exports, "WAC_TO_CPAPI_LOCALE_MAP", function () { return $968372e4295fabe6$export$9367d1c6d4e06c7e; });
$parcel$export(module.exports, "TEMPLATE_CATEGORY_OBJ", function () { return $968372e4295fabe6$export$8a30761f5ebaff2; });
$parcel$export(module.exports, "RECO_TEMPLATE_LOCAL_STORAGE_NAME", function () { return $968372e4295fabe6$export$68486ec0ba4ac32f; });

var $7Knp0 = parcelRequire("7Knp0");
const $968372e4295fabe6$var$isProductionEnvironment = true;
const $968372e4295fabe6$var$commonLocales = {
    br: "pt-BR",
    de: "de-DE",
    en: "en-US",
    es: "es",
    fr: "fr-FR",
    it: "it-IT",
    ja: "ja-JP",
    ko: "ko-KR",
    nl: "nl-NL",
    pl: "pl-PL",
    ru: "ru-RU",
    zh: "zh-CN"
};
const $968372e4295fabe6$var$nonProdLocales = {
    xx: "en-US",
    zz: "en-US"
};
const $968372e4295fabe6$export$9367d1c6d4e06c7e = $968372e4295fabe6$var$isProductionEnvironment ? $968372e4295fabe6$var$commonLocales : (0, $7Knp0._)({}, $968372e4295fabe6$var$commonLocales, $968372e4295fabe6$var$nonProdLocales);
const $968372e4295fabe6$export$8a30761f5ebaff2 = {
    id: "7ckISKU5UGRFKMEQyFf123",
    name: "Recommended for you",
    urlSlug: "recommended",
    shortDescriptionOneLiner: "Check out our personalized list of templates relevant to you and your team.",
    pageTitle: "Recommended templates for you",
    description: null,
    experiment: false
};
const $968372e4295fabe6$export$68486ec0ba4ac32f = "template_reco";

});






parcelRegister("61A0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $537cd27d87d2a568$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $5ZKRm = parcelRequire("5ZKRm");

var $dJVgs = parcelRequire("dJVgs");
const $537cd27d87d2a568$var$JiraSoftwareNavUniform = ()=>{
    const { template: template } = (0, $gPr7r.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $5ZKRm.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $iSvIT.useState)(false);
    const openModalForTemplateClickAction = (0, $iSvIT.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$537cd27d87d2a568$var$JiraSoftwareNavUniform.displayName = "JiraSoftwareNavUniform";
var $537cd27d87d2a568$export$2e2bcd8739ae039 = $537cd27d87d2a568$var$JiraSoftwareNavUniform;

});

parcelRegister("2ChcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5968950e65378e4$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $5ZKRm = parcelRequire("5ZKRm");

var $9g0oR = parcelRequire("9g0oR");
const $f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform = ()=>{
    const { template: template } = (0, $gPr7r.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $5ZKRm.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $iSvIT.useState)(false);
    const openModalForTemplateClickAction = (0, $iSvIT.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform.displayName = "JiraServiceManagementSoftwareNavV2Uniform";
var $f5968950e65378e4$export$2e2bcd8739ae039 = $f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform;

});

parcelRegister("68wZ4", function(module, exports) {

$parcel$export(module.exports, "LoomNav", function () { return $5635adddc28602a5$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $5635adddc28602a5$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $5ifyY = parcelRequire("5ifyY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $3XIdt = parcelRequire("3XIdt");

var $hbBKK = parcelRequire("hbBKK");

var $gAJUc = parcelRequire("gAJUc");

var $eyheK = parcelRequire("eyheK");

var $g0Zvb = parcelRequire("g0Zvb");
const $5635adddc28602a5$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $5635adddc28602a5$var$LoomLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "loomcircular",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ifyY.LoomAttributionLogo), {
        appearance: "brand"
    });
};
const $5635adddc28602a5$export$e9541932877c1f74 = ()=>{
    const intl = (0, $f6qj2.default)();
    const dropdownStyles = (0, $iSvIT.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            insetBlockStart: "4.25rem",
            transform: "translateX(-25%)"
        };
    }, []);
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium");
    const resourcesHref = (0, $3FBn4.useLocalizedHref)("/software/loom/resources");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/loom/pricing");
    const desktopLinks = [
        {
            globalLinksKey: "features",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: true,
            content: $5635adddc28602a5$var$wrapSubnav(/*#__PURE__*/ (0, $loA2J.jsx)((0, $eyheK.LoomFeaturesSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "solutions",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.resources",
                defaultMessage: "Solutions"
            }),
            hasSubnav: true,
            containerStyles: dropdownStyles,
            content: $5635adddc28602a5$var$wrapSubnav(/*#__PURE__*/ (0, $loA2J.jsx)((0, $g0Zvb.LoomSolutionsSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "resources",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.useCases",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            href: resourcesHref
        },
        {
            globalLinksKey: "pricing",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            href: pricingHref
        }
    ];
    const mobileLinks = [
        ...desktopLinks.map((link)=>({
                globalLinksKey: link.globalLinksKey,
                productKey: link.productKey,
                linkText: link.linkText,
                hasSubnav: link.hasSubnav,
                href: link.href,
                dropdownType: link.globalLinksKey
            }))
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productKey: "loom",
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($5635adddc28602a5$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "LoomPageTemplate.navbar.loom-logo",
            defaultMessage: "Loom logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($5635adddc28602a5$var$LoomLogoComponent, {}),
        productPageNavLinks: desktopLinks,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-loom",
                mobileLinksProps: mobileLinks
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: "features",
                menuPageObjects: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eyheK.LoomFeaturesSubnav), {})
            },
            {
                menuPageKey: "solutions",
                menuPageObjects: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g0Zvb.LoomSolutionsSubnav), {})
            }
        ]
    });
};
var $5635adddc28602a5$export$2e2bcd8739ae039 = $5635adddc28602a5$export$e9541932877c1f74;

});
parcelRegister("5ifyY", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogo", function () { return $3daab4b4ef34ab49$export$6e87ce8d41eda665; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $3daab4b4ef34ab49$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsForLoom)(appearance, colorMode);
    return '<svg\n		fill="none"\n		height="32"\n		xmlns="http://www.w3.org/2000/svg"\n		focusable="false"\n		aria-hidden="true"\n		viewBox="0 0 88 32"\n	>\n		<path\n			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"\n			fill="'.concat(colors.iconColor, '"\n		/>\n		<path\n			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"\n			fill="').concat(colors.textColor, '"\n		/>\n	</svg>');
};
var $3daab4b4ef34ab49$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom Attribution" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3daab4b4ef34ab49$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eyheK", function(module, exports) {

$parcel$export(module.exports, "LoomFeaturesSubnav", function () { return $e075e9345b3455b3$export$a7a6399eaf95e9b8; });
/* features-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $jGfor = parcelRequire("jGfor");
const $e075e9345b3455b3$export$a7a6399eaf95e9b8 = ()=>{
    const intl = (0, $f6qj2.default)();
    const productKey = "loom";
    const loomLinks = {
        features: {
            id: "features",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.loomFeatures.links.features",
                defaultMessage: "Explore Features"
            }),
            items: [
                {
                    id: "meeting-notes",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.meeting-notes",
                        defaultMessage: "Meeting Notes"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/ai-meeting")
                },
                {
                    id: "screen-recorder",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screen-recorder",
                        defaultMessage: "Screen Recorder"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/screen-recorder")
                },
                {
                    id: "screenshots",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screenshots",
                        defaultMessage: "Screenshots"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/screenshot")
                },
                {
                    id: "loom-ai",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.loom-ai",
                        defaultMessage: "Loom AI"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/ai")
                },
                {
                    id: "editing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.editing",
                        defaultMessage: "Editing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/editing")
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1p1dangw _syazmt5y _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_1ex89o1": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark0")),
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_bpsp1nn1 _19tboxwj _43dsmt5y _qfs11r31 _s41oglyw _1k6pnqa1 _1caymt5y _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_1ex89o1": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark0"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "globalNavSubnav",
                                        "data-product-key": productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("g0Zvb", function(module, exports) {

$parcel$export(module.exports, "LoomSolutionsSubnav", function () { return $1f685d7846ca643c$export$e7b21fd28cd3f276; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $3XIdt = parcelRequire("3XIdt");

var $baj2f = parcelRequire("baj2f");

var $jGfor = parcelRequire("jGfor");

var $hbBKK = parcelRequire("hbBKK");
function $1f685d7846ca643c$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: "teams",
            title: (0, $6x1qA.defineMessage)({
                id: "loom-product-nav.solutions.links.solution",
                defaultMessage: "Teams"
            }),
            items: [
                {
                    id: "sales",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.sales",
                        defaultMessage: "Sales"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/sales")
                },
                {
                    id: "marketing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/marketing")
                },
                {
                    id: "design",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.design",
                        defaultMessage: "Design"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/design")
                },
                {
                    id: "support",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.support",
                        defaultMessage: "Support"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/support")
                },
                {
                    id: "productmanagement",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.product-management",
                        defaultMessage: "Product Management"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/product-management")
                },
                {
                    id: "engineering",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.engineering",
                        defaultMessage: "Engineering"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/engineering")
                }
            ]
        },
        usecases: {
            id: "usecases",
            title: (0, $6x1qA.defineMessage)({
                id: "loom-product-nav.solutions.links.use-cases",
                defaultMessage: "Use cases"
            }),
            items: [
                {
                    id: "loom-jira",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-jira",
                        defaultMessage: "Loom + Jira"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/loom-jira")
                },
                {
                    id: "loom-confluence",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-confluence",
                        defaultMessage: "Loom + Confluence"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/loom-confluence")
                }
            ]
        },
        companysize: {
            id: "companysize",
            title: (0, $6x1qA.defineMessage)({
                id: "loom-product-nav.solutions.links.company-size",
                defaultMessage: "Company Size"
            }),
            items: [
                {
                    id: "enterprise",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/enterprise")
                }
            ]
        }
    };
}
const $1f685d7846ca643c$export$e7b21fd28cd3f276 = ({ productKey: productKey = "loom" })=>{
    const intl = (0, $f6qj2.default)();
    const loomSolutionLinks = $1f685d7846ca643c$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bfhkcd5j _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("g99nl", function(module, exports) {

$parcel$export(module.exports, "RovoNav", function () { return $5298b6428dc92303$export$f7b51e35c95f667c; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $bQiYD = parcelRequire("bQiYD");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $9g0oR = parcelRequire("9g0oR");

var $gAJUc = parcelRequire("gAJUc");

var $5wOn9 = parcelRequire("5wOn9");
const $5298b6428dc92303$export$f7b51e35c95f667c = ()=>{
    var _userSegments_UserSegmentTypes_OWNED_PRODUCTS;
    const intl = (0, $f6qj2.default)();
    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/features")
        },
        {
            globalLinksKey: "connectors",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.connectors",
                defaultMessage: "Connectors"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/connectors")
        },
        {
            globalLinksKey: "use-cases",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.use-cases",
                defaultMessage: "Use cases"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/use-cases")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            productKey: "rovo",
            containerPosition: "relative",
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
                orientation: "column",
                contentSections: [
                    {
                        links: [
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.ai-adoption-resources",
                                    defaultMessage: "AI adoption resources"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("http://community.atlassian.com/learning/hub/rovo")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.admin-onboarding",
                                    defaultMessage: "Admin onboarding"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/rovo/guides/admin-guide")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.end-user-onboarding",
                                    defaultMessage: "End-user onboarding"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/rovo/guides/end-user-guide")
                            }
                        ]
                    }
                ]
            })
        },
        {
            globalLinksKey: "licensing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.licensing",
                defaultMessage: "Licensing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/licensing/rovo")
        }
    ];
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $5wOn9.useLoggedInUser)();
    const isRovoCtasEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8011RovoProductTour);
    const { data: userSegments } = (0, $bQiYD.useUserSegments)();
    const isRovoInPlanList = userSegments === null || userSegments === void 0 ? void 0 : (_userSegments_UserSegmentTypes_OWNED_PRODUCTS = userSegments[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) === null || _userSegments_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _userSegments_UserSegmentTypes_OWNED_PRODUCTS.includes("rovo.ondemand");
    const defaultCTAUrl = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium");
    const isUserLoggedInAndCtasEnabledAndInPlan = isUserLoggedIn && isRovoCtasEnabled && isRovoInPlanList;
    const ctaText = isUserLoggedInAndCtasEnabledAndInPlan ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.try-rovo",
        defaultMessage: "Try Rovo"
    }) : isRovoCtasEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.get-rovo",
        defaultMessage: "Get Rovo"
    }) : undefined;
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? "https://home.atlassian.com/chat" : isRovoCtasEnabled ? defaultCTAUrl : undefined;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            productLogoAriaLabel: intl.formatMessage({
                id: "RovoPageTemplate.navbar.rovo-logo",
                defaultMessage: "Rovo logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-rovo",
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});
parcelRegister("bQiYD", function(module, exports) {

$parcel$export(module.exports, "UserSegmentTypes", function () { return $76f753b0c86d9e93$export$a8dc2296828ba3fa; });
$parcel$export(module.exports, "useUserSegments", function () { return $76f753b0c86d9e93$export$cb9d3ee4b5fdaafe; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $aO3Hl = parcelRequire("aO3Hl");

var $5KXGt = parcelRequire("5KXGt");

var $9Cnr8 = parcelRequire("9Cnr8");

var $j27rt = parcelRequire("j27rt");

var $XAEGR = parcelRequire("XAEGR");
var $76f753b0c86d9e93$export$a8dc2296828ba3fa;
(function(UserSegmentTypes) {
    UserSegmentTypes["LOGIN_STATUS"] = "login-status";
    UserSegmentTypes["GEOLOCATION"] = "geolocation";
    UserSegmentTypes["JOB_FUNCTION"] = "job-function";
    UserSegmentTypes["DOMAIN_TYPE"] = "domain-type";
    UserSegmentTypes["OWNED_PRODUCTS"] = "owned-products";
    UserSegmentTypes["CLUSTER_TAG"] = "cluster-tag";
})($76f753b0c86d9e93$export$a8dc2296828ba3fa || ($76f753b0c86d9e93$export$a8dc2296828ba3fa = {}));
const $76f753b0c86d9e93$export$cb9d3ee4b5fdaafe = ()=>{
    var _profile_userProfile, _profile_userProfile1;
    const [status, setStatus] = (0, $iSvIT.useState)("idle");
    const [profile, setProfile] = (0, $iSvIT.useState)();
    const [profileError, setProfileError] = (0, $iSvIT.useState)(null);
    const loggedInUser = (0, $5KXGt.useLoggedInUser)();
    const { personalizationValues: personalizationValues } = (0, $j27rt.useWAEContext)();
    // Memoize the client to prevent recreation on every render
    const { getFullProfileCallback: getFullProfileCallback } = (0, $aO3Hl.useGupsStatus)();
    const envSource = typeof window !== "undefined" ? window : $XAEGR.env;
    const { countryCode: countryCode, status: locationStatus } = (0, $9Cnr8.useGeoLocation)(envSource["PRODUCT_CATALOG_LOCATION_BASE_URL"]);
    (0, $iSvIT.useEffect)(()=>{
        const getFullProfile = async ()=>{
            setStatus("fetching");
            const { data: data, error: error } = await getFullProfileCallback();
            setProfileError(error);
            setProfile(data);
            setStatus("complete");
        };
        getFullProfile();
    }, [
        getFullProfileCallback
    ]);
    // Memoize the personalization values to prevent unnecessary recalculations
    return (0, $iSvIT.useMemo)(()=>{
        var _profile_sites, _profile_userProfile, _profile_userProfile1;
        const products = [
            // de-duplicate product names
            ...new Set(profile === null || profile === void 0 ? void 0 : (_profile_sites = profile.sites) === null || _profile_sites === void 0 ? void 0 : _profile_sites.flatMap((site)=>{
                var _site_products;
                return (_site_products = site.products) === null || _site_products === void 0 ? void 0 : _site_products.map((product)=>product.productName || product.productKey);
            }))
        ].filter(Boolean);
        const personalizationFacetValue = (0, $6iHNw._)((0, $7Knp0._)({}, personalizationValues), {
            ["login-status"]: loggedInUser.isUserLoggedIn ? "loggedIn" : "loggedOut",
            ["geolocation"]: locationStatus === "complete" ? countryCode : undefined,
            ["job-function"]: profile === null || profile === void 0 ? void 0 : (_profile_userProfile = profile.userProfile) === null || _profile_userProfile === void 0 ? void 0 : _profile_userProfile.jobFunction,
            ["domain-type"]: profile === null || profile === void 0 ? void 0 : (_profile_userProfile1 = profile.userProfile) === null || _profile_userProfile1 === void 0 ? void 0 : _profile_userProfile1.domainType,
            ["owned-products"]: products
        });
        return {
            data: personalizationFacetValue,
            error: profileError,
            status: status
        };
    }, [
        loggedInUser.isUserLoggedIn,
        profile === null || profile === void 0 ? void 0 : profile.sites,
        profile === null || profile === void 0 ? void 0 : (_profile_userProfile = profile.userProfile) === null || _profile_userProfile === void 0 ? void 0 : _profile_userProfile.domainType,
        profile === null || profile === void 0 ? void 0 : (_profile_userProfile1 = profile.userProfile) === null || _profile_userProfile1 === void 0 ? void 0 : _profile_userProfile1.jobFunction,
        profileError,
        countryCode,
        status,
        locationStatus,
        personalizationValues
    ]);
};

});
parcelRegister("9Cnr8", function(module, exports) {

$parcel$export(module.exports, "COUNTRY_CODE_TO_CURRENCY", function () { return $ead8b56b1848df3d$export$5eecc1bf68a424bd; });
$parcel$export(module.exports, "getCurrencyFromUserLocale", function () { return $ead8b56b1848df3d$export$d308c60568c90469; });
$parcel$export(module.exports, "useGeoLocation", function () { return $ead8b56b1848df3d$export$f0ecc6cfe1a5d26a; });

var $iSvIT = parcelRequire("iSvIT");

var $56xle = parcelRequire("56xle");
const $ead8b56b1848df3d$export$7baaffefa21dec1 = "US";
const $ead8b56b1848df3d$export$496c65882823a55b = "bxp.currentLocale";
const $ead8b56b1848df3d$export$5eecc1bf68a424bd = {
    US: "USD",
    JP: "JPY",
    ja: "JPY"
};
const $ead8b56b1848df3d$export$d308c60568c90469 = (userLocale)=>{
    var _COUNTRY_CODE_TO_CURRENCY_userLocale;
    // @ts-ignore
    return (_COUNTRY_CODE_TO_CURRENCY_userLocale = $ead8b56b1848df3d$export$5eecc1bf68a424bd[userLocale]) !== null && _COUNTRY_CODE_TO_CURRENCY_userLocale !== void 0 ? _COUNTRY_CODE_TO_CURRENCY_userLocale : $ead8b56b1848df3d$export$5eecc1bf68a424bd[$ead8b56b1848df3d$export$7baaffefa21dec1];
};
async function $ead8b56b1848df3d$export$f5c42400285872e7(baseUrl, request) {
    if (typeof window === "undefined") {
        const headers = {};
        //@ts-ignore
        const awsRegion = globalThis.ssrContext.awsRegion;
        // S2S calls only work if the downstream service exists in the same region that our tesseract runtime is in
        const downStreamServiceExistsInSameTesseractRuntimeRegion = (0, $56xle.BxpExpressServiceSupportedRegions).has(awsRegion);
        if (!downStreamServiceExistsInSameTesseractRuntimeRegion) {
            console.log("Downstream service does not exist in the same region as current tesseract region. Current tesseract region: " + awsRegion);
            const fallbackLocale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
            return {
                countryIsoCode: fallbackLocale,
                regionIsoCode: ""
            };
        }
        headers["x-ssr-service-name"] = "bxp-express";
        //@ts-ignore
        const environmentType = globalThis.ssrContext.environmentType;
        if (environmentType === "dev") {
            // bxp-express service does not have any dev instances so when we're in dev, point to staging
            headers["x-ssr-service-env"] = "staging";
            headers["x-ssr-service-region"] = "us-east-1"; // Bxp-express service in staging only lives in us-east-1 or us-west-2
        }
        //@ts-ignore
        headers["X-Forwarded-For"] = request === null || request === void 0 ? void 0 : request.headers["x-forwarded-for"];
        return await fetch(`/location`, {
            headers: headers
        }).then((response)=>{
            return response.json();
        }).then((json)=>{
            return {
                countryIsoCode: json.countryIsoCode || $ead8b56b1848df3d$export$7baaffefa21dec1,
                regionIsoCode: json.regionIsoCode || ""
            };
        }).catch(async ()=>{
            // If there's an error with s2s call - fall back to original fetchUserLocale
            const fallbackLocale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
            return {
                countryIsoCode: fallbackLocale,
                regionIsoCode: ""
            };
        });
    } else {
        const fallbackLocale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
        return {
            countryIsoCode: fallbackLocale,
            regionIsoCode: ""
        };
    }
}
async function $ead8b56b1848df3d$export$b6ae37355b3e5433(baseUrl, request) {
    let localeFromStorage;
    if (typeof window !== "undefined") localeFromStorage = sessionStorage.getItem($ead8b56b1848df3d$export$496c65882823a55b);
    if (localeFromStorage) return Promise.resolve(localeFromStorage);
    const locationData = await $ead8b56b1848df3d$export$f5c42400285872e7(baseUrl, request);
    return locationData.countryIsoCode;
}
async function $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl) {
    let localeFromStorage;
    if (typeof window !== "undefined") localeFromStorage = sessionStorage.getItem($ead8b56b1848df3d$export$496c65882823a55b);
    if (localeFromStorage) return Promise.resolve(localeFromStorage);
    const locationData = await $ead8b56b1848df3d$export$284826310e51ae98(baseUrl);
    return locationData.countryIsoCode;
}
async function $ead8b56b1848df3d$export$284826310e51ae98(baseUrl) {
    return await fetch(`${baseUrl}/location`).then((response)=>{
        return response.json();
    }).then((json)=>{
        return {
            countryIsoCode: json.countryIsoCode || $ead8b56b1848df3d$export$7baaffefa21dec1,
            regionIsoCode: json.regionIsoCode || ""
        };
    }).catch(()=>{
        return {
            countryIsoCode: $ead8b56b1848df3d$export$7baaffefa21dec1,
            regionIsoCode: ""
        };
    });
}
function $ead8b56b1848df3d$export$f0ecc6cfe1a5d26a(baseUrl) {
    const [status, setStatus] = (0, $iSvIT.useState)("idle");
    const [countryCode, setCountryCode] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const locale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
            setStatus("complete");
            setCountryCode(locale);
        };
        fetchData();
    }, []);
    return {
        status: status,
        countryCode: countryCode
    };
}

});



parcelRegister("gygyq", function(module, exports) {

$parcel$export(module.exports, "RovoDevNav", function () { return $585a7ff05ee5573e$export$446da800ffd5a425; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $cP0Yq = parcelRequire("cP0Yq");
const $585a7ff05ee5573e$export$446da800ffd5a425 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=devai");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/rovo-dev/pricing");
    const documentationHref = (0, $3FBn4.useLocalizedHref)("https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents");
    const logo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg",
            alt: "Rovo Dev"
        },
        style: {
            height: "26px"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: "/software/rovo-dev",
        productLogo: logo,
        productLogoAriaLabel: intl.formatMessage({
            id: "RovoDevNav.productLogoAriaLabel",
            defaultMessage: "Rovo Dev logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: logo,
        productPageNavLinks: [
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: pricingHref
            },
            {
                globalLinksKey: "documentation",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.documentation",
                    defaultMessage: "Documentation"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: documentationHref
            }
        ],
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-rovo-dev",
                mobileLinksProps: [
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: pricingHref
                    },
                    {
                        globalLinksKey: "documentation",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.documentation",
                            defaultMessage: "Documentation"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: documentationHref
                    }
                ]
            }
        ]
    });
};

});

parcelRegister("52gYK", function(module, exports) {

$parcel$export(module.exports, "OptionalSiteSelectorContextProvider", function () { return $f7786a656b77b76d$export$ef73016e54e00d81; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("gkV6l");
var $5ZKRm = parcelRequire("5ZKRm");
const $f7786a656b77b76d$export$ef73016e54e00d81 = (props)=>{
    const { siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, children: children } = props;
    if (!siteSelectorProductKey) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZKRm.SiteSelectorContextProvider), {
        productKey: siteSelectorProductKey,
        analyticsPrefix: siteSelectorAnalyticsPrefix !== null && siteSelectorAnalyticsPrefix !== void 0 ? siteSelectorAnalyticsPrefix : siteSelectorProductKey,
        children: children
    });
};

});




//# sourceMappingURL=page.6302205e.js.map
